import { LOCATIONS } from "./serviceAreas";

export const CITIES = [...LOCATIONS.filter((l) => !l.parent).map((l) => l.name), "Erftstadt"];

export const CITIES_LINE_SUFFIX = {
  ua: "та околиці",
  de: "& Umgebung",
  en: "& surrounding area",
};

export const CONTACT_INFO = {
  whatsappRaw: "4917622038169",
  whatsappDisplay: "+49 176 22038169",
  phoneE164: "+4917622038169",
  whatsappLabel: "PUREGLOSS",
  email: "info@puregloss.eu",
  instagram: "@puregloss.eu",
  instagramUrl: "https://instagram.com/puregloss.eu",
  telegram: "@pureglosseu",
  telegramUrl: "https://t.me/pureglosseu",
};

export const BRAND_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_puregloss-detail/artifacts/ufcotznt_ChatGPT%20Image%2011%20%D1%87%D0%B5%D1%80%D0%B2.%202026%20%D1%80.%2C%2003_00_31.png";

export const buildWhatsAppLink = (message = "") => {
  const text = encodeURIComponent(message);
  return `https://wa.me/${CONTACT_INFO.whatsappRaw}${text ? `?text=${text}` : ""}`;
};

export const translations = {
  ua: {
    seo: {
      title: "PUREGLOSS — Mobile Auto Detailing & Polsterreinigung Euskirchen",
      description:
        "Мобільний детейлінг авто та хімчистка диванів з виїздом. Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen та околиці. Безкоштовна оцінка протягом 1 години.",
      keywords:
        "Auto Detailing Euskirchen, Mobile Detailing Euskirchen, Autoaufbereitung Euskirchen, Sofa Cleaning Euskirchen, Polsterreinigung Euskirchen, хімчистка диванів, детейлінг авто",
    },
    nav: {
      home: "Головна",
      services: "Послуги",
      beforeAfter: "До і Після",
      reviews: "Відгуки",
      prices: "Ціни",
      serviceArea: "Зона обслуговування",
      promotions: "Акції",
      faq: "Питання",
      contact: "Контакти",
      academy: "Академія",
      works: "Наші роботи",
      club: "PUREGLOSS CLUB",
      cta: "WhatsApp",
    },
    cta: {
      getPrice: "Дізнатись ціну",
      getPriceShort: "Ціна",
      bookAppointment: "Забронювати термін",
      bookAppointmentShort: "Термін",
      checkAvailability: "Перевірити доступність у вашому місті",
      joinWaitingList: "Долучитись до списку",
      whatsapp: "WhatsApp",
      readyTitle: "Готові розпочати?",
      readyDesc: "Швидко отримайте ціну або заброньте слот.",
    },
    promotions: {
      eyebrow: "Акції та пропозиції",
      title: "Акції та спеціальні пропозиції",
      desc: "Першими дізнавайтесь про сезонні знижки, пакети та преміум-пропозиції PUREGLOSS.",
      nameLabel: "Ім'я (не обов'язково)",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      cta: "Підписатися",
      gdpr: "Я погоджуюсь отримувати маркетингові повідомлення відповідно до",
      successTitle: "Дякуємо!",
      successMessage: "Вас додано до списку пропозицій PUREGLOSS.",
      error: "Не вдалось підписатись. Спробуйте ще раз.",
    },
    ctaBlocks: {
      services: { title: "Готові розпочати?", desc: "Дізнайтесь ціну або заброньте слот.", primary: "Дізнатись ціну", secondary: "Забронювати термін" },
      pricing: { title: "Обрали пакет?", desc: "Заброньте термін або отримайте точну ціну.", primary: "Дізнатись ціну", secondary: "Забронювати термін" },
      serviceArea: { title: "Ми приїдемо до вас", desc: "Перевірте доступність у вашому місті.", primary: "Перевірити доступність", secondary: "Забронювати термін" },
      academy: { title: "PUREGLOSS Академія", desc: "Опануйте мобільний детейлінг у Німеччині. Запис відкриваємо найближчим часом.", primary: "Долучитись до списку" },
    },
    serviceAreaMap: {
      title: "Зона обслуговування",
      desc: "Мобільний сервіс у Euskirchen, Köln, Bonn та сусідніх містах.",
      mobileTag: "Мобільний сервіс — приїдемо до вас",
      cityAvailability: "Мобільний сервіс у вашому місті",
    },
    trustBadge: "Безкоштовна оцінка вартості протягом 1 години",
    floatingEstimate: "Безкоштовна оцінка через заявку",
    basedIn: "Базуємось в Euskirchen",
    whatsappConsent: {
      eyebrow: "Захист даних",
      title: "Ви переходите до WhatsApp",
      body: "При натисканні кнопки Ваш номер телефону та повідомлення передаються до WhatsApp Ireland Ltd. (Meta). Частина обробки відбувається за межами ЄС (США).",
      details: "Правова підстава: ст. 6 (1) (a) GDPR (згода). Деталі —",
      datenschutzLink: "Політика конфіденційності",
      confirm: "Продовжити до WhatsApp",
      cancel: "Скасувати",
      close: "Закрити",
    },
    fullAreaText:
      "Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen та околиці",
    hero: {
      eyebrow: "Mobile Detailing • Euskirchen",
      title: "PUREGLOSS",
      subtitle: "Detailing & Sofa Cleaning",
      desc: "Мобільний детейлінг авто та хімчистка диванів з виїздом до клієнта.",
      ctaPrimary: "Отримати ціну",
      ctaSecondary: "Написати в WhatsApp",
      scroll: "Прокрутити",
    },
    area: {
      label: "Зона обслуговування",
      suffix: "та околиці",
    },
    services: {
      eyebrow: "Послуги",
      title: "Преміум догляд за вашим авто та меблями",
      desc: "Професійний сервіс з виїздом — все, що потрібно, щоб ваші речі знову виглядали бездоганно.",
      vehicleTitle: "Детейлінг авто",
      vehicleItems: [
        "Хімчистка салону",
        "Чистка сидінь",
        "Догляд за шкірою",
        "Видалення запахів",
        "Ручне миття",
        "Чистка дисків",
        "Догляд за шинами",
        "Підготовка авто до продажу",
      ],
      sofaTitle: "Sofa & Upholstery Cleaning",
      sofaItems: [
        "Дивани",
        "Крісла",
        "Матраци",
        "М’які меблі",
        "Видалення плям",
        "Видалення запахів",
        "Глибока чистка",
        "Чистка килимів",
      ],
    },
    pricing: {
      eyebrow: "Прайс",
      title: "Прозорі ціни",
      auto: "Авто",
      polishing: "Паста та полірування",
      furniture: "Меблі",
      from: "від",
      items: {
        auto: [
          { name: "Innenreinigung", price: "49€" },
          { name: "Außenreinigung", price: "39€" },
          { name: "Komplettpaket", price: "89€" },
          { name: "Verkaufsaufbereitung", price: "119€" },
        ],
        furniture: [
          { name: "Sessel", price: "25€" },
          { name: "2-Sitzer Sofa", price: "49€" },
          { name: "3-Sitzer Sofa", price: "69€" },
          { name: "Ecksofa", price: "99€" },
          { name: "Matratze", price: "39€" },
        ],
      },
      note: "Точна ціна залежить від стану авто або меблів. Надішліть фото для безкоштовної оцінки.",
      lockedBadge: "ДУЖЕ СКОРО",
      lockedTitle: "Поліровка та корекція ЛФП",
      lockedDesc:
        "Професійна поліровка кузова та корекція лакофарбового покриття наразі недоступні, але скоро з'являться.",
      lockedDisabled: "Бронювання тимчасово недоступне",
      ctaGetEstimate: "Отримати оцінку",
      lockedItems: [
        { name: "Одноступенева поліровка", price: "149€" },
        { name: "Двоступенева поліровка", price: "249€" },
        { name: "Триступенева поліровка", price: "349€" },
      ],
    },
    stats: [
      { value: "100%", label: "Виїзний сервіс" },
      { value: "PRO", label: "Преміум засоби" },
      { value: "24/7", label: "Гнучкий графік" },
      { value: "★★★★★", label: "Професійний результат" },
    ],
    beforeAfter: {
      eyebrow: "Результати",
      title: "До і після",
      desc: "Перетягніть слайдер, щоб побачити різницю.",
      categories: { cars: "Авто", sofas: "Дивани" },
      beforeLabel: "До",
      afterLabel: "Після",
    },
    instaProof: {
      eyebrow: "Портфоліо",
      title: "Наші реальні роботи",
      desc: "Перегляньте реальні результати PUREGLOSS: авто, дивани, матраци та інші роботи до / після.",
      stats: ["Реальні клієнти", "Фото до / після", "Нові роботи щотижня"],
      cta: "Переглянути всі роботи",
      handle: "@puregloss.eu",
    },
    serviceLabels: {
      Innenraum: "Інтер'єр",
      "Außenreinigung": "Екстер'єр",
      Sitzreinigung: "Хімчистка сидінь",
      Lederpflege: "Захист шкіри",
      Felgenreinigung: "Чистка дисків",
      Politur: "Полірування",
      Scheinwerfer: "Фари",
    },
    furnitureServiceLabels: {
      Sofa: "Диван",
      Matratze: "Матрац",
      Sessel: "Крісло",
      "Stühle": "Стільці",
      Bürostuhl: "Офісне крісло",
      Teppich: "Килим",
      Polster: "М'які меблі",
    },
    brandLabels: {
      Audi: "Audi", BMW: "BMW", "Mercedes-Benz": "Mercedes-Benz",
      Porsche: "Porsche", Volkswagen: "Volkswagen", Tesla: "Tesla",
      Skoda: "Skoda", Ford: "Ford", Opel: "Opel", Toyota: "Toyota",
      Hyundai: "Hyundai", Other: "Інше",
    },
    furnitureTypeLabels: {
      "2-Sitzer Sofa": "2-місний диван",
      "3-Sitzer Sofa": "3-місний диван",
      Ecksofa: "Кутовий диван",
      Matratze: "Матрац",
      Sessel: "Крісло",
      Stuhl: "Стілець",
      Bürostuhl: "Офісне крісло",
      Teppich: "Килим",
      Other: "Інше",
    },
    works: {
      heroTitle: "Наші роботи PUREGLOSS",
      heroSubtitle: "Реальні результати чистки авто, диванів, матраців та меблів.",
      empty: "Роботи скоро будуть додані.",
      filterAll: "Всі",
      filterCategory: "Категорія",
      filterService: "Послуга",
      filterBrand: "Марка",
      filterType: "Тип меблів",
      catVehicle: "Авто",
      catFurniture: "Меблі",
      viewBtn: "Переглянути",
      getPriceCta: "Дізнатись ціну",
      beforeLabel: "До",
      afterLabel: "Після",
      cityLabel: "Місто",
      serviceLabel: "Послуга",
      brandLabel: "Марка",
      modelLabel: "Модель",
      typeLabel: "Тип",
      descriptionLabel: "Опис",
      sliderHint: "Перетягніть, щоб порівняти",
      beforeGallery: "Фото до",
      afterGallery: "Фото після",
      close: "Закрити",
      photoSoon: "Фото скоро буде додано",
      getSameServiceCta: "Отримати таку ж чистку",
      likeResultTitle: "Сподобався результат?",
      likeResultDesc: "Ми можемо зробити такий самий результат і для вашого автомобіля або меблів.",
      ctaFreeQuote: "Отримати безкоштовну оцінку",
      ctaBookSlot: "Забронювати термін",
    },
    club: {
      title: "Ласкаво просимо в PUREGLOSS CLUB",
      subtitle: "Отримайте ексклюзивні переваги та станьте членом клубу безкоштовно.",
      benefit1: "🎁 Вітальний ваучер 25 € від 100 € вартості замовлення",
      benefit2: "⚡ Ранній доступ до акцій і пропозицій",
      benefit3: "👑 Ексклюзивні переваги для учасників PUREGLOSS CLUB",
      benefit4: "",
      nameLabel: "Ім'я (необов'язково)",
      emailLabel: "Email",
      gdpr: "Я погоджуюсь з обробкою моїх даних відповідно до Політики конфіденційності.",
      joinCta: "Стати учасником безкоштовно",
      joining: "Обробка...",
      finePrint: "Ваучер дійсний 6 місяців, використовується один раз. Мінімальна сума замовлення 100 €.",
      close: "Закрити",
      alreadyRegistered: "Ця електронна адреса вже зареєстрована в PUREGLOSS CLUB.",
      genericError: "Не вдалося приєднатися. Спробуйте ще раз.",
      emailInvalid: "Введіть коректний email",
      gdprRequired: "Прийміть Політику конфіденційності",
      successTitle: "Ласкаво просимо в PUREGLOSS CLUB!",
      successMessage: "Ваш вітальний ваучер на 25 € активовано. Він діє для будь-якої послуги PUREGLOSS від 100 € вартості замовлення.",
      successCta: "Запит на безкоштовну оцінку",
    },
    clubAdmin: {
      tab: "PUREGLOSS CLUB",
      empty: "Ще немає учасників клубу.",
      filterAll: "Всі",
      filterActive: "Активні",
      filterUsed: "Використано",
      filterExpired: "Прострочено",
      filterEmailNotSent: "Email не надіслано",
      filterEmailSent: "Email надіслано",
      searchPlaceholder: "Пошук по імені, email або коду ваучера",
      newMemberBtn: "Новий учасник",
      newMemberTitle: "Створити учасника клубу",
      sendWelcomeCheckbox: "Надіслати Welcome Email одразу",
      createBtn: "Створити",
      redeemBtn: "Використати ваучер",
      redeemTitle: "Використати ваучер?",
      redeemDesc: "Статус зміниться на «Використано» та буде записана дата.",
      redeemConfirm: "Використати",
      redeemed: "Ваучер використано.",
      regenerateBtn: "Створити PDF заново",
      regenerated: "PDF-ваучер створено заново.",
      emptySearch: "Немає результатів для вашого пошуку.",
      colName: "Ім'я",
      colEmail: "Email",
      colJoined: "Дата вступу",
      colBonusStart: "Початок бонусу",
      colBonusEnd: "Кінець бонусу",
      colBonus: "Welcome Bonus",
      colCondition: "Умова",
      colSecond: "2-га чистка",
      colVoucherCode: "Код ваучера",
      colStatus: "Статус",
      colEmailStatus: "Email",
      statusActive: "активний",
      statusUsed: "використано",
      statusExpired: "прострочено",
      emailNotSent: "не надіслано",
      emailSent: "надіслано",
      emailFailed: "помилка",
      markUsed: "Позначити як використано",
      markActive: "Позначити як активний",
      markExpired: "Позначити як прострочено",
      editBtn: "Редагувати",
      deleteBtn: "Видалити",
      sendWelcome: "Надіслати Welcome Email",
      deleteTitle: "Видалити учасника клубу?",
      deleteDesc: "Ви впевнені, що хочете видалити цього учасника клубу?",
      deleteConfirm: "Видалити",
      cancel: "Скасувати",
      resendNotConnected: "Відправка email буде підключена на наступному етапі через Resend.",
      emailSentToast: "Welcome email успішно надіслано.",
      emailFailedToast: "Помилка надсилання email",
      updated: "Учасника оновлено.",
      deleted: "Учасника видалено.",
      actionFailed: "Не вдалося виконати дію.",
      editTitle: "Редагувати учасника",
      notesLabel: "Нотатки",
      saveBtn: "Зберегти",
    },
    worksAdmin: {
      tab: "Роботи",
      addBtn: "Додати роботу",
      editBtn: "Редагувати",
      deleteBtn: "Видалити",
      publish: "Опубліковано",
      draft: "Чернетка",
      statusLabel: "Статус",
      createTitle: "Нова робота",
      editTitle: "Редагування роботи",
      titleField: "Заголовок",
      titlePlaceholder: "напр. BMW M3 — Комплексна чистка салону",
      categoryField: "Категорія",
      serviceField: "Послуга",
      brandField: "Марка авто",
      modelField: "Модель",
      furnitureTypeField: "Тип меблів",
      cityField: "Місто",
      descriptionField: "Короткий опис",
      beforePhotos: "Фото до (до 5)",
      afterPhotos: "Фото після (до 5)",
      uploadBtn: "Завантажити фото",
      selectPlaceholder: "— Оберіть —",
      cancel: "Скасувати",
      save: "Зберегти",
      empty: "Немає робіт. Натисніть «Додати роботу», щоб створити першу.",
      deleteTitle: "Видалити роботу?",
      deleteDesc: "Ви точно хочете видалити цю роботу? Цю дію неможливо скасувати.",
      workCreated: "Роботу створено.",
      workUpdated: "Роботу оновлено.",
      workDeleted: "Роботу видалено.",
      actionFailed: "Не вдалося виконати дію.",
      maxPhotos: "Максимум 5 фото.",
      requiredCategory: "Оберіть категорію",
      uploadFailed: "Не вдалося завантажити фото: ",
      unsupportedFile: "Непідтримуваний файл: ",
      supportedFormats: "Дозволено: JPG, PNG, WEBP",
      uploadingProgress: "Завантаження {done}/{total}...",
    },
    reviews: {
      eyebrow: "Відгуки",
      title: "Що кажуть клієнти",
      items: [
        { text: "Після підготовки авто до продажу машина виглядала значно краще і продалась швидше.", author: "Andreas K.", city: "Köln" },
        { text: "Диван хотіли викидати, але після чистки він знову виглядає свіжо.", author: "Marina S.", city: "Bonn" },
        { text: "Дуже зручно, що сервіс приїжджає додому. Все зроблено акуратно.", author: "Thomas L.", city: "Euskirchen" },
        { text: "Чесна ціна, гарний результат і професійний підхід.", author: "Olena P.", city: "Brühl" },
        { text: "Рекомендую PUREGLOSS. Буду звертатись ще.", author: "Markus B.", city: "Hürth" },
      ],
    },
    howItWorks: {
      eyebrow: "Як це працює",
      title: "Простий процес",
      steps: [
        "Надсилаєте фото",
        "Отримуєте приблизну ціну",
        "Обираємо зручний термін",
        "Ми приїжджаємо до вас",
        "Ви отримуєте чистий результат",
      ],
    },
    newsletter: {
      eyebrow: "Розсилка",
      title: "Не пропустіть акції та спеціальні пропозиції",
      placeholder: "your@email.com",
      cta: "Підписатися",
      thanks: "Дякуємо за підписку!",
      gdpr: "Я даю згоду на обробку моїх даних відповідно до Політики конфіденційності.",
      error: "Не вдалося підписатися. Спробуйте ще раз.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Часті питання",
      items: [
        { q: "Скільки коштує чистка авто?", a: "Ціна починається від 39€ за зовнішнє миття та 49€ за хімчистку салону. Повний пакет — від 89€. Точна вартість залежить від стану авто." },
        { q: "Скільки часу займає хімчистка?", a: "Зазвичай від 2 до 5 годин. Все залежить від рівня забруднення та обраного пакету." },
        { q: "Чи потрібно кудись їхати?", a: "Ні. Ми мобільний сервіс і приїжджаємо до вас додому або в офіс — все обладнання у нас з собою." },
        { q: "Чи чистите дивани, матраци та килими?", a: "Так. Ми чистимо дивани, крісла, матраци, кутові дивани, килими та інші м'які меблі." },
        { q: "Чи можна почистити лише сидіння?", a: "Так. Ми робимо часткову хімчистку — наприклад, лише передні сидіння або багажник." },
        { q: "Чи прибираєте запахи?", a: "Так. Ми використовуємо професійні засоби для видалення запахів — тютюну, домашніх тварин, харчових." },
        { q: "Які райони обслуговуєте?", a: "Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen та околиці. Виїзд далі — за домовленістю." },
        { q: "Як забронювати послугу?", a: "Заповніть форму на сайті або напишіть нам у WhatsApp. Ми погодимо зручний час протягом години." },
        { q: "Як отримати точну ціну?", a: "Надішліть нам кілька фото авто або меблів у WhatsApp — ми відповімо протягом години. Оцінка безкоштовна." },
        { q: "Які способи оплати доступні?", a: "Готівка, банківський переказ або PayPal — на ваш вибір. Оплата після виконання роботи." },
      ],
    },
    quote: {
      eyebrow: "Запит ціни",
      title: "Отримайте безкоштовну оцінку",
      desc: "Заповніть форму — ми відкриємо WhatsApp із вашим повідомленням. Відповідь протягом 1 години.",
      name: "Ім'я",
      phone: "Телефон",
      city: "Місто",
      cityPlaceholder: "—",
      serviceType: "Тип послуги",
      message: "Повідомлення",
      photos: "Фото (опціонально)",
      photosHint: "Додайте фото — після натискання кнопки відкриється WhatsApp, де ви зможете прикріпити їх",
      submit: "Дізнатись ціну",
      successHint: "Зараз відкриється WhatsApp",
      serviceOptions: [
        "Хімчистка салону",
        "Зовнішня мийка",
        "Повний детейлінг",
        "Чистка дивану",
        "Чистка матрацу",
        "Чистка килима",
      ],
      cityOther: "Інше / околиці",
      uploading: "Завантаження...",
      emailLabel: "Email",
      preferredContactLabel: "Зручний спосіб зв'язку",
      preferredContactPlaceholder: "Оберіть спосіб",
      preferredContactRequired: "Оберіть зручний спосіб зв'язку",
      preferredContactOptions: ["WhatsApp", "Telegram", "Email", "Telefon"],
      gdpr: "Я погоджуюсь з обробкою моїх даних відповідно до Політики конфіденційності.",
      submitError: "Не вдалося надіслати запит. Спробуйте ще раз.",
      successTitle: "Дякуємо за ваш запит!",
      successMessage: "Вашу заявку успішно отримано та передано в обробку. Ми зв'яжемося з вами найближчим часом через обраний спосіб зв'язку.",
      successPhone: "+49 176 22038169",
      successOpenWhatsApp: "Відкрити WhatsApp",
      successClose: "Закрити",
    },
    booking: {
      flowGetPrice: "Дізнатись ціну",
      flowBook: "Забронювати термін",
      address: "Адреса",
      itemDetails: "Авто або деталі дивану",
      preferredDate: "Бажана дата",
      preferredTime: "Бажаний час",
      pickDate: "Оберіть дату",
      pickTime: "Оберіть час",
      booked: "Заброньовано",
      blocked: "Недоступно",
      tooSoon: "Бронювання доступне мінімум за 8 днів",
      submit: "Забронювати",
      successTitle: "Дякуємо. Запит на термін отримано",
      successMessage: "Ми підтвердимо дату через WhatsApp протягом 24 годин.",
      noSlot: "Немає вільних слотів цього дня",
      previousMonth: "Попередній місяць",
      nextMonth: "Наступний місяць",
      legend: {
        available: "Доступно",
        booked: "Заброньовано",
        unavailable: "Недоступно",
      },
    },
    student: {
      loginButton: "Вхід для учнів",
      loginTitle: "Вхід для учнів",
      loginSubtitle: "Доступ до PUREGLOSS Academy.",
      email: "Email",
      password: "Пароль",
      signIn: "Увійти",
      signingIn: "Входимо...",
      invalidCredentials: "Невірний email або пароль",
      accountPaused: "Доступ призупинений. Зверніться до PUREGLOSS Academy.",
      backToAcademy: "Назад до Академії",
      logout: "Вийти",
      dashboard: {
        welcome: "Вітаємо",
        package: "Пакет",
        startDate: "Дата старту",
        progress: "Прогрес",
        status: "Статус",
        completedOf: "виконано з",
        modulesTitle: "Модулі курсу",
        locked: "Заблоковано",
        unlock: "Доступно у пакеті",
        startLesson: "Розпочати",
        markCompleted: "Позначити виконаним",
        markIncomplete: "Скасувати позначення",
        completed: "Виконано",
        certificateTitle: "Сертифікація",
        certificateDesc: "Ваш сертифікат буде доступний після успішного завершення фінального оцінювання.",
        certificatePending: "Сертифікат буде доступний після завершення курсу",
      },
      statusLabels: {
        Active: "Активний",
        Paused: "Призупинено",
        Completed: "Завершено",
      },
    },
    academy: {
      nav: "Академія",
      eyebrow: "PUREGLOSS Academy",
      title: "PUREGLOSS Академія",
      subtitle: "Програма навчання мобільного детейлінгу.\nДля Німеччини, Польщі, України та всієї Європи.",
      coverage: "Підходить для студентів з Німеччини, Польщі, України та інших країн Європи.",
      hero: {
        cta: "Долучитись до списку очікування",
        secondary: "Дізнатись більше",
      },
      why: {
        eyebrow: "Чому PUREGLOSS Академія",
        title: "Чому саме PUREGLOSS Академія?",
        desc: "Не звичайний онлайн-курс — повноцінний професійний шлях у мобільному детейлінгу.",
        items: [
          { title: "Реальні знання", desc: "Практичні методи та робочі процеси з реального досвіду PUREGLOSS." },
          { title: "Системи крок за кроком", desc: "Структуровані інструкції, чек-листи та шаблони замість безсистемних відео." },
          { title: "Сертифікація", desc: "Офіційний сертифікат PUREGLOSS Academy після успішного завершення." },
          { title: "Спільнота", desc: "Доступ до закритої спільноти студентів і випускників." },
          { title: "Партнерство в майбутньому", desc: "Найкращі студенти можуть отримати доступ до мережі PUREGLOSS." },
          { title: "Готові робочі процеси", desc: "Шаблони комунікації, ціноутворення та контролю якості." },
          { title: "Фокус на мобільний сервіс", desc: "Усе навчання адаптоване під виїзний детейлінг." },
          { title: "Кар'єрний шлях", desc: "Шлях від новачка до власної мобільної служби або партнера PUREGLOSS." },
        ],
      },
      who: {
        eyebrow: "Для кого",
        title: "Для кого цей курс?",
        items: [
          "Майбутні детейлери",
          "Початківці без досвіду",
          "Українці та міжнародні студенти",
          "Люди, які шукають практичні навички",
          "Майбутні власники мобільного сервісу",
          "Люди, які прагнуть самозайнятості",
        ],
        note: "Власне авто рекомендовано для виїзного сервісу, але не обов'язкове для приєднання до списку очікування.",
      },
      packages: {
        eyebrow: "Програми навчання",
        title: "Оберіть свою програму",
        desc: "Три рівні навчання — від основ до повноцінного запуску мобільного сервісу.",
        comingSoon: "Скоро",
        includes: "Включає",
        certificate: "Сертифікат",
        foundation: {
          icon: "🥉",
          name: "Foundation",
          oldPrice: "249€",
          newPrice: "149€",
          tagline: "Для повних початківців.",
          items: [
            "Вступ до мобільного детейлінгу",
            "Основи внутрішньої чистки",
            "Безпечні основи зовнішньої мийки",
            "Рекомендований перелік обладнання",
            "Рекомендований перелік хімії",
            "Інструкції з використання хімії",
            "Гід по мікрофібрі",
            "Гід по щітках і аксесуарах",
            "Основи ціноутворення",
            "Основи комунікації з клієнтом",
            "Огляд робочого процесу послуги",
            "PDF-чек-листи",
            "Тест на знання",
            "Сертифікат PUREGLOSS Foundation",
          ],
          note: "Без практичного навчання.",
          certificateName: "Сертифікат PUREGLOSS Foundation",
        },
        professional: {
          icon: "🥈",
          name: "Professional",
          oldPrice: "499€",
          newPrice: "349€",
          badge: "popular",
          tagline: "Усе з Foundation плюс:",
          items: [
            "Поглиблена внутрішня чистка",
            "Чистка сидінь",
            "Чистка килимів",
            "Догляд за пластиком",
            "Догляд за шкірою",
            "Основи чистки м'яких меблів",
            "Безпечна робота з хімією",
            "Гід зі зйомки до/після",
            "Підготовка авто до продажу",
            "Система оцінки часу",
            "Система оцінки ціни",
            "Як знайти перших клієнтів",
            "Стратегія флаєрів",
            "Стратегія візиток",
            "Стратегія локальних платформ",
            "Гід зі створення Google Business Profile",
            "Гід з індексації в Google",
            "Скрипти комунікації з клієнтом",
            "Розбір кейсів",
            "Практичні завдання",
            "Знижка 50% на створення сайту PUREGLOSS",
          ],
          certificateName: "Сертифікат PUREGLOSS Professional",
        },
        elite: {
          icon: "👑",
          name: "Elite",
          oldPrice: "999€",
          newPrice: "749€",
          badge: "premium",
          tagline: "Усе з Professional плюс:",
          items: [
            "Персональне менторство",
            "Приклади реальних робочих процесів",
            "Системи контролю якості",
            "Бізнес-процеси",
            "Управління термінами",
            "Розрахунок прибутку",
            "Системи повторних клієнтів",
            "Системи утримання клієнтів",
            "Підготовка до майбутньої мережі PUREGLOSS",
            "Пріоритетна верифікація сертифіката",
            "Практичне навчання з ментором (за можливості)",
            "БЕЗКОШТОВНИЙ односторінковий сайт PUREGLOSS",
            "Персональна підтримка Google Business Profile",
            "Персональна підтримка індексації в Google",
          ],
          certificateName: "Сертифікат PUREGLOSS Elite",
        },
      },
      polishingDisclaimer: "Поліровка та робота з ЛФП розглядаються лише у вигляді теоретичного вступу. Практична корекція лаку не входить у програму.",
      certification: {
        eyebrow: "Сертифікація",
        title: "Сертифікація та фінальне оцінювання",
        desc: "Усі студенти повинні скласти фінальне оцінювання, перш ніж отримати офіційний сертифікат PUREGLOSS Academy.",
        items: [
          "Теоретичний іспит",
          "Перевірка знань",
          "Розуміння робочих процесів",
          "Розуміння клієнтського workflow",
        ],
        award: "Після успішного завершення студент отримує:",
        awardName: "Сертифікат PUREGLOSS Academy",
      },
      career: {
        eyebrow: "Кар'єра",
        title: "Можливості після навчання",
        desc: "Найкращі студенти можуть отримати майбутній доступ до:",
        items: [
          "Програма PUREGLOSS Certified Detailer",
          "Партнерська мережа PUREGLOSS",
          "Профіль рекомендованого детейлера",
          "Майбутні рекомендації клієнтів",
          "Майбутні можливості співпраці",
        ],
        note: "Ми не гарантуємо працевлаштування — це майбутні можливості після успішного завершення курсу.",
      },
      notIncluded: {
        eyebrow: "Що не входить",
        title: "Що не входить у курс",
        items: [
          "Хімічні продукти",
          "Стартовий набір",
          "Налаштування платної реклами",
          "Практика поглибленої корекції лаку",
          "Публічний акаунт детейлера PUREGLOSS",
        ],
      },
      waitlist: {
        eyebrow: "Список очікування",
        title: "Залиште заявку",
        desc: "Залиште свої контакти — ми повідомимо про старт занять та запропонуємо ранній доступ.",
        name: "Ім'я",
        phone: "Телефон",
        email: "Email",
        country: "Країна",
        language: "Мова навчання",
        package: "Зацікавлений пакет",
        message: "Коментар",
        submit: "Долучитись",
        sending: "Надсилаємо...",
        successTitle: "Дякуємо!",
        successMessage: "Ваша заявка прийнята. Ми зв'яжемось з вами найближчим часом.",
        error: "Не вдалось надіслати заявку. Спробуйте ще раз.",
        gdpr: "Я погоджуюсь з обробкою моїх даних відповідно до Політики конфіденційності.",
      },
      future: {
        title: "Скоро в Академії",
        items: ["Відеоуроки", "Модулі курсів", "Сертифікати", "Кабінет студента", "Покупка курсів"],
      },
      pricing: {
        oldLabel: "Стара ціна",
        currentLabel: "Поточна ціна",
        badgePopular: "НАЙПОПУЛЯРНІШИЙ",
        badgePremium: "ПРЕМІУМ-ПРОГРАМА",
        save: "Економія",
      },
      cohort: {
        eyebrow: "🔥 Перший набір",
        title: "Перший набір PUREGLOSS Academy",
        desc: "Лише перші 20 студентів долучаться до стартового запуску Академії.",
        note: "Після завершення першого набору, нові періоди реєстрації можуть відкриватися пізніше.",
      },
      bonuses: {
        eyebrow: "🎁 Бонуси для студентів",
        title: "Бонуси для студентів",
        desc: "Усе включено — практичні матеріали, які заощадять вам тижні роботи.",
        items: [
          "PUREGLOSS PDF чек-листи",
          "Скрипти комунікації з клієнтом",
          "Рекомендовані переліки хімії",
          "Рекомендовані переліки обладнання",
          "Шаблони розрахунку ціни",
          "Шаблони робочих процесів",
        ],
      },
      certificatePreview: {
        eyebrow: "🏅 Сертифікат",
        title: "Сертифікат PUREGLOSS Academy",
        subtitle: "Кожен успішний студент отримує офіційний сертифікат PUREGLOSS Academy після проходження фінального оцінювання.",
        alt: "Зразок сертифіката PUREGLOSS Academy",
      },
      earnings: {
        eyebrow: "💰 Потенціал доходу",
        title: "Потенціал доходу мобільного детейлінгу",
        desc: "Приклади розрахунків при стабільному графіку:",
        items: [
          { vehicles: "1 авто на день", income: "≈ 1 780€/місяць" },
          { vehicles: "2 авто на день", income: "≈ 3 560€/місяць" },
          { vehicles: "3 авто на день", income: "≈ 5 340€/місяць" },
        ],
        disclaimer:
          "Результати залежать від країни, цін, попиту, якості сервісу та кількості клієнтів. Жодних гарантій доходу не надається.",
      },
      network: {
        eyebrow: "🚀 PUREGLOSS Network",
        title: "PUREGLOSS Network",
        desc: "Найкращі випускники можуть отримати майбутні можливості, такі як:",
        items: [
          "Статус PUREGLOSS Certified Detailer",
          "Розміщення в майбутній мережі PUREGLOSS",
          "Майбутні рекомендації клієнтів",
          "Потенційні можливості співпраці з PUREGLOSS",
        ],
        note: "Ми не обіцяємо працевлаштування — це майбутні можливості.",
      },
    },
    contact: {
      eyebrow: "Контакти",
      title: "Зв'яжіться з нами",
    },
    brands: {
      eyebrow: "Преміум обладнання",
      title: "Преміум продукти та обладнання",
      desc: "Для досягнення професійного результату ми використовуємо якісну хімію та обладнання від провідних брендів.",
      items: [
        { name: "Koch-Chemie", category: "Хімія для детейлінгу" },
        { name: "Kärcher", category: "Професійне обладнання" },
      ],
    },
    footer: {
      tagline: "Detailing & Sofa Cleaning",
      area: "Зона обслуговування",
      rights: "Всі права захищені.",
      legal: "Юридична інформація",
      impressum: "Імпресум",
      datenschutz: "Політика конфіденційності",
      agb: "Загальні умови",
      widerruf: "Право відкликання",
      cookies: "Cookies",
      madeIn: "Створено з ★ в Euskirchen",
      verifiedCustomer: "Перевірений клієнт",
    },
    admin: {
      title: "Admin · Leads",
      password: "Пароль",
      signIn: "Увійти",
      invalidPassword: "Невірний пароль",
      back: "Назад на сайт",
      logout: "Вийти",
      refresh: "Оновити",
      tabs: {
        overview: "Огляд",
        auto: "Авто",
        furniture: "Меблі",
        bookings: "Бронювання",
        newsletter: "Розсилка",
        detailers: "Детейлери",
        clients: "Клієнти",
        academy: "Академія",
        calendar: "Календар",
      },
      stats: {
        autoNew: "Нові авто",
        furnitureNew: "Нові меблі",
        inProgress: "В роботі",
        scheduled: "Заплановано",
        completed: "Виконано",
        rejected: "Відхилено",
        completedMonth: "Виконано цього місяця",
        completedYear: "Виконано цього року",
        revenue: "Прогнозовані надходження",
        aov: "Середній чек",
        totalLeads: "Всього лідів",
        activeLeads: "Активні ліди",
        conversion: "Конверсія",
        bookings: "Бронювань",
        leadVolume: "Обсяг лідів — Останні 14 днів",
        revenueVolume: "Прогноз доходу — Останні 14 днів (€)",
        topCities: "Топ міст",
        topServices: "Топ послуг",
        recentLeads: "Останні ліди",
        leadsCount: "Кількість лідів",
        revenueEur: "Дохід",
        noData: "Немає даних",
      },
      statusLabels: {
        NEW: "Новий",
        IN_PROGRESS: "В роботі",
        SCHEDULED: "Заплановано",
        COMPLETED: "Виконано",
        REJECTED: "Відхилено",
      },
      academyStatusLabels: {
        NEW: "Новий",
        CONTACTED: "Зв'язались",
        ENROLLED: "Зараховано",
        GRADUATED: "Випускник",
        REJECTED: "Відхилено",
      },
      card: {
        phone: "Телефон",
        email: "Email",
        city: "Місто",
        service: "Послуга",
        carModel: "Авто",
        package: "Пакет",
        message: "Повідомлення",
        photos: "Фото",
        status: "Статус",
        estimatedPrice: "Орієнтовна ціна",
        detailer: "Детейлер",
        whatsapp: "WhatsApp",
        call: "Дзвонити",
        emailAction: "Написати email",
        telegram: "Telegram",
        preferredContact: "Спосіб зв'язку",
        edit: "Редагувати",
        delete: "Видалити",
        duplicate: "Дублювати",
        internalNotes: "Внутрішні нотатки",
        internalNotesPlaceholder: "Тільки для адміна — напр. Зателефонувати після 18:00, VIP клієнт, взяти екстрактор...",
        createdAt: "Створено",
        updatedAt: "Оновлено",
        editLead: "Редагувати заявку",
        saveChanges: "Зберегти зміни",
        cancel: "Скасувати",
        deleteLeadTitle: "Видалити заявку?",
        deleteLeadDesc: "Ви впевнені, що хочете назавжди видалити цю заявку? Цю дію не можна скасувати.",
        deleteConfirm: "Видалити",
        leadDeletedToast: "Заявку успішно видалено.",
        leadUpdatedToast: "Заявку оновлено.",
        leadDuplicatedToast: "Заявку продубльовано.",
        priceUpdatedToast: "Ціну оновлено.",
        notesSavedToast: "Нотатки збережено.",
        actionFailedToast: "Дію не виконано. Спробуйте ще раз.",
        clickToEditPrice: "Натисніть, щоб редагувати",
        priceInvalid: "Введіть коректне число (€)",
        emailInvalid: "Введіть коректний email",
        phoneInvalid: "Введіть коректний телефон",
        nameRequired: "Ім'я обов'язкове",
        phoneRequired: "Телефон обов'язковий",
        detailerNone: "— Без детейлера —",
        estimatedPriceHint: "Приклад: 89, 149, 399",
        serviceHint: "Довільний текст: напр. Реставрація шкіри, Чистка двигуна...",
        history: "Історія",
        notSet: "не вказано",
        viewPhotos: "Перегляд фото",
        unread: "НОВИЙ",
        empty: "Немає запитів.",
        leadType: "Тип",
        leadTypeAuto: "Авто",
        leadTypeFurniture: "Меблі",
        leadTypeAcademy: "Академія",
        leadTypeBooking: "Бронювання",
        date: "Дата",
        customer: "Клієнт",
        all: "Всі",
        sort: "Сортувати",
        assignDetailer: "Призначити детейлера",
        requestReview: "Запросити відгук",
        address: "Адреса",
        item: "Об'єкт",
        sendWhatsApp: "Надіслати в WhatsApp",
        sendEmail: "Надіслати email",
        copyLink: "Копіювати посилання",
        copied: "Скопійовано",
        close: "Закрити",
      },
      sorts: {
        newest: "Спочатку нові",
        oldest: "Спочатку старі",
        priceDesc: "Висока ціна",
        priceAsc: "Низька ціна",
        city: "Місто A→Z",
        detailer: "Детейлер",
        bookingDate: "Дата бронювання",
      },
      detailers: {
        title: "Детейлери",
        id: "ID",
        name: "Ім'я",
        completedJobs: "Виконано",
        revenue: "Дохід",
        commission: "Комісія",
        rating: "Рейтинг",
        status: "Статус",
        active: "активний",
        inactive: "неактивний",
      },
      newsletterTable: {
        email: "Email",
        lang: "Мова",
        source: "Джерело",
        created: "Дата",
        empty: "Підписників ще немає.",
      },
      clients: {
        title: "Клієнти",
        search: "Пошук за іменем, телефоном або email…",
        levels: "Bronze 1-2 · Silver 3-4 · Gold 5+ виконаних замовлень",
        name: "Ім'я",
        orders: "Замовлень",
        completed: "Виконано",
        revenue: "Дохід",
        level: "Рівень",
      },
      academy: {
        title: "Академія — Список очікування",
        empty: "Заявок ще немає.",
        package: "Пакет",
        language: "Мова",
        totalLabel: "Усього в списку",
        interestedLabel: "Зацікавлені студенти",
        enrolledLabel: "Зараховані",
        graduatedLabel: "Випускники",
        byLanguageLabel: "За мовою",
      },
      students: {
        tab: "Учні",
        title: "Учні Академії",
        empty: "Ще немає учнів.",
        add: "Додати учня",
        edit: "Редагувати",
        delete: "Видалити",
        resetPassword: "Скинути пароль",
        activate: "Активувати учня",
        copyMessage: "Копіювати повідомлення",
        copied: "Скопійовано",
        cols: {
          studentId: "ID",
          name: "Ім'я",
          email: "Email",
          package: "Пакет",
          status: "Статус",
          startDate: "Старт",
          progress: "Прогрес",
          actions: "Дії",
        },
        form: {
          name: "Ім'я",
          email: "Email",
          password: "Пароль",
          newPassword: "Новий пароль",
          packageType: "Пакет",
          startDate: "Дата старту",
          status: "Статус",
          save: "Зберегти",
          cancel: "Скасувати",
          create: "Створити",
        },
        statusLabels: {
          Active: "Активний",
          Paused: "Призупинено",
          Completed: "Завершено",
        },
        accessMessage:
          "Ваш доступ до PUREGLOSS Academy активовано.\nУвійдіть тут:\nhttps://puregloss.eu/academy/login\n\nEmail:\n{email}\n\nПароль:\n{password}",
      },
      calendar: {
        title: "Календар бронювань",
        legendAvailable: "Доступно",
        legendBooked: "Заброньовано",
        legendUnavailable: "Недоступно",
        blockDay: "Заблокувати день",
        unblock: "Розблокувати",
        blocked: "Заблоковано",
        bookings: "Бронювань",
      },
      pgApps: {
        stats: {
          total: "Всього",
          new: "Нові",
          inReview: "На розгляді",
          approved: "Прийнято",
          rejected: "Відхилено",
        },
        roles: {
          all: "Всі",
          drivers: "Водії",
          detailers: "Детейлери",
          partners: "Партнери",
          driver: "Водій",
          detailer: "Детейлер",
          partner: "Партнер",
        },
        statuses: {
          allStatuses: "Всі статуси",
          new: "Нові",
          in_review: "На розгляді",
          approved: "Прийнято",
          rejected: "Відхилено",
        },
        sort: {
          newest: "Спочатку нові",
          oldest: "Спочатку старі",
        },
        searchPlaceholder: "Пошук…",
        refresh: "Оновити",
        table: {
          nameCompany: "Ім'я / Компанія",
          role: "Роль",
          location: "Локація",
          email: "Email",
          status: "Статус",
          submitted: "Надіслано",
          empty: "Немає заявок",
        },
        detail: {
          loading: "Завантаження…",
          close: "Закрити",
          fields: {
            company: "Компанія",
            businessType: "Тип бізнесу",
            contactPerson: "Контактна особа",
            email: "Email",
            phone: "Телефон",
            locations: "Локації",
            country: "Країна",
            city: "Місто",
            website: "Вебсайт",
            googleMaps: "Google Maps",
            social: "Соцмережі",
            fullName: "Повне ім'я",
            experience: "Досвід",
            services: "Послуги",
            training: "Навчання",
            academyTrainer: "Академія / тренер",
            instagram: "Instagram",
            facebook: "Facebook",
            portfolio: "Портфоліо",
            vehicle: "Автомобіль",
            heardAbout: "Звідки дізнались",
            motivation: "Мотивація",
            businessDescription: "Опис бізнесу",
            servicesToOffer: "Послуги, які пропонує",
            language: "Мова",
            submitted: "Надіслано",
            updated: "Оновлено",
            applicationId: "ID заявки",
          },
          adminNotes: "Нотатки адміна",
          saveNotes: "Зберегти нотатки",
          saved: "Збережено",
          saveFailed: "Не вдалось",
          actions: {
            email: "Email",
            call: "Дзвінок",
            whatsapp: "WhatsApp",
            instagram: "Instagram",
            facebook: "Facebook",
            website: "Сайт",
            maps: "Мапа",
            portfolio: "Портфоліо",
            copy: "Копіювати",
            copied: "Скопійовано",
          },
          delete: {
            button: "Видалити заявку",
            title: "Видалити цю заявку?",
            desc: "Заявку буде остаточно видалено. Цю дію неможливо скасувати.",
            confirm: "Видалити",
            cancel: "Скасувати",
            deleting: "Видалення…",
            deleted: "Заявку видалено",
            failed: "Видалення не вдалось",
          },
        },
      },

    },
    legal: {
      impressum: {
        title: "Імпресум",
        subtitle: "Інформація згідно з § 5 DDG",
        sections: [
          { h: "Постачальник послуг (§ 5 DDG)", p: "PUREGLOSS\nВласник: Vladyslav Lysyi\nПравова форма: одноосібне підприємство (Einzelunternehmen)\nRüdesheimer Ring 129\n53879 Euskirchen\nНімеччина" },
          { h: "Контакти", p: "Телефон: +49 176 22038169\nWhatsApp: +49 176 22038169\nEmail: info@puregloss.eu\nВебсайт: https://puregloss.eu" },
          { h: "ІПН з ПДВ", p: "Ідентифікаційний номер платника ПДВ відповідно до § 27a Закону Німеччини про ПДВ:\nDE367513046" },
          { h: "Відповідальний за зміст", p: "Відповідальний за зміст згідно з § 18 (2) MStV:\nVladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Німеччина" },
          { h: "Онлайн-вирішення спорів (ЄС)", p: "Європейська Комісія надає платформу для онлайн-вирішення спорів (ODR): https://ec.europa.eu/consumers/odr\nНашу email-адресу вказано вище в Імпресумі." },
          { h: "Позасудове вирішення спорів", p: "Ми не готові та не зобов'язані брати участь у процедурі позасудового вирішення спорів у сенсі § 36 Закону про врегулювання спорів споживачів (VSBG)." },
          { h: "Відповідальність за зміст", p: "Як постачальник послуг ми несемо відповідальність за власний зміст на цих сторінках відповідно до § 7 (1) DDG та загального законодавства. Проте згідно з §§ 8–10 DDG ми не зобов'язані контролювати передану або збережену сторонню інформацію." },
          { h: "Відповідальність за посилання", p: "Наша пропозиція містить посилання на зовнішні сайти третіх осіб, на зміст яких ми не маємо впливу. Відповідальність за зміст пов'язаних сторінок несе відповідний постачальник або оператор." },
          { h: "Авторське право", p: "Вміст цієї вебсторінки, створений оператором, охороняється німецьким законом про авторське право. Використання поза межами цього закону потребує письмової згоди автора." },
        ],
        back: "Повернутися на головну",
      },
      datenschutz: {
        title: "Політика конфіденційності",
        subtitle: "GDPR / BDSG-neu / TTDSG",
        sections: [
          { h: "1. Розпорядник даних", p: "Розпорядником у сенсі GDPR є:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129\n53879 Euskirchen, Німеччина\nТелефон: +49 176 22038169\nEmail: info@puregloss.eu" },
          { h: "2. Загальні положення", p: "Ми ставимося до захисту ваших персональних даних серйозно і обробляємо їх конфіденційно відповідно до GDPR, BDSG-neu та TTDSG. Персональні дані збираються тільки в обсязі, необхідному для виконання договірних чи законних зобов'язань або за вашою явною згодою." },
          { h: "3. SSL/TLS-шифрування", p: "Сайт використовує SSL/TLS-шифрування для безпечної передачі конфіденційного вмісту. Наявність шифрування можна побачити за префіксом \"https://\" та іконкою замка у браузері." },
          { h: "4. Серверні лог-файли / хостинг", p: "Сайт хоститься компанією Emergent Labs, Inc. Провайдер автоматично записує лог-файли з IP-адресою (у скороченому вигляді), датою й часом запиту, URL, реферером, браузером і ОС. Правова підстава: ст. 6 (1) (f) GDPR. Термін зберігання: до 30 днів." },
          { h: "5. Зв'язок (email, телефон, WhatsApp)", p: "Коли ви зв'язуєтесь з нами електронною поштою, телефоном або через месенджер, ми зберігаємо вашу інформацію (ім'я, контакти, повідомлення) для обробки запиту. Правова підстава: ст. 6 (1) (b) або (f) GDPR. Термін зберігання: до досягнення мети або встановлених законом строків (до 10 років згідно з § 257 HGB, § 147 AO)." },
          { h: "6. Форма запиту пропозиції", p: "Через форму ви можете надіслати ненавʼязливий запит. Обробляються: ім'я, телефон, email (за бажанням), місто, дані про автомобіль/об'єкт, фото, спосіб зв'язку, повідомлення. Правова підстава: ст. 6 (1) (b) GDPR." },
          { h: "7. Форма бронювання", p: "При обов'язковому бронюванні додатково збираються адреса надання послуги, дата та час. Правова підстава: ст. 6 (1) (b) GDPR." },
          { h: "8. WhatsApp", p: "На сайті є кнопки WhatsApp (WhatsApp Ireland Limited, група Meta). Зʼєднання з серверами WhatsApp/Meta встановлюється тільки після вашого натискання. Частково дані обробляються за межами ЄС (США). Правова підстава: ст. 6 (1) (a) і (b) GDPR. Деталі: https://www.whatsapp.com/legal/privacy-policy-eea." },
          { h: "9. PUREGLOSS CLUB (бонусна програма)", p: "При приєднанні до PUREGLOSS CLUB обробляються: імʼя (необовʼязково), email, мовні налаштування, час приєднання, згенерований код ваучера. Мета: видача та адміністрування одноразового ваучера на 25 €, оперативне спілкування щодо програми. Правова підстава: ст. 6 (1) (a) і (b) GDPR. Ви можете відкликати згоду в будь-який час (info@puregloss.eu)." },
          { h: "10. Newsletter / акції", p: "Для розсилки акційних листів ми зберігаємо email, момент надання згоди, а для доказу — вашу IP-адресу та User-Agent браузера. Підписка відбувається лише після активної відмітки GDPR-згоди. Ви можете відписатись у будь-який час, написавши на info@puregloss.eu; ми видалимо ваші дані одразу, не пізніше ніж протягом 7 днів. Правова підстава: ст. 6 (1) (a) GDPR." },
          { h: "11. Розсилка листів (Resend)", p: "Для відправки транзакційних та рекламних листів ми використовуємо Resend (Resend, Inc., Сан-Франциско, США). Оброблюються email-адреса, вміст повідомлень і метадані доставки. Укладено угоду про обробку за ст. 28 GDPR. Правова підстава: ст. 6 (1) (b) та (f) GDPR. Передача до третьої країни (США) забезпечується стандартними договірними положеннями ЄС згідно зі ст. 46 GDPR." },
          { h: "12. Cookies і локальне сховище", p: "Сайт використовує лише технічно необхідне локальне сховище браузера (localStorage) для мови, стану popup CLUB тощо. Ці дані ніколи не покидають ваш браузер. Маркетингові, аналітичні або сторонні cookies НЕ використовуються. Правова підстава: § 25 (2) № 2 TTDSG." },
          { h: "13. Шрифти", p: "Ми використовуємо шрифт «Cabinet Grotesk», який завантажується через сервіс Fontshare (Indian Type Foundry, Індія). При завантаженні сторінки може передаватися ваша IP-адреса. Правова підстава: ст. 6 (1) (f) GDPR. Google Fonts більше не використовується; інші шрифти беруться локально з операційної системи." },
          { h: "14. Зображення", p: "Сайт містить фото до/після, портфоліо та стокові зображення. Номери авто та обличчя людей у салоні маскуються чи видаляються перед публікацією." },
          { h: "15. Завантаження файлів", p: "Фото, завантажені через форму запиту, зберігаються на нашій інфраструктурі й використовуються виключно для підготовки пропозиції. Правова підстава: ст. 6 (1) (b) GDPR. Видаляються не пізніше ніж через 12 місяців після завершення запиту." },
          { h: "16. Отримувачі / передача третім особам", p: "Ми передаємо дані тільки: провайдеру email (Resend), хостинг-провайдеру (Emergent Labs, Inc.) та – за вашим використанням – WhatsApp/Meta. Передача третім особам з рекламною метою НЕ здійснюється." },
          { h: "17. Термін зберігання", p: "Персональні дані зберігаються лише стільки, скільки потрібно для мети або передбачено законом (як правило, 6 років згідно з § 257 HGB, 10 років згідно з § 147 AO для податкових документів)." },
          { h: "18. Ваші права", p: "Згідно з GDPR ви маєте право:\n• на доступ (ст. 15)\n• на виправлення (ст. 16)\n• на видалення (ст. 17)\n• на обмеження обробки (ст. 18)\n• на переносимість (ст. 20)\n• на заперечення (ст. 21)\n• на відкликання згоди (ст. 7 (3))\n\nДля реалізації прав достатньо надіслати повідомлення на info@puregloss.eu." },
          { h: "19. Право на скаргу", p: "Ви маєте право подати скаргу до наглядового органу з питань захисту даних:\n\nLandesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)\nKavalleriestraße 2-4, 40213 Düsseldorf\nТел.: +49 211 38424-0\nEmail: poststelle@ldi.nrw.de\nhttps://www.ldi.nrw.de" },
          { h: "20. Актуальність політики", p: "Ця політика конфіденційності діє з дати останнього оновлення. Актуальна версія завжди доступна за адресою https://puregloss.eu/datenschutz." },
          { h: "21. Журнал безпеки при реєстрації (PUREGLOSS Club)", p: "Під час кожної нової реєстрації в PUREGLOSS Club ми додатково зберігаємо технічну інформацію для безпеки, запобігання шахрайству, спам-захисту та виявлення зловживань. Це охоплює: вашу IP-адресу, наближене місцезнаходження (країна, регіон, приблизне місто) на основі цієї IP — ніколи точну позицію, — інформацію про браузер і пристрій (User-Agent, операційна система, тип пристрою), а також час реєстрації. Місцезнаходження завжди залишається приблизним і не використовується для індивідуальної ідентифікації. Правова підстава: ст. 6(1)(f) GDPR (законний інтерес у безпечному та вільному від зловживань наданні сервісу). Ця інформація доступна лише внутрішньо та не передається третім особам, за винятком технічно необхідного сервісу IP-геолокації." },
        ],
        back: "Повернутися на головну",
      },
      agb: {
        title: "Загальні умови",
        subtitle: "Дійсні з лютого 2026",
        sections: [
          { h: "§ 1 Сфера застосування", p: "Ці Загальні умови (AGB) регулюють усі договори між PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen («Виконавець») та споживачами/підприємцями («Клієнт») щодо послуг на https://puregloss.eu (мобільне детейлінг-обслуговування авто, внутрішня/зовнішня очистка, чистка м'яких меблів)." },
          { h: "§ 2 Укладення договору", p: "Розміщені послуги — не юридично зобов'язуюча пропозиція, а запрошення надати пропозицію. Клієнт надсилає ненавʼязливий запит через форму, Виконавець готує індивідуальну пропозицію. Договір укладається лише після взаємного підтвердження або початку виконання." },
          { h: "§ 3 Обсяг послуг", p: "Точний обсяг послуг визначається в індивідуальній пропозиції. Стан авто/об'єкта може впливати на трудомісткість і кінцеву ціну; істотні зміни узгоджуються заздалегідь." },
          { h: "§ 4 Ціни та оплата", p: "Ціни вказані в євро з урахуванням ПДВ. Оплата на місці після виконання послуги готівкою або (за наявності) карткою. У разі прострочення діють §§ 286 і далі BGB." },
          { h: "§ 5 Запис, скасування, запізнення", p: "Записи підтверджуються email або месенджером. Клієнт може безкоштовно скасувати чи перенести запис не пізніше ніж за 24 години. За пізніші скасування може стягуватись 50 % вартості. Виконавець за поважної причини оперативно пропонує заміну дати." },
          { h: "§ 6 Обов'язки клієнта", p: "Клієнт забезпечує доступ до авто/об'єкта, необхідне місце, воду й електропостачання 230 В за потреби. Особисті речі мають бути вилучені з авто/об'єкта до початку робіт." },
          { h: "§ 7 Гарантія та відповідальність", p: "Діють законні гарантії. Виконавець несе необмежену відповідальність за шкоду життю та здоров'ю, а також за умисел і грубу необережність. У разі простої необережності — обмежена типовою передбачуваною шкодою. За вже наявні пошкодження (подряпини, сколи, застарілі плями) Виконавець не відповідає; за бажанням вони фіксуються до початку робіт." },
          { h: "§ 8 Право споживача на відкликання", p: "Споживачі мають право відкликання відповідно до § 312g разом із § 355 BGB. Деталі — у нашій Widerrufsbelehrung." },
          { h: "§ 9 Вирішення спорів", p: "Комісія ЄС надає платформу для онлайн-вирішення спорів: https://ec.europa.eu/consumers/odr. Ми не готові та не зобов'язані брати участь у процедурах перед арбітражною комісією." },
          { h: "§ 10 Прикінцеві положення", p: "Застосовується німецьке право за винятком Віденської конвенції. Місце виконання — Euskirchen. Підсудність — місцезнаходження Виконавця. У разі недійсності окремих положень інші залишаються чинними." },
        ],
        back: "Повернутися на головну",
      },
      widerruf: {
        title: "Право на відкликання",
        subtitle: "Ваші права як споживача",
        sections: [
          { h: "Право на відкликання", p: "Ви маєте право відкликати цей договір протягом чотирнадцяти днів без вказання причини. Строк відкликання становить чотирнадцять днів з дня укладення договору.\n\nЩоб реалізувати право, повідомте нас:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Німеччина\nТел.: +49 176 22038169\nEmail: info@puregloss.eu\n\nоднозначною заявою (лист поштою або email). Ви можете скористатися нижченаведеним шаблоном, але це необов'язково.\n\nДля дотримання строку достатньо надіслати повідомлення до закінчення терміну." },
          { h: "Наслідки відкликання", p: "У разі відкликання ми повертаємо всі отримані від вас платежі (окрім додаткових витрат за нестандартний спосіб доставки) не пізніше ніж через 14 днів з моменту отримання повідомлення про відкликання. Повернення здійснюється тим самим способом оплати, якщо не погоджено інше; жодних додаткових зборів не стягується." },
          { h: "Дострокове припинення права відкликання при послугах", p: "Право відкликання припиняється, якщо послуга виконана повністю та її виконання розпочато за вашою явною згодою і з підтвердженням, що при повному виконанні право відкликання втрачається (§ 356 (4) BGB)." },
          { h: "Зразок заяви про відкликання", p: "(Заповніть цю форму, якщо хочете відкликати договір.)\n\nКому: PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen, Німеччина, Email: info@puregloss.eu\n\nЦим я/ми (*) відкликаю/відкликаємо (*) укладений мною/нами (*) договір щодо купівлі товару (*)/надання послуги (*):\n\n___________________________________\n\nЗамовлено (*)/отримано (*):\n___________________________________\n\nІм'я споживача(-ів):\n___________________________________\n\nАдреса:\n___________________________________\n\nДата: _______________\n\nПідпис (лише при паперовому оформленні):\n___________________________________\n\n(*) Непотрібне закреслити." },
        ],
        back: "Повернутися на головну",
      },
      cookies: {
        title: "Політика Cookies",
        subtitle: "Cookies і локальне сховище",
        sections: [
          { h: "1. Загальний принцип", p: "Цей сайт НЕ використовує cookies третіх сторін, маркетингові чи аналітичні cookies. Не використовуються Google Analytics, Google Tag Manager, Meta Pixel тощо. Використовується лише технічно необхідне локальне сховище браузера." },
          { h: "2. Мета локального сховища", p: "Зберігаються локально:\n• обрана мова (DE/EN/UA)\n• факт вступу до PUREGLOSS CLUB\n• налаштування форми за замовчуванням\n\nЦі дані ніколи не покидають ваш браузер." },
          { h: "3. Правова основа", p: "Наведене зберігання є суворо необхідним для функціонування сайту (§ 25 (2) № 2 TTDSG) і не потребує окремої згоди." },
          { h: "4. Видалення", p: "Ви можете будь-коли очистити локальне сховище через налаштування вашого браузера." },
          { h: "5. Зовнішні сервіси", p: "При натисканні кнопки WhatsApp ви залишаєте наш сайт і потрапляєте в середовище WhatsApp/Meta, яке може встановлювати свої cookies. Це поза нашим контролем." },
        ],
        back: "Повернутися на головну",
      },
    },
  },

  de: {
    seo: {
      title: "PUREGLOSS — Mobile Autoaufbereitung & Polsterreinigung Euskirchen",
      description:
        "Mobile Fahrzeugaufbereitung und professionelle Polsterreinigung. Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen & Umgebung. Kostenlose Preisbewertung innerhalb von 1 Stunde.",
      keywords:
        "Auto Detailing Euskirchen, Mobile Detailing Euskirchen, Autoaufbereitung Euskirchen, Sofa Cleaning Euskirchen, Polsterreinigung Euskirchen, Innenreinigung, Politur",
    },
    nav: {
      home: "Start",
      services: "Leistungen",
      beforeAfter: "Vorher & Nachher",
      reviews: "Bewertungen",
      prices: "Preise",
      serviceArea: "Einsatzgebiet",
      promotions: "Aktionen",
      faq: "FAQ",
      contact: "Kontakt",
      academy: "Akademie",
      works: "Unsere Arbeiten",
      club: "PUREGLOSS CLUB",
      cta: "WhatsApp",
    },
    cta: {
      getPrice: "Preis anfragen",
      getPriceShort: "Preis",
      bookAppointment: "Termin buchen",
      bookAppointmentShort: "Termin",
      checkAvailability: "Verfügbarkeit in Ihrer Stadt prüfen",
      joinWaitingList: "Auf die Warteliste",
      whatsapp: "WhatsApp",
      readyTitle: "Bereit zu starten?",
      readyDesc: "Schnell einen Preis erhalten oder Ihren Termin buchen.",
    },
    promotions: {
      eyebrow: "Aktionen & Angebote",
      title: "Aktionen & Sonderangebote",
      desc: "Erfahren Sie als Erstes von saisonalen Rabatten, Paketen und exklusiven Premium-Angeboten von PUREGLOSS.",
      nameLabel: "Name (optional)",
      emailLabel: "E-Mail",
      emailPlaceholder: "your@email.com",
      cta: "Abonnieren",
      gdpr: "Ich stimme dem Erhalt von Marketing-E-Mails gemäß",
      successTitle: "Vielen Dank!",
      successMessage: "Sie wurden zur PUREGLOSS-Angebotsliste hinzugefügt.",
      error: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    },
    ctaBlocks: {
      services: { title: "Bereit zu starten?", desc: "Holen Sie einen schnellen Preis oder buchen Sie einen Termin.", primary: "Preis anfragen", secondary: "Termin buchen" },
      pricing: { title: "Paket gewählt?", desc: "Buchen Sie einen Termin oder fragen Sie den genauen Preis an.", primary: "Preis anfragen", secondary: "Termin buchen" },
      serviceArea: { title: "Wir kommen zu Ihnen", desc: "Prüfen Sie die Verfügbarkeit in Ihrer Stadt.", primary: "Verfügbarkeit prüfen", secondary: "Termin buchen" },
      academy: { title: "PUREGLOSS Akademie", desc: "Mobile Fahrzeugaufbereitung in Deutschland lernen. Plätze sind bald verfügbar.", primary: "Auf die Warteliste" },
    },
    serviceAreaMap: {
      title: "Einsatzgebiet",
      desc: "Mobiler Service in Euskirchen, Köln, Bonn und Umgebung.",
      mobileTag: "Mobiler Service — wir kommen zu Ihnen",
      cityAvailability: "Mobiler Service an Ihrem Standort",
    },
    trustBadge: "Kostenlose Preisbewertung innerhalb von 1 Stunde",
    floatingEstimate: "Kostenlose Bewertung per Anfrage",
    basedIn: "Standort: Euskirchen",
    whatsappConsent: {
      eyebrow: "Datenschutz-Hinweis",
      title: "Sie werden zu WhatsApp weitergeleitet",
      body: "Mit Ihrer Bestätigung werden Ihre Telefonnummer und Ihre Nachricht an WhatsApp Ireland Ltd. (Meta) übertragen. Ein Teil der Verarbeitung findet außerhalb der EU (USA) statt.",
      details: "Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Details in unserer",
      datenschutzLink: "Datenschutzerklärung",
      confirm: "Weiter zu WhatsApp",
      cancel: "Abbrechen",
      close: "Schließen",
    },
    fullAreaText:
      "Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen & Umgebung",
    hero: {
      eyebrow: "Mobiles Detailing • Euskirchen",
      title: "PUREGLOSS",
      subtitle: "Detailing & Sofa Cleaning",
      desc: "Mobile Fahrzeugaufbereitung und professionelle Polsterreinigung — direkt bei Ihnen vor Ort.",
      ctaPrimary: "Preis erhalten",
      ctaSecondary: "WhatsApp schreiben",
      scroll: "Scrollen",
    },
    area: {
      label: "Servicegebiet",
      suffix: "& Umgebung",
    },
    services: {
      eyebrow: "Leistungen",
      title: "Premium-Pflege für Ihr Auto und Ihre Möbel",
      desc: "Professioneller mobiler Service — alles, was Sie brauchen, damit Ihre Sachen wieder makellos aussehen.",
      vehicleTitle: "Fahrzeugaufbereitung",
      vehicleItems: [
        "Innenreinigung",
        "Sitzreinigung",
        "Lederpflege",
        "Geruchsentfernung",
        "Handwäsche",
        "Felgenreinigung",
        "Reifenpflege",
        "Verkaufsaufbereitung",
      ],
      sofaTitle: "Sofa & Polsterreinigung",
      sofaItems: [
        "Sofas",
        "Sessel",
        "Matratzen",
        "Polstermöbel",
        "Fleckenentfernung",
        "Geruchsentfernung",
        "Tiefenreinigung",
        "Teppichreinigung",
      ],
    },
    pricing: {
      eyebrow: "Preise",
      title: "Transparente Preise",
      auto: "Auto",
      polishing: "Lackkorrektur & Politur",
      furniture: "Möbel",
      from: "ab",
      items: {
        auto: [
          { name: "Innenreinigung", price: "49€" },
          { name: "Außenreinigung", price: "39€" },
          { name: "Komplettpaket", price: "89€" },
          { name: "Verkaufsaufbereitung", price: "119€" },
        ],
        furniture: [
          { name: "Sessel", price: "25€" },
          { name: "2-Sitzer Sofa", price: "49€" },
          { name: "3-Sitzer Sofa", price: "69€" },
          { name: "Ecksofa", price: "99€" },
          { name: "Matratze", price: "39€" },
        ],
      },
      note: "Der genaue Preis hängt vom Zustand des Fahrzeugs oder der Möbel ab. Senden Sie uns Fotos für eine kostenlose Einschätzung.",
      lockedBadge: "BALD VERFÜGBAR",
      lockedTitle: "Lackkorrektur & Politur",
      lockedDesc:
        "Professionelle Lackkorrektur und Maschinenpolitur sind derzeit noch nicht verfügbar, werden aber in Kürze eingeführt.",
      lockedDisabled: "Buchung vorübergehend nicht möglich",
      ctaGetEstimate: "Anfrage senden",
      lockedItems: [
        { name: "Ein-Stufen-Politur", price: "149€" },
        { name: "Zwei-Stufen-Politur", price: "249€" },
        { name: "Drei-Stufen-Politur", price: "349€" },
      ],
    },
    stats: [
      { value: "100%", label: "Mobiler Service" },
      { value: "PRO", label: "Premium-Produkte" },
      { value: "24/7", label: "Flexible Termine" },
      { value: "★★★★★", label: "Professionelles Ergebnis" },
    ],
    beforeAfter: {
      eyebrow: "Ergebnisse",
      title: "Vorher & Nachher",
      desc: "Ziehen Sie den Schieberegler, um den Unterschied zu sehen.",
      categories: { cars: "Auto", sofas: "Sofa" },
      beforeLabel: "Vorher",
      afterLabel: "Nachher",
    },
    instaProof: {
      eyebrow: "Portfolio",
      title: "Unsere echten Arbeiten",
      desc: "Sehen Sie echte PUREGLOSS Ergebnisse: Fahrzeuge, Sofas, Matratzen und weitere Vorher-/Nachher-Arbeiten.",
      stats: ["Echte Kunden", "Vorher-/Nachher-Fotos", "Wöchentlich neue Arbeiten"],
      cta: "Alle Arbeiten ansehen",
      handle: "@puregloss.eu",
    },
    serviceLabels: {
      Innenraum: "Innenraum",
      "Außenreinigung": "Außenreinigung",
      Sitzreinigung: "Sitzreinigung",
      Lederpflege: "Lederpflege",
      Felgenreinigung: "Felgenreinigung",
      Politur: "Politur",
      Scheinwerfer: "Scheinwerfer",
    },
    furnitureServiceLabels: {
      Sofa: "Sofa",
      Matratze: "Matratze",
      Sessel: "Sessel",
      "Stühle": "Stühle",
      Bürostuhl: "Bürostuhl",
      Teppich: "Teppich",
      Polster: "Polster",
    },
    brandLabels: {
      Audi: "Audi", BMW: "BMW", "Mercedes-Benz": "Mercedes-Benz",
      Porsche: "Porsche", Volkswagen: "Volkswagen", Tesla: "Tesla",
      Skoda: "Skoda", Ford: "Ford", Opel: "Opel", Toyota: "Toyota",
      Hyundai: "Hyundai", Other: "Sonstige",
    },
    furnitureTypeLabels: {
      "2-Sitzer Sofa": "2-Sitzer Sofa",
      "3-Sitzer Sofa": "3-Sitzer Sofa",
      Ecksofa: "Ecksofa",
      Matratze: "Matratze",
      Sessel: "Sessel",
      Stuhl: "Stuhl",
      Bürostuhl: "Bürostuhl",
      Teppich: "Teppich",
      Other: "Sonstige",
    },
    works: {
      heroTitle: "Unsere Arbeiten",
      heroSubtitle: "Echte Ergebnisse unserer Fahrzeug-, Sofa-, Matratzen- und Polsterreinigung.",
      empty: "Arbeiten werden bald hinzugefügt.",
      filterAll: "Alle",
      filterCategory: "Kategorie",
      filterService: "Leistung",
      filterBrand: "Marke",
      filterType: "Möbeltyp",
      catVehicle: "Fahrzeuge",
      catFurniture: "Möbel",
      viewBtn: "Ansehen",
      getPriceCta: "Preis anfragen",
      beforeLabel: "Vorher",
      afterLabel: "Nachher",
      cityLabel: "Stadt",
      serviceLabel: "Leistung",
      brandLabel: "Marke",
      modelLabel: "Modell",
      typeLabel: "Typ",
      descriptionLabel: "Beschreibung",
      sliderHint: "Ziehen zum Vergleichen",
      beforeGallery: "Vorher-Fotos",
      afterGallery: "Nachher-Fotos",
      close: "Schließen",
      photoSoon: "Foto wird bald hinzugefügt",
      getSameServiceCta: "Preis berechnen",
      likeResultTitle: "Gefällt Ihnen das Ergebnis?",
      likeResultDesc: "Wir erzielen auch bei Ihrem Fahrzeug oder Ihren Möbeln ein solches Ergebnis.",
      ctaFreeQuote: "Kostenlose Schätzung anfragen",
      ctaBookSlot: "Termin buchen",
    },
    club: {
      title: "Willkommen im PUREGLOSS CLUB",
      subtitle: "Sichern Sie sich exklusive Vorteile und werden Sie kostenlos Mitglied.",
      benefit1: "🎁 25 € Willkommensgutschein ab 100 € Auftragswert",
      benefit2: "⚡ Frühzeitiger Zugang zu Aktionen und Angeboten",
      benefit3: "👑 Exklusive Vorteile für PUREGLOSS CLUB Mitglieder",
      benefit4: "",
      nameLabel: "Name (optional)",
      emailLabel: "E-Mail",
      gdpr: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu.",
      joinCta: "Kostenlos Mitglied werden",
      joining: "Wird verarbeitet...",
      finePrint: "Gutschein 6 Monate gültig, einmalig einlösbar. Mindestauftragswert 100 €.",
      close: "Schließen",
      alreadyRegistered: "Diese E-Mail ist bereits im PUREGLOSS CLUB registriert.",
      genericError: "Beitritt fehlgeschlagen. Bitte erneut versuchen.",
      emailInvalid: "Bitte gültige E-Mail eingeben",
      gdprRequired: "Bitte Datenschutzerklärung akzeptieren",
      successTitle: "Willkommen im PUREGLOSS CLUB!",
      successMessage: "Ihr 25 € Willkommensgutschein ist aktiviert. Er gilt für jede PUREGLOSS Dienstleistung ab 100 € Auftragswert.",
      successCta: "Kostenlose Bewertung anfragen",
    },
    clubAdmin: {
      tab: "PUREGLOSS CLUB",
      empty: "Noch keine Club-Mitglieder.",
      filterAll: "Alle",
      filterActive: "Aktiv",
      filterUsed: "Verwendet",
      filterExpired: "Abgelaufen",
      filterEmailNotSent: "E-Mail nicht gesendet",
      filterEmailSent: "E-Mail gesendet",
      searchPlaceholder: "Suche nach Name, E-Mail oder Gutschein-Code",
      newMemberBtn: "Neues Mitglied",
      newMemberTitle: "Club-Mitglied anlegen",
      sendWelcomeCheckbox: "Welcome Email direkt senden",
      createBtn: "Anlegen",
      redeemBtn: "Gutschein einlösen",
      redeemTitle: "Gutschein einlösen?",
      redeemDesc: "Der Status wird auf „Verwendet\" gesetzt und das Einlösedatum gespeichert.",
      redeemConfirm: "Einlösen",
      redeemed: "Gutschein eingelöst.",
      regenerateBtn: "PDF neu erzeugen",
      regenerated: "PDF-Gutschein wurde neu erstellt.",
      emptySearch: "Keine Treffer für Ihre Suche.",
      colName: "Name",
      colEmail: "E-Mail",
      colJoined: "Beitrittsdatum",
      colBonusStart: "Bonus-Start",
      colBonusEnd: "Bonus-Ende",
      colBonus: "Welcome Bonus",
      colCondition: "Bedingung",
      colSecond: "2. Reinigung",
      colVoucherCode: "Gutschein-Code",
      colStatus: "Status",
      colEmailStatus: "E-Mail",
      statusActive: "aktiv",
      statusUsed: "verwendet",
      statusExpired: "abgelaufen",
      emailNotSent: "nicht gesendet",
      emailSent: "gesendet",
      emailFailed: "fehlgeschlagen",
      markUsed: "Als verwendet markieren",
      markActive: "Als aktiv markieren",
      markExpired: "Als abgelaufen markieren",
      editBtn: "Bearbeiten",
      deleteBtn: "Löschen",
      sendWelcome: "Welcome Email senden",
      deleteTitle: "Club-Mitglied löschen?",
      deleteDesc: "Sind Sie sicher, dass Sie dieses Club-Mitglied löschen möchten?",
      deleteConfirm: "Löschen",
      cancel: "Abbrechen",
      resendNotConnected: "Email-Versand wird im nächsten Schritt mit Resend verbunden.",
      emailSentToast: "Welcome Email erfolgreich gesendet.",
      emailFailedToast: "E-Mail-Versand fehlgeschlagen",
      updated: "Mitglied aktualisiert.",
      deleted: "Mitglied gelöscht.",
      actionFailed: "Aktion fehlgeschlagen.",
      editTitle: "Mitglied bearbeiten",
      notesLabel: "Notizen",
      saveBtn: "Speichern",
    },
    worksAdmin: {
      tab: "Arbeiten",
      addBtn: "Arbeit hinzufügen",
      editBtn: "Bearbeiten",
      deleteBtn: "Löschen",
      publish: "Veröffentlicht",
      draft: "Entwurf",
      statusLabel: "Status",
      createTitle: "Neue Arbeit",
      editTitle: "Arbeit bearbeiten",
      titleField: "Titel",
      titlePlaceholder: "z. B. BMW M3 — Komplette Innenraumreinigung",
      categoryField: "Kategorie",
      serviceField: "Leistung",
      brandField: "Fahrzeugmarke",
      modelField: "Modell",
      furnitureTypeField: "Möbeltyp",
      cityField: "Stadt",
      descriptionField: "Kurzbeschreibung",
      beforePhotos: "Vorher-Fotos (bis zu 5)",
      afterPhotos: "Nachher-Fotos (bis zu 5)",
      uploadBtn: "Fotos hochladen",
      selectPlaceholder: "— Bitte wählen —",
      cancel: "Abbrechen",
      save: "Speichern",
      empty: "Noch keine Arbeiten. Klicken Sie auf 'Arbeit hinzufügen', um die erste zu erstellen.",
      deleteTitle: "Arbeit löschen?",
      deleteDesc: "Möchten Sie diese Arbeit wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      workCreated: "Arbeit erstellt.",
      workUpdated: "Arbeit aktualisiert.",
      workDeleted: "Arbeit gelöscht.",
      actionFailed: "Aktion fehlgeschlagen.",
      maxPhotos: "Maximal 5 Fotos.",
      requiredCategory: "Bitte Kategorie wählen",
      uploadFailed: "Foto konnte nicht hochgeladen werden: ",
      unsupportedFile: "Nicht unterstützte Datei: ",
      supportedFormats: "Erlaubt: JPG, PNG, WEBP",
      uploadingProgress: "Wird hochgeladen {done}/{total}...",
    },
    reviews: {
      eyebrow: "Bewertungen",
      title: "Was unsere Kunden sagen",
      items: [
        { text: "Nach der Verkaufsaufbereitung sah das Auto deutlich besser aus und verkaufte sich schneller.", author: "Andreas K.", city: "Köln" },
        { text: "Wir wollten das Sofa wegwerfen, aber nach der Reinigung sieht es wieder frisch aus.", author: "Marina S.", city: "Bonn" },
        { text: "Sehr praktisch, dass der Service nach Hause kommt. Alles sauber gemacht.", author: "Thomas L.", city: "Euskirchen" },
        { text: "Fairer Preis, gutes Ergebnis und professioneller Service.", author: "Olena P.", city: "Brühl" },
        { text: "Ich empfehle PUREGLOSS. Werde wiederkommen.", author: "Markus B.", city: "Hürth" },
      ],
    },
    howItWorks: {
      eyebrow: "So funktioniert es",
      title: "Einfacher Ablauf",
      steps: [
        "Sie senden Fotos",
        "Sie erhalten einen Richtpreis",
        "Wir wählen einen passenden Termin",
        "Wir kommen zu Ihnen",
        "Sie erhalten ein sauberes Ergebnis",
      ],
    },
    newsletter: {
      eyebrow: "Newsletter",
      title: "Verpassen Sie keine Aktionen und Sonderangebote",
      placeholder: "your@email.com",
      cta: "Abonnieren",
      thanks: "Danke für Ihre Anmeldung!",
      gdpr: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu.",
      error: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Häufige Fragen",
      items: [
        { q: "Wie viel kostet die Autoreinigung?", a: "Der Preis beginnt bei 39€ für die Außenreinigung und 49€ für die Innenreinigung. Komplettpaket ab 89€. Der genaue Preis hängt vom Zustand ab." },
        { q: "Wie lange dauert die Reinigung?", a: "In der Regel 2–5 Stunden, je nach Verschmutzungsgrad und gewähltem Paket." },
        { q: "Muss ich irgendwohin fahren?", a: "Nein. Wir sind ein mobiler Service und kommen zu Ihnen — mit unserer eigenen Ausrüstung." },
        { q: "Reinigen Sie Sofas, Matratzen und Teppiche?", a: "Ja. Wir reinigen Sofas, Sessel, Matratzen, Ecksofas, Teppiche und andere Polstermöbel." },
        { q: "Kann nur ein Teil gereinigt werden?", a: "Ja. Wir bieten Teilreinigungen an — z.B. nur Vordersitze oder Kofferraum." },
        { q: "Entfernen Sie auch Gerüche?", a: "Ja. Wir verwenden professionelle Mittel zur Geruchsbeseitigung — Rauch, Tiere, Lebensmittel." },
        { q: "Welche Gebiete bedienen Sie?", a: "Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen & Umgebung. Weitere Gebiete auf Anfrage." },
        { q: "Wie buche ich einen Termin?", a: "Füllen Sie das Formular auf der Website aus oder schreiben Sie uns auf WhatsApp. Wir bestätigen einen passenden Termin innerhalb einer Stunde." },
        { q: "Wie bekomme ich einen genauen Preis?", a: "Senden Sie uns einige Fotos per WhatsApp — wir antworten innerhalb einer Stunde. Preisbewertung kostenlos." },
        { q: "Welche Zahlungsmöglichkeiten?", a: "Bar, Überweisung oder PayPal. Zahlung nach Abschluss der Arbeit." },
      ],
    },
    quote: {
      eyebrow: "Preisanfrage",
      title: "Erhalten Sie ein kostenloses Angebot",
      desc: "Füllen Sie das Formular aus — wir öffnen WhatsApp mit Ihrer Nachricht. Antwort innerhalb von 1 Stunde.",
      name: "Name",
      phone: "Telefonnummer",
      city: "Stadt",
      cityPlaceholder: "—",
      serviceType: "Art der Leistung",
      message: "Nachricht",
      photos: "Fotos (optional)",
      photosHint: "Fügen Sie Fotos hinzu — nach Klick öffnet sich WhatsApp, wo Sie sie anhängen können",
      submit: "Preis erhalten",
      successHint: "WhatsApp wird geöffnet",
      serviceOptions: [
        "Innenreinigung",
        "Außenreinigung",
        "Komplettpaket",
        "Sofa-Reinigung",
        "Matratzen-Reinigung",
        "Teppichreinigung",
      ],
      cityOther: "Sonstige / Umgebung",
      uploading: "Wird hochgeladen...",
      emailLabel: "Email",
      preferredContactLabel: "Bevorzugte Kontaktmethode",
      preferredContactPlaceholder: "Methode wählen",
      preferredContactRequired: "Bitte bevorzugte Kontaktmethode wählen",
      preferredContactOptions: ["WhatsApp", "Telegram", "Email", "Telefon"],
      gdpr: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu.",
      submitError: "Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
      successTitle: "Vielen Dank für Ihre Anfrage!",
      successMessage: "Ihre Anfrage wurde erfolgreich übermittelt und wird nun bearbeitet. Wir melden uns schnellstmöglich über Ihre gewählte Kontaktmethode.",
      successPhone: "+49 176 22038169",
      successOpenWhatsApp: "WhatsApp öffnen",
      successClose: "Schließen",
    },
    booking: {
      flowGetPrice: "Preis anfragen",
      flowBook: "Termin buchen",
      address: "Adresse",
      itemDetails: "Automodell oder Sofa-Details",
      preferredDate: "Wunschdatum",
      preferredTime: "Wunschzeit",
      pickDate: "Datum wählen",
      pickTime: "Zeit wählen",
      booked: "Gebucht",
      blocked: "Nicht verfügbar",
      tooSoon: "Buchungen sind frühestens 8 Tage im Voraus möglich",
      submit: "Termin buchen",
      successTitle: "Danke. Ihre Terminanfrage wurde erhalten",
      successMessage: "Wir bestätigen den Termin innerhalb von 24 Stunden per WhatsApp.",
      noSlot: "Keine verfügbaren Termine an diesem Tag",
      previousMonth: "Vorheriger Monat",
      nextMonth: "Nächster Monat",
      legend: {
        available: "Verfügbar",
        booked: "Gebucht",
        unavailable: "Nicht verfügbar",
      },
    },
    student: {
      loginButton: "Schüler-Login",
      loginTitle: "Schüler-Login",
      loginSubtitle: "Zugriff auf die PUREGLOSS Academy.",
      email: "E-Mail",
      password: "Passwort",
      signIn: "Anmelden",
      signingIn: "Anmeldung läuft...",
      invalidCredentials: "Ungültige E-Mail oder Passwort",
      accountPaused: "Zugang pausiert. Bitte wenden Sie sich an die PUREGLOSS Academy.",
      backToAcademy: "Zurück zur Akademie",
      logout: "Abmelden",
      dashboard: {
        welcome: "Willkommen",
        package: "Paket",
        startDate: "Startdatum",
        progress: "Fortschritt",
        status: "Status",
        completedOf: "abgeschlossen von",
        modulesTitle: "Kursmodule",
        locked: "Gesperrt",
        unlock: "Verfügbar im Paket",
        startLesson: "Starten",
        markCompleted: "Als abgeschlossen markieren",
        markIncomplete: "Markierung zurücknehmen",
        completed: "Abgeschlossen",
        certificateTitle: "Zertifizierung",
        certificateDesc: "Ihr Zertifikat ist nach Bestehen der Abschlussprüfung verfügbar.",
        certificatePending: "Zertifikat verfügbar nach Kursabschluss",
      },
      statusLabels: {
        Active: "Aktiv",
        Paused: "Pausiert",
        Completed: "Abgeschlossen",
      },
    },
    academy: {
      nav: "Akademie",
      eyebrow: "PUREGLOSS Academy",
      title: "PUREGLOSS Akademie",
      subtitle: "Trainingsprogramm für mobile Fahrzeugaufbereitung.\nFür Deutschland, Polen, Ukraine und ganz Europa.",
      coverage: "Geeignet für Studierende aus Deutschland, Polen, Ukraine und anderen europäischen Ländern.",
      hero: {
        cta: "Auf die Warteliste",
        secondary: "Mehr erfahren",
      },
      why: {
        eyebrow: "Warum PUREGLOSS Academy",
        title: "Warum PUREGLOSS Akademie?",
        desc: "Kein gewöhnlicher Online-Kurs — sondern ein vollständiger, professioneller Karriereweg im mobilen Detailing.",
        items: [
          { title: "Praxis-Wissen", desc: "Echte Techniken und Workflows aus der täglichen PUREGLOSS-Arbeit." },
          { title: "Schritt-für-Schritt-Systeme", desc: "Strukturierte Anleitungen, Checklisten und Vorlagen statt zusammenhangloser Videos." },
          { title: "Zertifizierung", desc: "Offizielles PUREGLOSS-Academy-Zertifikat nach erfolgreichem Abschluss." },
          { title: "Community", desc: "Zugang zu einer geschlossenen Community aus Studierenden und Absolventen." },
          { title: "Zukünftige Partnerschaft", desc: "Die besten Studierenden erhalten Zugang zum zukünftigen PUREGLOSS-Netzwerk." },
          { title: "Fertige Workflows", desc: "Kommunikations-, Preis- und Qualitätskontroll-Vorlagen — sofort einsatzbereit." },
          { title: "Fokus auf Mobile Service", desc: "Komplette Schulung ausgelegt auf mobile Fahrzeugaufbereitung." },
          { title: "Karriereweg", desc: "Vom Einsteiger zum eigenen Mobilservice oder PUREGLOSS-Partner." },
        ],
      },
      who: {
        eyebrow: "Zielgruppe",
        title: "Für wen ist dieser Kurs?",
        items: [
          "Zukünftige Detailer",
          "Anfänger ohne Vorkenntnisse",
          "Ukrainische und internationale Studierende",
          "Menschen mit Interesse an praktischen Skills",
          "Zukünftige Inhaber eines Mobilservice",
          "Menschen, die Selbstständigkeit anstreben",
        ],
        note: "Ein eigenes Fahrzeug wird für die mobile Tätigkeit empfohlen, ist aber für die Anmeldung zur Warteliste nicht erforderlich.",
      },
      packages: {
        eyebrow: "Schulungspakete",
        title: "Wählen Sie Ihr Programm",
        desc: "Drei Stufen — vom Grundlagen-Kurs bis zum kompletten Start eines mobilen Detailing-Service.",
        comingSoon: "Demnächst",
        includes: "Enthalten",
        certificate: "Zertifikat",
        foundation: {
          icon: "🥉",
          name: "Foundation",
          oldPrice: "249€",
          newPrice: "149€",
          tagline: "Für absolute Einsteiger.",
          items: [
            "Einführung in mobiles Detailing",
            "Grundlagen der Innenreinigung",
            "Sichere Grundlagen der Außenwäsche",
            "Empfohlene Ausrüstungsliste",
            "Empfohlene Chemikalienliste",
            "Anleitung zur Chemikaliennutzung",
            "Mikrofaser-Guide",
            "Guide zu Bürsten und Zubehör",
            "Preisgestaltung — Grundlagen",
            "Kundenkommunikation — Grundlagen",
            "Überblick über den Service-Workflow",
            "PDF-Checklisten",
            "Wissenstest",
            "PUREGLOSS Foundation-Zertifikat",
          ],
          note: "Keine praktische Schulung.",
          certificateName: "PUREGLOSS Foundation-Zertifikat",
        },
        professional: {
          icon: "🥈",
          name: "Professional",
          oldPrice: "499€",
          newPrice: "349€",
          badge: "popular",
          tagline: "Alles aus Foundation plus:",
          items: [
            "Fortgeschrittene Innenreinigung",
            "Sitzreinigung",
            "Teppichreinigung",
            "Kunststoffpflege",
            "Lederpflege",
            "Sofa- und Polsterreinigung — Grundlagen",
            "Sicherer Umgang mit Chemikalien",
            "Vorher/Nachher-Foto-Guide",
            "Fahrzeugvorbereitung zum Verkauf",
            "Zeit-Kalkulationssystem",
            "Preis-Kalkulationssystem",
            "Wie man die ersten Kunden findet",
            "Flyer-Strategie",
            "Visitenkarten-Strategie",
            "Strategie für lokale Plattformen",
            "Google Business Profile — Einrichtungs-Guide",
            "Google Indexierungs-Guide",
            "Skripte für die Kundenkommunikation",
            "Case-Study-Review",
            "Praktische Aufgaben",
            "50 % Rabatt auf Website-Erstellung durch PUREGLOSS",
          ],
          certificateName: "PUREGLOSS Professional-Zertifikat",
        },
        elite: {
          icon: "👑",
          name: "Elite",
          oldPrice: "999€",
          newPrice: "749€",
          badge: "premium",
          tagline: "Alles aus Professional plus:",
          items: [
            "Persönliches Mentoring",
            "Reale Workflow-Beispiele",
            "Qualitätskontroll-Systeme",
            "Geschäftsprozess-Systeme",
            "Termin-Management",
            "Profit-Kalkulation",
            "Systeme für Stammkunden",
            "Kundenbindungs-Systeme",
            "Vorbereitung auf das zukünftige PUREGLOSS-Netzwerk",
            "Bevorzugte Zertifikatsverifizierung",
            "Praktische Schulung mit Mentor (falls verfügbar)",
            "KOSTENLOSE PUREGLOSS One-Page-Website",
            "Persönlicher Support für Google Business Profile",
            "Persönlicher Support für Google-Indexierung",
          ],
          certificateName: "PUREGLOSS Elite-Zertifikat",
        },
      },
      polishingDisclaimer: "Politur und Lackpflege werden ausschließlich als theoretische Einführung behandelt. Praktische Lackkorrektur ist nicht Bestandteil des Kurses.",
      certification: {
        eyebrow: "Zertifizierung",
        title: "Zertifizierung & Abschlussprüfung",
        desc: "Alle Studierenden müssen eine Abschlussprüfung bestehen, bevor sie das offizielle PUREGLOSS-Academy-Zertifikat erhalten.",
        items: [
          "Theorieprüfung",
          "Wissensverifizierung",
          "Verständnis der Prozesse",
          "Verständnis des Kunden-Workflows",
        ],
        award: "Nach erfolgreichem Abschluss erhält der Studierende:",
        awardName: "PUREGLOSS Academy-Zertifikat",
      },
      career: {
        eyebrow: "Karriere",
        title: "Chancen nach der Ausbildung",
        desc: "Die besten Studierenden erhalten möglicherweise zukünftigen Zugang zu:",
        items: [
          "PUREGLOSS Certified Detailer Programm",
          "PUREGLOSS Partner-Netzwerk",
          "Featured Detailer-Profil",
          "Zukünftige Kundenempfehlungen",
          "Zukünftige Kooperationsmöglichkeiten",
        ],
        note: "Wir garantieren keine Anstellung — dies sind zukünftige Möglichkeiten nach erfolgreichem Abschluss.",
      },
      notIncluded: {
        eyebrow: "Nicht enthalten",
        title: "Was ist nicht enthalten?",
        items: [
          "Chemikalien-Produkte",
          "Starter-Kit",
          "Einrichtung bezahlter Werbung",
          "Praxis der fortgeschrittenen Lackkorrektur",
          "Öffentliches PUREGLOSS Detailer-Konto",
        ],
      },
      waitlist: {
        eyebrow: "Warteliste",
        title: "Anfrage senden",
        desc: "Hinterlassen Sie Ihre Kontaktdaten — wir informieren Sie über den Start und bieten frühzeitigen Zugang.",
        name: "Name",
        phone: "Telefon",
        email: "Email",
        country: "Land",
        language: "Kurssprache",
        package: "Interessantes Paket",
        message: "Nachricht",
        submit: "Anmelden",
        sending: "Wird gesendet...",
        successTitle: "Vielen Dank!",
        successMessage: "Ihre Anfrage wurde empfangen. Wir melden uns in Kürze.",
        error: "Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
        gdpr: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu.",
      },
      future: {
        title: "Bald in der Akademie",
        items: ["Videolektionen", "Kursmodule", "Zertifikate", "Studentendashboard", "Kurskäufe"],
      },
      pricing: {
        oldLabel: "Alter Preis",
        currentLabel: "Aktueller Preis",
        badgePopular: "BELIEBTESTE",
        badgePremium: "PREMIUM-PROGRAMM",
        save: "Ersparnis",
      },
      cohort: {
        eyebrow: "🔥 Erster Jahrgang",
        title: "Erster PUREGLOSS Academy Jahrgang",
        desc: "Nur die ersten 20 Studierenden gehören zum initialen Academy-Launch.",
        note: "Nach Abschluss des ersten Jahrgangs können später neue Anmeldephasen geöffnet werden.",
      },
      bonuses: {
        eyebrow: "🎁 Bonus für Studierende",
        title: "Bonus für Studierende",
        desc: "Alles inklusive — Praxis-Materialien, die Ihnen wochenlange Arbeit ersparen.",
        items: [
          "PUREGLOSS PDF-Checklisten",
          "Skripte für die Kundenkommunikation",
          "Empfohlene Chemikalien-Listen",
          "Empfohlene Ausrüstungs-Listen",
          "Preisberechnungs-Vorlagen",
          "Workflow-Vorlagen",
        ],
      },
      certificatePreview: {
        eyebrow: "🏅 Zertifikat",
        title: "PUREGLOSS Academy Zertifikat",
        subtitle: "Jeder erfolgreiche Studierende erhält ein offizielles PUREGLOSS Academy-Zertifikat nach Bestehen der Abschlussprüfung.",
        alt: "Vorschau PUREGLOSS Academy-Zertifikat",
      },
      earnings: {
        eyebrow: "💰 Verdienstpotenzial",
        title: "Verdienstpotenzial Mobile Fahrzeugaufbereitung",
        desc: "Beispielrechnungen bei kontinuierlicher Auslastung:",
        items: [
          { vehicles: "1 Fahrzeug pro Tag", income: "≈ 1.780€/Monat" },
          { vehicles: "2 Fahrzeuge pro Tag", income: "≈ 3.560€/Monat" },
          { vehicles: "3 Fahrzeuge pro Tag", income: "≈ 5.340€/Monat" },
        ],
        disclaimer:
          "Ergebnisse hängen von Land, Preisgestaltung, Nachfrage, Servicequalität und Kundenanzahl ab. Es werden keine Einkommensgarantien gegeben.",
      },
      network: {
        eyebrow: "🚀 PUREGLOSS Network",
        title: "PUREGLOSS Network",
        desc: "Top-Absolventen können zukünftige Möglichkeiten erhalten, wie:",
        items: [
          "PUREGLOSS Certified Detailer Status",
          "Platzierung im zukünftigen PUREGLOSS Network",
          "Zukünftige Kundenempfehlungen",
          "Potenzielle Kooperationsmöglichkeiten mit PUREGLOSS",
        ],
        note: "Wir versprechen keine Anstellung — dies sind zukünftige Möglichkeiten.",
      },
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Kontaktieren Sie uns",
    },
    brands: {
      eyebrow: "Premium Ausrüstung",
      title: "Premium Produkte & Ausrüstung",
      desc: "Für professionelle Ergebnisse verwenden wir hochwertige Produkte und Geräte führender Marken.",
      items: [
        { name: "Koch-Chemie", category: "Detailing-Chemie" },
        { name: "Kärcher", category: "Profi-Geräte" },
      ],
    },
    footer: {
      tagline: "Detailing & Sofa Cleaning",
      area: "Servicegebiet",
      rights: "Alle Rechte vorbehalten.",
      legal: "Rechtliches",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      agb: "AGB",
      widerruf: "Widerruf",
      cookies: "Cookies",
      madeIn: "Gemacht mit ★ in Euskirchen",
      verifiedCustomer: "Verifizierter Kunde",
    },
    admin: {
      title: "Admin · Leads",
      password: "Passwort",
      signIn: "Anmelden",
      invalidPassword: "Falsches Passwort",
      back: "Zurück zur Website",
      logout: "Abmelden",
      refresh: "Aktualisieren",
      tabs: {
        overview: "Übersicht",
        auto: "Auto",
        furniture: "Möbel",
        bookings: "Buchungen",
        newsletter: "Newsletter",
        detailers: "Detailer",
        clients: "Kunden",
        academy: "Akademie",
        calendar: "Kalender",
      },
      stats: {
        autoNew: "Neue Auto",
        furnitureNew: "Neue Möbel",
        inProgress: "In Bearbeitung",
        scheduled: "Geplant",
        completed: "Abgeschlossen",
        rejected: "Abgelehnt",
        completedMonth: "Abgeschlossen diesen Monat",
        completedYear: "Abgeschlossen dieses Jahr",
        revenue: "Geschätzter Umsatz",
        aov: "Durchschnittlicher Bestellwert",
        totalLeads: "Leads gesamt",
        activeLeads: "Aktive Leads",
        conversion: "Konversion",
        bookings: "Buchungen",
        leadVolume: "Lead-Volumen — Letzte 14 Tage",
        revenueVolume: "Umsatzprognose — Letzte 14 Tage (€)",
        topCities: "Top Städte",
        topServices: "Top Leistungen",
        recentLeads: "Aktuelle Leads",
        leadsCount: "Anzahl Leads",
        revenueEur: "Umsatz",
        noData: "Keine Daten",
      },
      statusLabels: {
        NEW: "Neu",
        IN_PROGRESS: "In Bearbeitung",
        SCHEDULED: "Geplant",
        COMPLETED: "Abgeschlossen",
        REJECTED: "Abgelehnt",
      },
      academyStatusLabels: {
        NEW: "Neu",
        CONTACTED: "Kontaktiert",
        ENROLLED: "Eingeschrieben",
        GRADUATED: "Absolviert",
        REJECTED: "Abgelehnt",
      },
      card: {
        phone: "Telefon",
        email: "Email",
        city: "Stadt",
        service: "Leistung",
        carModel: "Auto",
        package: "Paket",
        message: "Nachricht",
        photos: "Fotos",
        status: "Status",
        estimatedPrice: "Geschätzter Preis",
        detailer: "Detailer",
        whatsapp: "WhatsApp",
        call: "Anrufen",
        emailAction: "E-Mail senden",
        telegram: "Telegram",
        preferredContact: "Kontaktmethode",
        edit: "Bearbeiten",
        delete: "Löschen",
        duplicate: "Duplizieren",
        internalNotes: "Interne Notizen",
        internalNotesPlaceholder: "Nur Admin — z. B. Anrufen nach 18:00, VIP-Kunde...",
        createdAt: "Erstellt",
        updatedAt: "Aktualisiert",
        editLead: "Lead bearbeiten",
        saveChanges: "Änderungen speichern",
        cancel: "Abbrechen",
        deleteLeadTitle: "Lead löschen?",
        deleteLeadDesc: "Sind Sie sicher, dass Sie diesen Lead dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        deleteConfirm: "Löschen",
        leadDeletedToast: "Lead erfolgreich gelöscht.",
        leadUpdatedToast: "Lead erfolgreich aktualisiert.",
        leadDuplicatedToast: "Lead dupliziert.",
        priceUpdatedToast: "Preis aktualisiert.",
        notesSavedToast: "Notizen gespeichert.",
        actionFailedToast: "Aktion fehlgeschlagen. Bitte erneut versuchen.",
        clickToEditPrice: "Zum Bearbeiten klicken",
        priceInvalid: "Bitte gültige Zahl (€) eingeben",
        emailInvalid: "Bitte gültige E-Mail eingeben",
        phoneInvalid: "Bitte gültige Telefonnummer eingeben",
        nameRequired: "Name ist erforderlich",
        phoneRequired: "Telefon ist erforderlich",
        detailerNone: "— Kein Detailer —",
        estimatedPriceHint: "Beispiel: 89, 149, 399",
        serviceHint: "Freitext: z. B. Lederrestaurierung, Motorreinigung...",
        history: "Verlauf",
        notSet: "nicht gesetzt",
        viewPhotos: "Fotos ansehen",
        unread: "NEU",
        empty: "Keine Anfragen.",
        leadType: "Typ",
        leadTypeAuto: "Auto",
        leadTypeFurniture: "Möbel",
        leadTypeAcademy: "Akademie",
        leadTypeBooking: "Buchung",
        date: "Datum",
        customer: "Kunde",
        all: "Alle",
        sort: "Sortieren",
        assignDetailer: "Detailer zuweisen",
        requestReview: "Bewertung anfragen",
        address: "Adresse",
        item: "Objekt",
        sendWhatsApp: "Per WhatsApp senden",
        sendEmail: "Per E-Mail senden",
        copyLink: "Link kopieren",
        copied: "Kopiert",
        close: "Schließen",
      },
      sorts: {
        newest: "Neueste zuerst",
        oldest: "Älteste zuerst",
        priceDesc: "Höchster Preis",
        priceAsc: "Niedrigster Preis",
        city: "Stadt A→Z",
        detailer: "Detailer",
        bookingDate: "Buchungsdatum",
      },
      detailers: {
        title: "Detailer",
        id: "ID",
        name: "Name",
        completedJobs: "Abgeschlossen",
        revenue: "Umsatz",
        commission: "Provision",
        rating: "Bewertung",
        status: "Status",
        active: "aktiv",
        inactive: "inaktiv",
      },
      newsletterTable: {
        email: "Email",
        lang: "Sprache",
        source: "Quelle",
        created: "Datum",
        empty: "Noch keine Abonnenten.",
      },
      clients: {
        title: "Kunden",
        search: "Suche nach Name, Telefon oder E-Mail…",
        levels: "Bronze 1-2 · Silver 3-4 · Gold 5+ abgeschlossene Aufträge",
        name: "Name",
        orders: "Aufträge",
        completed: "Abgeschlossen",
        revenue: "Umsatz",
        level: "Stufe",
      },
      academy: {
        title: "Akademie — Warteliste",
        empty: "Noch keine Anfragen.",
        package: "Paket",
        language: "Sprache",
        totalLabel: "Warteliste gesamt",
        interestedLabel: "Interessierte Studierende",
        enrolledLabel: "Eingeschrieben",
        graduatedLabel: "Absolventen",
        byLanguageLabel: "Nach Sprache",
      },
      students: {
        tab: "Studierende",
        title: "Akademie-Studierende",
        empty: "Noch keine Studierenden.",
        add: "Studierenden hinzufügen",
        edit: "Bearbeiten",
        delete: "Löschen",
        resetPassword: "Passwort zurücksetzen",
        activate: "Studierenden aktivieren",
        copyMessage: "Nachricht kopieren",
        copied: "Kopiert",
        cols: {
          studentId: "ID",
          name: "Name",
          email: "E-Mail",
          package: "Paket",
          status: "Status",
          startDate: "Start",
          progress: "Fortschritt",
          actions: "Aktionen",
        },
        form: {
          name: "Name",
          email: "E-Mail",
          password: "Passwort",
          newPassword: "Neues Passwort",
          packageType: "Paket",
          startDate: "Startdatum",
          status: "Status",
          save: "Speichern",
          cancel: "Abbrechen",
          create: "Erstellen",
        },
        statusLabels: {
          Active: "Aktiv",
          Paused: "Pausiert",
          Completed: "Abgeschlossen",
        },
        accessMessage:
          "Ihr Zugang zur PUREGLOSS Academy ist aktiv.\nMelden Sie sich hier an:\nhttps://puregloss.eu/academy/login\n\nE-Mail:\n{email}\n\nPasswort:\n{password}",
      },
      calendar: {
        title: "Buchungskalender",
        legendAvailable: "Verfügbar",
        legendBooked: "Gebucht",
        legendUnavailable: "Nicht verfügbar",
        blockDay: "Tag blockieren",
        unblock: "Freigeben",
        blocked: "Blockiert",
        bookings: "Buchungen",
      },
      pgApps: {
        stats: {
          total: "Gesamt",
          new: "Neu",
          inReview: "In Prüfung",
          approved: "Genehmigt",
          rejected: "Abgelehnt",
        },
        roles: {
          all: "Alle",
          drivers: "Fahrer",
          detailers: "Detailer",
          partners: "Partner",
          driver: "Fahrer",
          detailer: "Detailer",
          partner: "Partner",
        },
        statuses: {
          allStatuses: "Alle Status",
          new: "Neu",
          in_review: "In Prüfung",
          approved: "Genehmigt",
          rejected: "Abgelehnt",
        },
        sort: {
          newest: "Neueste zuerst",
          oldest: "Älteste zuerst",
        },
        searchPlaceholder: "Suchen…",
        refresh: "Aktualisieren",
        table: {
          nameCompany: "Name / Firma",
          role: "Rolle",
          location: "Standort",
          email: "E-Mail",
          status: "Status",
          submitted: "Eingereicht",
          empty: "Keine Bewerbungen",
        },
        detail: {
          loading: "Laden…",
          close: "Schließen",
          fields: {
            company: "Firma",
            businessType: "Geschäftstyp",
            contactPerson: "Ansprechpartner",
            email: "E-Mail",
            phone: "Telefon",
            locations: "Standorte",
            country: "Land",
            city: "Stadt",
            website: "Website",
            googleMaps: "Google Maps",
            social: "Social",
            fullName: "Vollständiger Name",
            experience: "Erfahrung",
            services: "Leistungen",
            training: "Ausbildung",
            academyTrainer: "Akademie / Trainer",
            instagram: "Instagram",
            facebook: "Facebook",
            portfolio: "Portfolio",
            vehicle: "Fahrzeug",
            heardAbout: "Erfahren über",
            motivation: "Motivation",
            businessDescription: "Firmenbeschreibung",
            servicesToOffer: "Angebotene Leistungen",
            language: "Sprache",
            submitted: "Eingereicht",
            updated: "Aktualisiert",
            applicationId: "Bewerbungs-ID",
          },
          adminNotes: "Admin-Notizen",
          saveNotes: "Notizen speichern",
          saved: "Gespeichert",
          saveFailed: "Fehlgeschlagen",
          actions: {
            email: "E-Mail",
            call: "Anrufen",
            whatsapp: "WhatsApp",
            instagram: "Instagram",
            facebook: "Facebook",
            website: "Website",
            maps: "Maps",
            portfolio: "Portfolio",
            copy: "Kopieren",
            copied: "Kopiert",
          },
          delete: {
            button: "Bewerbung löschen",
            title: "Diese Bewerbung löschen?",
            desc: "Die Bewerbung wird dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
            confirm: "Löschen",
            cancel: "Abbrechen",
            deleting: "Löschen…",
            deleted: "Bewerbung gelöscht",
            failed: "Löschen fehlgeschlagen",
          },
        },
      },

    },
    legal: {
      impressum: {
        title: "Impressum",
        subtitle: "Angaben gemäß § 5 DDG",
        sections: [
          {
            h: "Diensteanbieter (§ 5 DDG)",
            p: "PUREGLOSS\nInhaber: Vladyslav Lysyi\nRechtsform: Einzelunternehmen\nRüdesheimer Ring 129\n53879 Euskirchen\nDeutschland",
          },
          {
            h: "Kontakt",
            p: "Telefon: +49 176 22038169\nWhatsApp: +49 176 22038169\nE-Mail: info@puregloss.eu\nWebsite: https://puregloss.eu",
          },
          {
            h: "Umsatzsteuer-Identifikationsnummer",
            p: "Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:\nDE367513046",
          },
          {
            h: "Redaktionell verantwortlich",
            p: "Redaktionell verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV:\nVladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Deutschland",
          },
          {
            h: "EU-Streitschlichtung",
            p: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr\nUnsere E-Mail-Adresse finden Sie oben im Impressum.",
          },
          {
            h: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
            p: "Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle im Sinne des § 36 Verbraucherstreitbeilegungsgesetz (VSBG) teilzunehmen.",
          },
          {
            h: "Haftung für Inhalte",
            p: "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.",
          },
          {
            h: "Haftung für Links",
            p: "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
          },
          {
            h: "Urheberrecht",
            p: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
          },
        ],
        back: "Zurück zur Startseite",
      },
      datenschutz: {
        title: "Datenschutzerklärung",
        subtitle: "DSGVO / BDSG-neu / TTDSG",
        sections: [
          {
            h: "1. Verantwortlicher",
            p: "Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129\n53879 Euskirchen\nDeutschland\nTelefon: +49 176 22038169\nE-Mail: info@puregloss.eu",
          },
          {
            h: "2. Allgemeine Hinweise",
            p: "Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO, BDSG-neu, TTDSG) sowie dieser Datenschutzerklärung. Personenbezogene Daten werden nur erhoben, verarbeitet und genutzt, soweit dies zur Erfüllung unserer vertraglichen und gesetzlichen Pflichten erforderlich ist oder Sie ausdrücklich eingewilligt haben.",
          },
          {
            h: "3. SSL/TLS-Verschlüsselung",
            p: "Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://\" auf „https://\" wechselt und am Schloss-Symbol in Ihrer Browserzeile.",
          },
          {
            h: "4. Server-Logfiles / Hosting",
            p: "Diese Website wird bei Emergent Labs, Inc. gehostet. Der Anbieter erhebt in sog. Server-Logfiles automatisch Informationen, die Ihr Browser übermittelt: IP-Adresse (gekürzt gespeichert), Datum und Uhrzeit der Anfrage, angeforderte URL, Referrer-URL, verwendeter Browser und Betriebssystem. Diese Daten sind nicht bestimmten Personen zuordenbar und dienen ausschließlich der technischen Bereitstellung, Sicherheit und Fehleranalyse. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und funktionsfähigen Website). Speicherdauer: max. 30 Tage.",
          },
          {
            h: "5. Kontaktaufnahme (E-Mail, Telefon, WhatsApp)",
            p: "Wenn Sie uns per E-Mail, Telefon oder Messenger kontaktieren, werden Ihre Angaben (Name, Kontaktdaten, Nachricht) zur Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Anbahnung / Erfüllung eines Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse). Löschung erfolgt, sobald der Zweck entfallen ist, spätestens nach Ablauf gesetzlicher Aufbewahrungspflichten (§ 257 HGB, § 147 AO – bis zu 10 Jahre).",
          },
          {
            h: "6. Anfrage-/Angebotsformular",
            p: "Über unser Formular können Sie ein unverbindliches Angebot anfordern. Verarbeitet werden: Name, Telefonnummer, E-Mail (optional), Stadt/Ort, Fahrzeug-/Objektangaben, hochgeladene Fotos, bevorzugte Kontaktart und Ihre Nachricht. Diese Daten werden ausschließlich zur Angebotserstellung und Terminabstimmung verwendet. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Speicherdauer: bis zur endgültigen Erledigung Ihrer Anfrage bzw. Ablauf der gesetzlichen Aufbewahrungsfristen.",
          },
          {
            h: "7. Buchungsformular",
            p: "Bei einer verbindlichen Buchung erheben wir zusätzlich Ihre Wunsch-Adresse (Servicestandort), das gewählte Datum sowie die gewählte Uhrzeit. Diese Daten sind zur Erbringung des mobilen Detailing-/Reinigungsservices zwingend erforderlich. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).",
          },
          {
            h: "8. WhatsApp",
            p: "Auf unserer Website befinden sich Buttons, die eine direkte Kommunikation über WhatsApp (WhatsApp Ireland Limited, 4 Grand Canal Square, Dublin, Irland – Teil des Meta-Konzerns) ermöglichen. Erst mit dem Klick auf einen WhatsApp-Button wird eine Verbindung zu den Servern von WhatsApp/Meta hergestellt und Ihre Nachricht sowie Ihre Telefonnummer an WhatsApp übertragen. Ein Teil der Datenverarbeitung findet außerhalb der EU (u. a. USA) statt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch aktiven Klick) sowie Art. 6 Abs. 1 lit. b DSGVO. Details zur Verarbeitung durch WhatsApp: https://www.whatsapp.com/legal/privacy-policy-eea. Wenn Sie nicht möchten, dass Ihre Daten an WhatsApp übermittelt werden, nutzen Sie bitte E-Mail oder Telefon.",
          },
          {
            h: "9. PUREGLOSS CLUB (Bonusprogramm)",
            p: "Beim Beitritt zum PUREGLOSS CLUB verarbeiten wir: Name (optional), E-Mail-Adresse, Sprachpräferenz, Zeitpunkt des Beitritts sowie einen automatisch generierten Gutscheincode. Zweck: Ausstellung und Verwaltung des einmaligen 25 €-Willkommensgutscheins, Bereitstellung des zugehörigen PDF-Gutscheins, Nachweis der Einwilligung, sowie unmittelbare Kundenkommunikation im Zusammenhang mit dem Bonusprogramm. Rechtsgrundlage: Art. 6 Abs. 1 lit. a und lit. b DSGVO (Einwilligung sowie Anbahnung des Servicevertrages). Sie können Ihre Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen (info@puregloss.eu). Speicherung: bis zum Widerruf; bei Einlösung/Ablauf des Gutscheins zusätzlich zur Erfüllung gesetzlicher Aufbewahrungspflichten.",
          },
          {
            h: "10. Newsletter / Aktionen",
            p: "Für den Versand von Aktions-Informationen speichern wir Ihre E-Mail-Adresse, den Zeitpunkt der Einwilligung sowie zum Nachweis Ihre IP-Adresse und den User-Agent des Browsers. Die Anmeldung erfolgt ausschließlich nach aktiver Bestätigung der GDPR-Einwilligungscheckbox. Sie können den Newsletter jederzeit durch formlose Nachricht an info@puregloss.eu abbestellen; wir löschen Ihre Daten dann unverzüglich, spätestens innerhalb von 7 Tagen. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.",
          },
          {
            h: "11. E-Mail-Versand (Resend)",
            p: "Zum Versand transaktionaler und werblicher E-Mails setzen wir den Dienst Resend (Resend, Inc., 2261 Market Street #5039, San Francisco, CA 94114, USA) ein. Dabei werden Ihre E-Mail-Adresse, der Nachrichteninhalt und Zustellungs-Metadaten (Zeitstempel, Bounce-Status) verarbeitet. Es besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO. Übermittlung in ein Drittland (USA): abgesichert durch EU-Standardvertragsklauseln und weitere geeignete Garantien nach Art. 46 DSGVO. Weitere Informationen: https://resend.com/legal/privacy-policy.",
          },
          {
            h: "12. Cookies und lokale Speicherung",
            p: "Diese Website verwendet ausschließlich technisch notwendige lokale Speicherung („localStorage\") zur Sicherstellung der Grundfunktionen (u. a. Speicherung der Sprachauswahl, Anzeige-Status des CLUB-Popups, Cookie-Präferenz). Diese Daten verbleiben in Ihrem Browser und werden nicht an uns übertragen. Es werden KEINE Marketing- oder Tracking-Cookies, keine Analyse-Cookies und keine Cookies von Drittanbietern gesetzt. Rechtsgrundlage: § 25 Abs. 2 Nr. 2 TTDSG (unbedingt erforderlich).",
          },
          {
            h: "13. Schriftarten",
            p: "Zur einheitlichen Darstellung setzen wir die Schriftart „Cabinet Grotesk\" ein, die über den Dienst Fontshare (Indian Type Foundry Pvt. Ltd., Ahmedabad, Indien) ausgeliefert wird. Beim Aufruf der Seite wird eine Verbindung zu den Servern von Fontshare hergestellt, wobei Ihre IP-Adresse übertragen werden kann. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer ansprechenden Darstellung). Google Fonts werden nicht mehr eingesetzt; alle übrigen Schriften werden lokal aus dem Betriebssystem des Nutzers geladen (System-Fonts), sodass insoweit keine Übertragung an Dritte erfolgt.",
          },
          {
            h: "14. Bildmaterial",
            p: "Auf dieser Website werden Vorher-/Nachher-Fotos, Portfolio-Aufnahmen und Stockfotos verwendet. Personenbezogene Merkmale (Kennzeichen, Personen im Fahrzeug) werden unkenntlich gemacht oder vor Veröffentlichung entfernt.",
          },
          {
            h: "15. Datei-Uploads",
            p: "Fotos, die Sie über das Anfrageformular hochladen, werden auf unserer Infrastruktur gespeichert und ausschließlich zur Angebotserstellung verwendet. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Löschung erfolgt spätestens 12 Monate nach Erledigung Ihrer Anfrage.",
          },
          {
            h: "16. Empfänger / Weitergabe an Dritte",
            p: "Eine Weitergabe Ihrer personenbezogenen Daten an Dritte findet ausschließlich statt an: unseren E-Mail-Versanddienstleister (Resend), unseren Hosting-Provider (Emergent Labs, Inc.) sowie – soweit Sie das nutzen – WhatsApp/Meta. Alle Anbieter sind vertraglich zur Einhaltung der DSGVO verpflichtet. Eine Weitergabe zu Werbezwecken an sonstige Dritte findet NICHT statt.",
          },
          {
            h: "17. Speicherdauer",
            p: "Personenbezogene Daten werden nur so lange gespeichert, wie es zur Zweckerreichung erforderlich ist oder gesetzliche Aufbewahrungspflichten dies vorschreiben (i. d. R. 6 Jahre nach § 257 HGB, 10 Jahre nach § 147 AO für steuer- und handelsrelevante Unterlagen). Danach werden die Daten routinemäßig gelöscht.",
          },
          {
            h: "18. Ihre Rechte als betroffene Person",
            p: "Sie haben nach der DSGVO folgende Rechte gegenüber uns:\n• Recht auf Auskunft (Art. 15 DSGVO)\n• Recht auf Berichtigung (Art. 16 DSGVO)\n• Recht auf Löschung („Recht auf Vergessenwerden\", Art. 17 DSGVO)\n• Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)\n• Recht auf Datenübertragbarkeit (Art. 20 DSGVO)\n• Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)\n• Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)\n\nZur Ausübung Ihrer Rechte genügt eine formlose Nachricht an info@puregloss.eu.",
          },
          {
            h: "19. Beschwerderecht bei der Aufsichtsbehörde",
            p: "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Zuständige Aufsichtsbehörde für unseren Sitz ist:\n\nLandesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)\nKavalleriestraße 2-4, 40213 Düsseldorf\nTelefon: +49 211 38424-0\nE-Mail: poststelle@ldi.nrw.de\nhttps://www.ldi.nrw.de",
          },
          {
            h: "20. Aktualität dieser Datenschutzerklärung",
            p: "Diese Datenschutzerklärung ist aktuell gültig. Durch Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Fassung kann jederzeit unter https://puregloss.eu/datenschutz abgerufen werden.",
          },
          {
            h: "21. Sicherheitsprotokoll bei Anmeldungen (PUREGLOSS Club)",
            p: "Bei jeder neuen Anmeldung zum PUREGLOSS Club speichern wir zusätzlich zu den von Ihnen angegebenen Daten technische Informationen zur Sicherheit, zum Betrugsschutz, zur Spam-Abwehr und zur Missbrauchserkennung. Dies umfasst: Ihre IP-Adresse, eine ungefähre Standortangabe (Land, Region, ungefähre Stadt) auf Basis dieser IP-Adresse — niemals eine genaue Position —, Informationen zu Ihrem Browser und Gerät (User-Agent, Betriebssystem, Gerätetyp) sowie den Zeitpunkt der Anmeldung. Die Standortangabe ist stets nur ungefähr und wird nicht zur individuellen Identifizierung verwendet. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und missbrauchsfreien Bereitstellung des Angebots). Diese Angaben sind ausschließlich intern einsehbar und werden nicht an Dritte weitergegeben, ausgenommen den technisch notwendigen IP-Geolokalisierungsdienst.",
          },
        ],
        back: "Zurück zur Startseite",
      },
      agb: {
        title: "Allgemeine Geschäftsbedingungen",
        subtitle: "AGB · Stand Februar 2026",
        sections: [
          {
            h: "§ 1 Geltungsbereich",
            p: "(1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen (nachfolgend „Anbieter\") und Verbrauchern bzw. Unternehmern (nachfolgend „Kunde\") über die auf https://puregloss.eu angebotenen Leistungen (mobile Fahrzeugaufbereitung, Innen- und Außenreinigung, Polster- und Sofareinigung).\n(2) Abweichende, entgegenstehende oder ergänzende AGB des Kunden werden nur dann Vertragsbestandteil, wenn der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.",
          },
          {
            h: "§ 2 Vertragsschluss",
            p: "(1) Die Präsentation der Leistungen auf der Website stellt kein rechtlich bindendes Angebot dar, sondern eine Aufforderung zur Abgabe eines Angebots (invitatio ad offerendum).\n(2) Der Kunde übermittelt über das Anfrage- oder Buchungsformular eine unverbindliche Anfrage. Der Anbieter erstellt daraufhin ein individuelles Angebot per E-Mail, Telefon oder WhatsApp.\n(3) Der Vertrag kommt erst mit ausdrücklicher Annahme des Angebots durch beide Seiten (schriftlich, per E-Mail oder Messenger) bzw. mit Erbringung der Leistung durch den Anbieter zustande.",
          },
          {
            h: "§ 3 Leistungsumfang",
            p: "Der genaue Leistungsumfang ergibt sich aus dem individuellen Angebot. Fahrzeug- und Objektzustand können den tatsächlichen Aufwand und damit den finalen Preis beeinflussen; wesentliche Preisanpassungen werden vor Ausführung mit dem Kunden abgestimmt.",
          },
          {
            h: "§ 4 Preise und Zahlung",
            p: "(1) Alle Preise verstehen sich in Euro inklusive der gesetzlichen Umsatzsteuer.\n(2) Die Zahlung erfolgt vor Ort nach Leistungserbringung in bar oder – sofern angeboten – per Kartenzahlung/Sofortüberweisung.\n(3) Bei Zahlungsverzug gelten die gesetzlichen Regelungen (§§ 286 ff. BGB).",
          },
          {
            h: "§ 5 Terminvereinbarung, Absage, Verspätung",
            p: "(1) Termine werden verbindlich per E-Mail oder Messenger bestätigt.\n(2) Der Kunde kann einen bestätigten Termin bis 24 Stunden vor Beginn kostenfrei absagen oder verschieben. Bei späteren Absagen kann eine Ausfallpauschale von 50 % des vereinbarten Preises erhoben werden.\n(3) Sollte der Anbieter aus wichtigem Grund (Krankheit, Wetter, höhere Gewalt) den Termin nicht wahrnehmen können, wird umgehend ein Ersatztermin angeboten.",
          },
          {
            h: "§ 6 Mitwirkungspflichten des Kunden",
            p: "Der Kunde stellt einen geeigneten Arbeitsplatz zur Verfügung (Zugang zum Fahrzeug/Objekt, ausreichender Platz, Wasseranschluss bei Bedarf, Stromanschluss 230 V). Persönliche Gegenstände sind vor Beginn der Arbeiten aus dem Fahrzeug/Objekt zu entfernen.",
          },
          {
            h: "§ 7 Gewährleistung und Haftung",
            p: "(1) Es gelten die gesetzlichen Gewährleistungsrechte.\n(2) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen.\n(3) Bei einfacher Fahrlässigkeit haftet der Anbieter – außer im Falle der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) – nicht. Die Haftung ist in diesem Fall auf den vertragstypisch vorhersehbaren Schaden begrenzt.\n(4) Für bereits vor Auftragserteilung vorhandene Schäden (z. B. Lackkratzer, Chip-Schäden, verhärtete Stoff-/Lederflecken) übernimmt der Anbieter keine Haftung. Solche Vorschäden werden auf Wunsch vor Beginn dokumentiert.",
          },
          {
            h: "§ 8 Widerrufsrecht für Verbraucher",
            p: "Verbraucher haben ein gesetzliches Widerrufsrecht nach § 312g i. V. m. § 355 BGB. Einzelheiten entnehmen Sie bitte unserer Widerrufsbelehrung.",
          },
          {
            h: "§ 9 Streitbeilegung",
            p: "Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: https://ec.europa.eu/consumers/odr. Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder bereit noch verpflichtet.",
          },
          {
            h: "§ 10 Schlussbestimmungen",
            p: "(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.\n(2) Erfüllungsort ist Euskirchen. Gerichtsstand ist – soweit gesetzlich zulässig – der Sitz des Anbieters.\n(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
          },
        ],
        back: "Zurück zur Startseite",
      },
      widerruf: {
        title: "Widerrufsbelehrung",
        subtitle: "Ihre Rechte als Verbraucher",
        sections: [
          {
            h: "Widerrufsrecht",
            p: "Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.\n\nUm Ihr Widerrufsrecht auszuüben, müssen Sie uns\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Deutschland\nTelefon: +49 176 22038169\nE-Mail: info@puregloss.eu\n\nmittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das nachstehende Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.\n\nZur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.",
          },
          {
            h: "Folgen des Widerrufs",
            p: "Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.",
          },
          {
            h: "Vorzeitiges Erlöschen des Widerrufsrechts bei Dienstleistungen",
            p: "Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen auch dann, wenn der Unternehmer die Dienstleistung vollständig erbracht hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem der Verbraucher dazu seine ausdrückliche Zustimmung gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, dass er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch den Unternehmer verliert (§ 356 Abs. 4 BGB).",
          },
          {
            h: "Muster-Widerrufsformular",
            p: "(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)\n\nAn: PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen, Deutschland, E-Mail: info@puregloss.eu\n\nHiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*):\n\n___________________________________\n\nBestellt am (*)/erhalten am (*):\n___________________________________\n\nName des/der Verbraucher(s):\n___________________________________\n\nAnschrift des/der Verbraucher(s):\n___________________________________\n\nDatum: _______________\n\nUnterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):\n___________________________________\n\n(*) Unzutreffendes streichen.",
          },
        ],
        back: "Zurück zur Startseite",
      },
      cookies: {
        title: "Cookie-Richtlinie",
        subtitle: "Cookies & lokale Speicherung",
        sections: [
          {
            h: "1. Grundsatz",
            p: "Diese Website verwendet KEINE Tracking-, Marketing- oder Drittanbieter-Cookies. Es werden keine Analyse-Tools wie Google Analytics, Google Tag Manager, Meta-Pixel oder ähnliche Dienste eingesetzt. Wir verwenden ausschließlich technisch notwendige lokale Speicherung („localStorage\"), die Ihr Browser bereitstellt.",
          },
          {
            h: "2. Zweck der lokalen Speicherung",
            p: "Wir speichern lokal in Ihrem Browser:\n• die von Ihnen gewählte Sprache (z. B. DE/EN/UA)\n• den Status, ob Sie dem PUREGLOSS CLUB beigetreten sind (damit das Popup nicht erneut erscheint)\n• Ihre bevorzugte Anzeige (z. B. zuletzt aktiver Formularmodus)\n\nDiese Daten verlassen niemals Ihren Browser und werden NICHT an unsere Server oder Dritte übertragen.",
          },
          {
            h: "3. Rechtsgrundlage",
            p: "Die genannte Speicherung ist zur bestimmungsgemäßen Bereitstellung der Website unbedingt erforderlich (§ 25 Abs. 2 Nr. 2 TTDSG) und benötigt daher keine gesonderte Einwilligung.",
          },
          {
            h: "4. Löschung / Widerspruch",
            p: "Sie können die lokale Speicherung jederzeit über die Einstellungen Ihres Browsers löschen (z. B. Chrome → Einstellungen → Datenschutz und Sicherheit → Browserdaten löschen → „Cookies und andere Websitedaten\"). Nach der Löschung erhält die Website ihre Grundeinstellungen (z. B. Standardsprache).",
          },
          {
            h: "5. Externe Dienste",
            p: "Wenn Sie aktiv auf einen WhatsApp-Button klicken, verlassen Sie unsere Seite und begeben sich in eine Umgebung, in der WhatsApp/Meta eigene Cookies setzen kann. Wir haben darauf keinen Einfluss. Details siehe unsere Datenschutzerklärung, Abschnitt WhatsApp.",
          },
        ],
        back: "Zurück zur Startseite",
      },
    },
  },

  en: {
    seo: {
      title: "PUREGLOSS — Mobile Auto Detailing & Sofa Cleaning Euskirchen",
      description:
        "Mobile car detailing and professional sofa cleaning. Euskirchen • Bonn • Brühl • Wesseling • Cologne • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen and surrounding areas. Free quote within 1 hour.",
      keywords:
        "Auto Detailing Euskirchen, Mobile Detailing Euskirchen, Autoaufbereitung Euskirchen, Sofa Cleaning Euskirchen, Polsterreinigung Euskirchen, upholstery cleaning",
    },
    nav: {
      home: "Home",
      services: "Services",
      beforeAfter: "Before & After",
      reviews: "Reviews",
      prices: "Prices",
      serviceArea: "Service Area",
      promotions: "Promotions",
      faq: "FAQ",
      contact: "Contact",
      academy: "Academy",
      works: "Our Work",
      club: "PUREGLOSS CLUB",
      cta: "WhatsApp",
    },
    cta: {
      getPrice: "Get Price",
      getPriceShort: "Price",
      bookAppointment: "Book Appointment",
      bookAppointmentShort: "Book",
      checkAvailability: "Check availability in your city",
      joinWaitingList: "Join Waiting List",
      whatsapp: "WhatsApp",
      readyTitle: "Ready to start?",
      readyDesc: "Get a quick quote or book your appointment.",
    },
    promotions: {
      eyebrow: "Promotions & Special Offers",
      title: "Promotions & Special Offers",
      desc: "Be the first to know about seasonal discounts, packages and exclusive PUREGLOSS premium deals.",
      nameLabel: "Name (optional)",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      cta: "Subscribe",
      gdpr: "I agree to receive marketing emails according to the",
      successTitle: "Thank you!",
      successMessage: "You have been added to the PUREGLOSS offers list.",
      error: "Subscription failed. Please try again.",
    },
    ctaBlocks: {
      services: { title: "Ready to start?", desc: "Get a quick quote or book your appointment.", primary: "Get Price", secondary: "Book Appointment" },
      pricing: { title: "Picked a package?", desc: "Book a slot or request a precise quote.", primary: "Get Price", secondary: "Book Appointment" },
      serviceArea: { title: "We come to you", desc: "Check availability in your city.", primary: "Check availability", secondary: "Book Appointment" },
      academy: { title: "PUREGLOSS Academy", desc: "Learn mobile detailing in Germany. Seats open soon.", primary: "Join Waiting List" },
    },
    serviceAreaMap: {
      title: "Service Area",
      desc: "Mobile service in Euskirchen, Köln, Bonn and surrounding cities.",
      mobileTag: "Mobile service — we come to you",
      cityAvailability: "Mobile service at your location",
    },
    trustBadge: "Free quote within 1 hour",
    floatingEstimate: "Free estimate via request",
    basedIn: "Based in Euskirchen",
    whatsappConsent: {
      eyebrow: "Privacy notice",
      title: "You are about to open WhatsApp",
      body: "By confirming, your phone number and message will be transmitted to WhatsApp Ireland Ltd. (Meta). Part of the processing takes place outside the EU (USA).",
      details: "Legal basis: Art. 6 (1) (a) GDPR (consent). Full details in our",
      datenschutzLink: "Privacy Policy",
      confirm: "Continue to WhatsApp",
      cancel: "Cancel",
      close: "Close",
    },
    fullAreaText:
      "Euskirchen • Bonn • Brühl • Wesseling • Cologne • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen and surrounding areas",
    hero: {
      eyebrow: "Mobile Detailing • Euskirchen",
      title: "PUREGLOSS",
      subtitle: "Detailing & Sofa Cleaning",
      desc: "Mobile car detailing and professional sofa cleaning — we come to you.",
      ctaPrimary: "Get a Quote",
      ctaSecondary: "Message on WhatsApp",
      scroll: "Scroll",
    },
    area: {
      label: "Service Area",
      suffix: "& surrounding area",
    },
    services: {
      eyebrow: "Services",
      title: "Premium care for your car and furniture",
      desc: "Professional mobile service — everything you need to make your things look flawless again.",
      vehicleTitle: "Vehicle Detailing",
      vehicleItems: [
        "Interior detailing",
        "Seat cleaning",
        "Leather care",
        "Odor removal",
        "Hand wash",
        "Wheel cleaning",
        "Tire care",
        "Pre-sale preparation",
      ],
      sofaTitle: "Sofa & Upholstery Cleaning",
      sofaItems: [
        "Sofas",
        "Armchairs",
        "Mattresses",
        "Upholstered furniture",
        "Stain removal",
        "Odor removal",
        "Deep cleaning",
        "Carpet cleaning",
      ],
    },
    pricing: {
      eyebrow: "Pricing",
      title: "Transparent prices",
      auto: "Auto",
      polishing: "Paint Correction & Polishing",
      furniture: "Furniture",
      from: "from",
      items: {
        auto: [
          { name: "Interior cleaning", price: "49€" },
          { name: "Exterior cleaning", price: "39€" },
          { name: "Complete package", price: "89€" },
          { name: "Pre-sale preparation", price: "119€" },
        ],
        furniture: [
          { name: "Armchair", price: "25€" },
          { name: "2-Seater Sofa", price: "49€" },
          { name: "3-Seater Sofa", price: "69€" },
          { name: "Corner Sofa", price: "99€" },
          { name: "Mattress", price: "39€" },
        ],
      },
      note: "The exact price depends on the condition of the car or furniture. Send us photos for a free estimate.",
      lockedBadge: "VERY SOON",
      lockedTitle: "Paint Correction & Polishing",
      lockedDesc:
        "Professional paint correction and machine polishing service is currently unavailable but will be launched soon.",
      lockedDisabled: "Booking temporarily unavailable",
      ctaGetEstimate: "Get Estimate",
      lockedItems: [
        { name: "One-Step Polish", price: "149€" },
        { name: "Two-Step Polish", price: "249€" },
        { name: "Three-Step Polish", price: "349€" },
      ],
    },
    stats: [
      { value: "100%", label: "Mobile Service" },
      { value: "PRO", label: "Premium Products" },
      { value: "24/7", label: "Flexible Appointments" },
      { value: "★★★★★", label: "Professional Results" },
    ],
    beforeAfter: {
      eyebrow: "Results",
      title: "Before & After",
      desc: "Drag the slider to see the difference.",
      categories: { cars: "Cars", sofas: "Sofas" },
      beforeLabel: "Before",
      afterLabel: "After",
    },
    instaProof: {
      eyebrow: "Portfolio",
      title: "Our real work",
      desc: "View real PUREGLOSS results: cars, sofas, mattresses and other before/after work.",
      stats: ["Real clients", "Before / after photos", "New work every week"],
      cta: "View all work",
      handle: "@puregloss.eu",
    },
    serviceLabels: {
      Innenraum: "Interior",
      "Außenreinigung": "Exterior Cleaning",
      Sitzreinigung: "Seat Cleaning",
      Lederpflege: "Leather Care",
      Felgenreinigung: "Wheel Cleaning",
      Politur: "Polishing",
      Scheinwerfer: "Headlights",
    },
    furnitureServiceLabels: {
      Sofa: "Sofa",
      Matratze: "Mattress",
      Sessel: "Armchair",
      "Stühle": "Chairs",
      Bürostuhl: "Office Chair",
      Teppich: "Carpet",
      Polster: "Upholstery",
    },
    brandLabels: {
      Audi: "Audi", BMW: "BMW", "Mercedes-Benz": "Mercedes-Benz",
      Porsche: "Porsche", Volkswagen: "Volkswagen", Tesla: "Tesla",
      Skoda: "Skoda", Ford: "Ford", Opel: "Opel", Toyota: "Toyota",
      Hyundai: "Hyundai", Other: "Other",
    },
    furnitureTypeLabels: {
      "2-Sitzer Sofa": "2-Seater Sofa",
      "3-Sitzer Sofa": "3-Seater Sofa",
      Ecksofa: "Corner Sofa",
      Matratze: "Mattress",
      Sessel: "Armchair",
      Stuhl: "Chair",
      Bürostuhl: "Office Chair",
      Teppich: "Carpet",
      Other: "Other",
    },
    works: {
      heroTitle: "Our Work",
      heroSubtitle: "Real results from our car, sofa, mattress and upholstery cleaning.",
      empty: "Works will be added soon.",
      filterAll: "All",
      filterCategory: "Category",
      filterService: "Service",
      filterBrand: "Brand",
      filterType: "Furniture type",
      catVehicle: "Vehicles",
      catFurniture: "Furniture",
      viewBtn: "View",
      getPriceCta: "Get Price",
      beforeLabel: "Before",
      afterLabel: "After",
      cityLabel: "City",
      serviceLabel: "Service",
      brandLabel: "Brand",
      modelLabel: "Model",
      typeLabel: "Type",
      descriptionLabel: "Description",
      sliderHint: "Drag to compare",
      beforeGallery: "Before photos",
      afterGallery: "After photos",
      close: "Close",
      photoSoon: "Photo will be added soon",
      getSameServiceCta: "Get my quote",
      likeResultTitle: "Like the result?",
      likeResultDesc: "We can achieve the same result for your vehicle or furniture.",
      ctaFreeQuote: "Get free estimate",
      ctaBookSlot: "Book appointment",
    },
    club: {
      title: "Welcome to PUREGLOSS CLUB",
      subtitle: "Unlock exclusive perks and become a member — for free.",
      benefit1: "🎁 €25 welcome voucher from €100 order value",
      benefit2: "⚡ Early access to promotions and special offers",
      benefit3: "👑 Exclusive PUREGLOSS CLUB member benefits",
      benefit4: "",
      nameLabel: "Name (optional)",
      emailLabel: "Email",
      gdpr: "I consent to the processing of my data according to the Privacy Policy.",
      joinCta: "Join for free",
      joining: "Processing...",
      finePrint: "Voucher valid for 6 months, single use. Minimum order value €100.",
      close: "Close",
      alreadyRegistered: "This email is already registered in PUREGLOSS CLUB.",
      genericError: "Could not join. Please try again.",
      emailInvalid: "Please enter a valid email",
      gdprRequired: "Please accept the Privacy Policy",
      successTitle: "Welcome to PUREGLOSS CLUB!",
      successMessage: "Your €25 welcome voucher is active. It applies to any PUREGLOSS service with a minimum order value of €100.",
      successCta: "Request a free estimate",
    },
    clubAdmin: {
      tab: "PUREGLOSS CLUB",
      empty: "No club members yet.",
      filterAll: "All",
      filterActive: "Active",
      filterUsed: "Used",
      filterExpired: "Expired",
      filterEmailNotSent: "Email not sent",
      filterEmailSent: "Email sent",
      searchPlaceholder: "Search by name, email or voucher code",
      newMemberBtn: "New Member",
      newMemberTitle: "Create club member",
      sendWelcomeCheckbox: "Send Welcome Email now",
      createBtn: "Create",
      redeemBtn: "Redeem Voucher",
      redeemTitle: "Redeem voucher?",
      redeemDesc: "The status will change to \"Used\" and the redemption date will be recorded.",
      redeemConfirm: "Redeem",
      redeemed: "Voucher redeemed.",
      regenerateBtn: "Regenerate PDF",
      regenerated: "PDF voucher regenerated.",
      emptySearch: "No results for your search.",
      colName: "Name",
      colEmail: "Email",
      colJoined: "Joined",
      colBonusStart: "Bonus start",
      colBonusEnd: "Bonus end",
      colBonus: "Welcome Bonus",
      colCondition: "Condition",
      colSecond: "2nd cleaning",
      colVoucherCode: "Voucher code",
      colStatus: "Status",
      colEmailStatus: "Email",
      statusActive: "active",
      statusUsed: "used",
      statusExpired: "expired",
      emailNotSent: "not sent",
      emailSent: "sent",
      emailFailed: "failed",
      markUsed: "Mark as used",
      markActive: "Mark as active",
      markExpired: "Mark as expired",
      editBtn: "Edit",
      deleteBtn: "Delete",
      sendWelcome: "Send Welcome Email",
      deleteTitle: "Delete club member?",
      deleteDesc: "Are you sure you want to delete this club member?",
      deleteConfirm: "Delete",
      cancel: "Cancel",
      resendNotConnected: "Email dispatch will be connected via Resend in the next step.",
      emailSentToast: "Welcome email sent successfully.",
      emailFailedToast: "Email send failed",
      updated: "Member updated.",
      deleted: "Member deleted.",
      actionFailed: "Action failed.",
      editTitle: "Edit member",
      notesLabel: "Notes",
      saveBtn: "Save",
    },
    worksAdmin: {
      tab: "Works",
      addBtn: "Add work",
      editBtn: "Edit",
      deleteBtn: "Delete",
      publish: "Published",
      draft: "Draft",
      statusLabel: "Status",
      createTitle: "New work",
      editTitle: "Edit work",
      titleField: "Title",
      titlePlaceholder: "e.g. BMW M3 — Full interior detail",
      categoryField: "Category",
      serviceField: "Service",
      brandField: "Vehicle brand",
      modelField: "Model",
      furnitureTypeField: "Furniture type",
      cityField: "City",
      descriptionField: "Short description",
      beforePhotos: "Before photos (up to 5)",
      afterPhotos: "After photos (up to 5)",
      uploadBtn: "Upload photos",
      selectPlaceholder: "— Select —",
      cancel: "Cancel",
      save: "Save",
      empty: "No works yet. Click 'Add work' to create the first.",
      deleteTitle: "Delete work?",
      deleteDesc: "Are you sure you want to delete this work? This action cannot be undone.",
      workCreated: "Work created.",
      workUpdated: "Work updated.",
      workDeleted: "Work deleted.",
      actionFailed: "Action failed.",
      maxPhotos: "Maximum 5 photos.",
      requiredCategory: "Please select a category",
      uploadFailed: "Photo upload failed: ",
      unsupportedFile: "Unsupported file: ",
      supportedFormats: "Allowed: JPG, PNG, WEBP",
      uploadingProgress: "Uploading {done}/{total}...",
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What our clients say",
      items: [
        { text: "After the pre-sale preparation, the car looked much better and sold faster.", author: "Andreas K.", city: "Köln" },
        { text: "We were going to throw away the sofa, but after cleaning it looks fresh again.", author: "Marina S.", city: "Bonn" },
        { text: "Very convenient that the service comes to your home. Everything done neatly.", author: "Thomas L.", city: "Euskirchen" },
        { text: "Fair price, great result and professional approach.", author: "Olena P.", city: "Brühl" },
        { text: "I recommend PUREGLOSS. Will book again.", author: "Markus B.", city: "Hürth" },
      ],
    },
    howItWorks: {
      eyebrow: "How it works",
      title: "Simple process",
      steps: [
        "You send photos",
        "You receive an estimate",
        "We pick a convenient time",
        "We come to you",
        "You enjoy the result",
      ],
    },
    newsletter: {
      eyebrow: "Newsletter",
      title: "Don't miss promotions and special offers",
      placeholder: "your@email.com",
      cta: "Subscribe",
      thanks: "Thanks for subscribing!",
      gdpr: "I consent to the processing of my data according to the Privacy Policy.",
      error: "Subscription failed. Please try again.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How much does car cleaning cost?", a: "Prices start from 39€ for exterior and 49€ for interior. Full package from 89€. The exact price depends on the condition." },
        { q: "How long does cleaning take?", a: "Usually 2–5 hours, depending on the condition and the chosen package." },
        { q: "Do I need to drive anywhere?", a: "No. We are a mobile service and come to your home or office with all the equipment." },
        { q: "Do you clean sofas, mattresses and carpets?", a: "Yes. We clean sofas, armchairs, mattresses, corner sofas, carpets, and other upholstered furniture." },
        { q: "Can you clean only the seats?", a: "Yes. We offer partial cleaning — e.g., only front seats or the trunk." },
        { q: "Do you remove odors?", a: "Yes. We use professional products to remove smells — smoke, pets, food." },
        { q: "Which areas do you serve?", a: "Euskirchen • Bonn • Brühl • Wesseling • Cologne • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen and surrounding areas." },
        { q: "How do I book a service?", a: "Fill the form on the website or message us on WhatsApp. We'll confirm a convenient time within an hour." },
        { q: "How can I get an exact price?", a: "Send us a few photos via WhatsApp — we'll reply within an hour. Quote is free." },
        { q: "What payment methods do you accept?", a: "Cash, bank transfer, or PayPal. Payment after the job is completed." },
      ],
    },
    quote: {
      eyebrow: "Quote Request",
      title: "Get a free quote",
      desc: "Fill out the form — we'll open WhatsApp with your message. Reply within 1 hour.",
      name: "Name",
      phone: "Phone Number",
      city: "City",
      cityPlaceholder: "—",
      serviceType: "Service Type",
      message: "Message",
      photos: "Photos (optional)",
      photosHint: "Add photos — after clicking, WhatsApp will open so you can attach them",
      submit: "Get a quote",
      successHint: "WhatsApp will open shortly",
      serviceOptions: [
        "Interior Detailing",
        "Exterior Detailing",
        "Full Detailing",
        "Sofa Cleaning",
        "Mattress Cleaning",
        "Carpet Cleaning",
      ],
      cityOther: "Other / surrounding area",
      uploading: "Uploading...",
      emailLabel: "Email",
      preferredContactLabel: "Preferred contact method",
      preferredContactPlaceholder: "Select method",
      preferredContactRequired: "Please select your preferred contact method",
      preferredContactOptions: ["WhatsApp", "Telegram", "Email", "Phone"],
      gdpr: "I consent to the processing of my data according to the Privacy Policy.",
      submitError: "Could not send your request. Please try again.",
      successTitle: "Thank you for your request!",
      successMessage: "Your request has been received and is now being processed. We will contact you shortly using your selected contact method.",
      successPhone: "+49 176 22038169",
      successOpenWhatsApp: "Open WhatsApp",
      successClose: "Close",
    },
    booking: {
      flowGetPrice: "Get Price",
      flowBook: "Book Appointment",
      address: "Address",
      itemDetails: "Car model or sofa details",
      preferredDate: "Preferred date",
      preferredTime: "Preferred time",
      pickDate: "Pick a date",
      pickTime: "Pick a time",
      booked: "Booked",
      blocked: "Unavailable",
      tooSoon: "Appointments require 8+ days lead time",
      submit: "Book Appointment",
      successTitle: "Thank you. Your appointment request has been received",
      successMessage: "We will confirm the appointment via WhatsApp within 24 hours.",
      noSlot: "No available slots on this day",
      previousMonth: "Previous month",
      nextMonth: "Next month",
      legend: {
        available: "Available",
        booked: "Booked",
        unavailable: "Unavailable",
      },
    },
    student: {
      loginButton: "Student Login",
      loginTitle: "Student Login",
      loginSubtitle: "Access to PUREGLOSS Academy.",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      signingIn: "Signing in...",
      invalidCredentials: "Invalid email or password",
      accountPaused: "Account is paused. Please contact PUREGLOSS Academy.",
      backToAcademy: "Back to Academy",
      logout: "Logout",
      dashboard: {
        welcome: "Welcome",
        package: "Package",
        startDate: "Start date",
        progress: "Progress",
        status: "Status",
        completedOf: "completed of",
        modulesTitle: "Course modules",
        locked: "Locked",
        unlock: "Available in",
        startLesson: "Start",
        markCompleted: "Mark as completed",
        markIncomplete: "Unmark",
        completed: "Completed",
        certificateTitle: "Certification",
        certificateDesc: "Your certificate will be available after passing the final examination.",
        certificatePending: "Certificate available after completing the course",
      },
      statusLabels: {
        Active: "Active",
        Paused: "Paused",
        Completed: "Completed",
      },
    },
    academy: {
      nav: "Academy",
      eyebrow: "PUREGLOSS Academy",
      title: "PUREGLOSS Academy",
      subtitle: "Mobile Car Detailing Training Program.\nFor Germany, Poland, Ukraine and across Europe.",
      coverage: "Suitable for students from Germany, Poland, Ukraine and other European countries.",
      hero: {
        cta: "Join Waiting List",
        secondary: "Learn more",
      },
      why: {
        eyebrow: "Why PUREGLOSS Academy",
        title: "Why PUREGLOSS Academy?",
        desc: "Not just another online course — a complete professional career path in mobile detailing.",
        items: [
          { title: "Real-world knowledge", desc: "Practical techniques and workflows from PUREGLOSS daily operations." },
          { title: "Step-by-step systems", desc: "Structured instructions, checklists and templates — not random videos." },
          { title: "Certification", desc: "Official PUREGLOSS Academy certificate upon successful completion." },
          { title: "Community access", desc: "Join a private community of students and graduates." },
          { title: "Future partnership", desc: "Top students may gain future access to the PUREGLOSS Network." },
          { title: "Business-ready workflows", desc: "Communication, pricing and quality-control templates ready to use." },
          { title: "Mobile detailing focus", desc: "Full curriculum tailored to mobile service operations." },
          { title: "Career path", desc: "From beginner to your own mobile service or PUREGLOSS partner." },
        ],
      },
      who: {
        eyebrow: "Who is it for",
        title: "Who is this course for?",
        items: [
          "Future detailers",
          "Beginners with no experience",
          "Ukrainians and international students",
          "People looking for practical skills",
          "Future mobile-service owners",
          "People aiming for self-employment",
        ],
        note: "A personal vehicle is recommended for mobile work but is not required for joining the waiting list.",
      },
      packages: {
        eyebrow: "Training Packages",
        title: "Choose your program",
        desc: "Three levels — from foundations to launching a complete mobile detailing service.",
        comingSoon: "Coming Soon",
        includes: "Includes",
        certificate: "Certificate",
        foundation: {
          icon: "🥉",
          name: "Foundation",
          oldPrice: "249€",
          newPrice: "149€",
          tagline: "For complete beginners.",
          items: [
            "Introduction to mobile detailing",
            "Interior cleaning fundamentals",
            "Safe exterior washing basics",
            "Recommended equipment list",
            "Recommended chemical list",
            "Chemical usage instructions",
            "Microfiber guide",
            "Brushes and accessories guide",
            "Pricing basics",
            "Customer communication basics",
            "Service workflow overview",
            "PDF checklists",
            "Knowledge test",
            "PUREGLOSS Foundation Certificate",
          ],
          note: "No practical training.",
          certificateName: "PUREGLOSS Foundation Certificate",
        },
        professional: {
          icon: "🥈",
          name: "Professional",
          oldPrice: "499€",
          newPrice: "349€",
          badge: "popular",
          tagline: "Everything from Foundation plus:",
          items: [
            "Advanced interior cleaning",
            "Seats cleaning",
            "Carpet cleaning",
            "Plastic care",
            "Leather care",
            "Sofa and upholstery basics",
            "Safe chemical handling",
            "Before / after photography guide",
            "Vehicle sale preparation",
            "Time estimation system",
            "Pricing estimation system",
            "How to find first clients",
            "Flyers strategy",
            "Business card strategy",
            "Local platform strategy",
            "Google Business Profile setup guide",
            "Google indexing guide",
            "Client communication scripts",
            "Case study review",
            "Practical assignments",
            "50% discount on PUREGLOSS website creation",
          ],
          certificateName: "PUREGLOSS Professional Certificate",
        },
        elite: {
          icon: "👑",
          name: "Elite",
          oldPrice: "999€",
          newPrice: "749€",
          badge: "premium",
          tagline: "Everything from Professional plus:",
          items: [
            "Personal mentoring",
            "Real workflow examples",
            "Quality control systems",
            "Business process systems",
            "Appointment management",
            "Profit calculation",
            "Repeat customer systems",
            "Client retention systems",
            "Preparing for future PUREGLOSS Network",
            "Priority certificate verification",
            "Practical training with mentor when available",
            "FREE PUREGLOSS one-page website",
            "Personal support for Google Business Profile setup",
            "Personal support for Google indexing setup",
          ],
          certificateName: "PUREGLOSS Elite Certificate",
        },
      },
      polishingDisclaimer: "Polishing and paint care are covered only as a theoretical introduction. Practical paint correction is not part of the course.",
      certification: {
        eyebrow: "Certification",
        title: "Certification & Final Examination",
        desc: "All students must pass a final assessment before receiving the official PUREGLOSS Academy certificate.",
        items: [
          "Theory examination",
          "Knowledge verification",
          "Process understanding",
          "Customer workflow understanding",
        ],
        award: "After successful completion the student receives:",
        awardName: "PUREGLOSS Academy Certificate",
      },
      career: {
        eyebrow: "Career",
        title: "Opportunities After Training",
        desc: "The best students may receive future access to:",
        items: [
          "PUREGLOSS Certified Detailer Program",
          "PUREGLOSS Partner Network",
          "Featured Detailer Profile",
          "Future customer referrals",
          "Future cooperation opportunities",
        ],
        note: "We do not guarantee jobs — these are future opportunities after successful completion.",
      },
      notIncluded: {
        eyebrow: "Not included",
        title: "What is not included",
        items: [
          "Chemical products",
          "Starter kit",
          "Paid advertising setup",
          "Advanced paint correction practice",
          "Public PUREGLOSS detailer account",
        ],
      },
      waitlist: {
        eyebrow: "Waiting List",
        title: "Join the waiting list",
        desc: "Leave your contact and we'll notify you when classes open — with early-bird access.",
        name: "Name",
        phone: "Phone",
        email: "Email",
        country: "Country",
        language: "Class language",
        package: "Interested package",
        message: "Message",
        submit: "Join",
        sending: "Sending...",
        successTitle: "Thank you!",
        successMessage: "Your request has been received. We'll be in touch shortly.",
        error: "Could not send your request. Please try again.",
        gdpr: "I consent to the processing of my data according to the Privacy Policy.",
      },
      future: {
        title: "Coming soon in Academy",
        items: ["Video lessons", "Course modules", "Certificates", "Student dashboard", "Course purchases"],
      },
      pricing: {
        oldLabel: "Old price",
        currentLabel: "Current price",
        badgePopular: "MOST POPULAR",
        badgePremium: "PREMIUM PROGRAM",
        save: "Save",
      },
      cohort: {
        eyebrow: "🔥 First cohort",
        title: "First PUREGLOSS Academy Cohort",
        desc: "Only the first 20 students will join the initial Academy launch.",
        note: "After the first cohort is completed, new enrollment periods may be opened later.",
      },
      bonuses: {
        eyebrow: "🎁 Student Bonuses",
        title: "Student Bonuses",
        desc: "Everything included — ready-to-use materials that save you weeks of work.",
        items: [
          "PUREGLOSS PDF Checklists",
          "Client Communication Scripts",
          "Recommended Chemical Product Lists",
          "Recommended Equipment Lists",
          "Pricing Calculation Templates",
          "Service Workflow Templates",
        ],
      },
      certificatePreview: {
        eyebrow: "🏅 Certificate",
        title: "PUREGLOSS Academy Certificate",
        subtitle: "Every successful student receives an official PUREGLOSS Academy Certificate after passing the final assessment.",
        alt: "PUREGLOSS Academy certificate preview",
      },
      earnings: {
        eyebrow: "💰 Income Potential",
        title: "Mobile Detailing Income Potential",
        desc: "Example calculations at a consistent schedule:",
        items: [
          { vehicles: "1 vehicle per day", income: "≈ 1,780€/month" },
          { vehicles: "2 vehicles per day", income: "≈ 3,560€/month" },
          { vehicles: "3 vehicles per day", income: "≈ 5,340€/month" },
        ],
        disclaimer:
          "Results depend on country, pricing, market demand, service quality, and number of clients. No income guarantees are made.",
      },
      network: {
        eyebrow: "🚀 PUREGLOSS Network",
        title: "PUREGLOSS Network",
        desc: "Top-performing graduates may receive future opportunities such as:",
        items: [
          "PUREGLOSS Certified Detailer Status",
          "Placement inside future PUREGLOSS Network",
          "Future client recommendations",
          "Potential cooperation opportunities with PUREGLOSS",
        ],
        note: "We do not promise employment — these are future opportunities.",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Get in touch",
    },
    brands: {
      eyebrow: "Premium Equipment",
      title: "Premium Products & Equipment",
      desc: "For professional results, we use premium products and equipment from leading brands.",
      items: [
        { name: "Koch-Chemie", category: "Detailing chemistry" },
        { name: "Kärcher", category: "Professional equipment" },
      ],
    },
    footer: {
      tagline: "Detailing & Sofa Cleaning",
      area: "Service Area",
      rights: "All rights reserved.",
      legal: "Legal",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      agb: "Terms",
      widerruf: "Withdrawal",
      cookies: "Cookies",
      madeIn: "Made with ★ in Euskirchen",
      verifiedCustomer: "Verified Customer",
    },
    admin: {
      title: "Admin · Leads",
      password: "Password",
      signIn: "Sign in",
      invalidPassword: "Invalid password",
      back: "Back to site",
      logout: "Logout",
      refresh: "Refresh",
      tabs: {
        overview: "Overview",
        auto: "Auto",
        furniture: "Furniture",
        bookings: "Bookings",
        newsletter: "Newsletter",
        detailers: "Detailers",
        clients: "Clients",
        academy: "Academy",
        calendar: "Calendar",
      },
      stats: {
        autoNew: "New auto",
        furnitureNew: "New furniture",
        inProgress: "In progress",
        scheduled: "Scheduled",
        completed: "Completed",
        rejected: "Rejected",
        completedMonth: "Completed this month",
        completedYear: "Completed this year",
        revenue: "Estimated revenue",
        aov: "Average order value",
        totalLeads: "Total leads",
        activeLeads: "Active leads",
        conversion: "Conversion",
        bookings: "Bookings",
        leadVolume: "Lead Volume — Last 14 days",
        revenueVolume: "Estimated Revenue — Last 14 days (€)",
        topCities: "Top cities",
        topServices: "Top services",
        recentLeads: "Recent leads",
        leadsCount: "Lead count",
        revenueEur: "Revenue",
        noData: "No data",
      },
      statusLabels: {
        NEW: "New",
        IN_PROGRESS: "In progress",
        SCHEDULED: "Scheduled",
        COMPLETED: "Completed",
        REJECTED: "Rejected",
      },
      academyStatusLabels: {
        NEW: "New",
        CONTACTED: "Contacted",
        ENROLLED: "Enrolled",
        GRADUATED: "Graduated",
        REJECTED: "Rejected",
      },
      card: {
        phone: "Phone",
        email: "Email",
        city: "City",
        service: "Service",
        carModel: "Car",
        package: "Package",
        message: "Message",
        photos: "Photos",
        status: "Status",
        estimatedPrice: "Estimated price",
        detailer: "Detailer",
        whatsapp: "WhatsApp",
        call: "Call",
        emailAction: "Send email",
        telegram: "Telegram",
        preferredContact: "Contact method",
        edit: "Edit",
        delete: "Delete",
        duplicate: "Duplicate",
        internalNotes: "Internal notes",
        internalNotesPlaceholder: "Admin only — e.g. Call after 18:00, VIP customer, bring extractor...",
        createdAt: "Created",
        updatedAt: "Last modified",
        editLead: "Edit lead",
        saveChanges: "Save changes",
        cancel: "Cancel",
        deleteLeadTitle: "Delete lead?",
        deleteLeadDesc: "Are you sure you want to permanently delete this lead? This action cannot be undone.",
        deleteConfirm: "Delete",
        leadDeletedToast: "Lead deleted successfully.",
        leadUpdatedToast: "Lead updated successfully.",
        leadDuplicatedToast: "Lead duplicated.",
        priceUpdatedToast: "Price updated.",
        notesSavedToast: "Notes saved.",
        actionFailedToast: "Action failed. Please try again.",
        clickToEditPrice: "Click to edit",
        priceInvalid: "Please enter a valid number (€)",
        emailInvalid: "Please enter a valid email",
        phoneInvalid: "Please enter a valid phone",
        nameRequired: "Name is required",
        phoneRequired: "Phone is required",
        detailerNone: "— No detailer —",
        estimatedPriceHint: "Example: 89, 149, 399",
        serviceHint: "Free text: e.g. Leather restoration, Engine cleaning...",
        history: "History",
        notSet: "not set",
        viewPhotos: "View photos",
        unread: "NEW",
        empty: "No requests yet.",
        leadType: "Type",
        leadTypeAuto: "Auto",
        leadTypeFurniture: "Furniture",
        leadTypeAcademy: "Academy",
        leadTypeBooking: "Booking",
        date: "Date",
        customer: "Customer",
        all: "All",
        sort: "Sort",
        assignDetailer: "Assign detailer",
        requestReview: "Request review",
        address: "Address",
        item: "Item",
        sendWhatsApp: "Send via WhatsApp",
        sendEmail: "Send via Email",
        copyLink: "Copy link",
        copied: "Copied",
        close: "Close",
      },
      sorts: {
        newest: "Newest first",
        oldest: "Oldest first",
        priceDesc: "Highest price",
        priceAsc: "Lowest price",
        city: "City A→Z",
        detailer: "Detailer",
        bookingDate: "Booking date",
      },
      detailers: {
        title: "Detailers",
        id: "ID",
        name: "Name",
        completedJobs: "Completed",
        revenue: "Revenue",
        commission: "Commission",
        rating: "Rating",
        status: "Status",
        active: "active",
        inactive: "inactive",
      },
      newsletterTable: {
        email: "Email",
        lang: "Language",
        source: "Source",
        created: "Date",
        empty: "No subscribers yet.",
      },
      clients: {
        title: "Clients",
        search: "Search by name, phone or email…",
        levels: "Bronze 1-2 · Silver 3-4 · Gold 5+ completed orders",
        name: "Name",
        orders: "Orders",
        completed: "Completed",
        revenue: "Revenue",
        level: "Level",
      },
      academy: {
        title: "Academy — Waiting List",
        empty: "No entries yet.",
        package: "Package",
        language: "Language",
        totalLabel: "Waiting list total",
        interestedLabel: "Interested students",
        enrolledLabel: "Enrolled",
        graduatedLabel: "Graduates",
        byLanguageLabel: "By language",
      },
      students: {
        tab: "Students",
        title: "Academy Students",
        empty: "No students yet.",
        add: "Add student",
        edit: "Edit",
        delete: "Delete",
        resetPassword: "Reset password",
        activate: "Activate Student",
        copyMessage: "Copy message",
        copied: "Copied",
        cols: {
          studentId: "ID",
          name: "Name",
          email: "Email",
          package: "Package",
          status: "Status",
          startDate: "Start",
          progress: "Progress",
          actions: "Actions",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          newPassword: "New password",
          packageType: "Package",
          startDate: "Start date",
          status: "Status",
          save: "Save",
          cancel: "Cancel",
          create: "Create",
        },
        statusLabels: {
          Active: "Active",
          Paused: "Paused",
          Completed: "Completed",
        },
        accessMessage:
          "Your PUREGLOSS Academy access is active.\nLogin here:\nhttps://puregloss.eu/academy/login\n\nEmail:\n{email}\n\nPassword:\n{password}",
      },
      calendar: {
        title: "Booking Calendar",
        legendAvailable: "Available",
        legendBooked: "Booked",
        legendUnavailable: "Unavailable",
        blockDay: "Block day",
        unblock: "Unblock",
        blocked: "Blocked",
        bookings: "Bookings",
      },
      pgApps: {
        stats: {
          total: "Total",
          new: "New",
          inReview: "In Review",
          approved: "Approved",
          rejected: "Rejected",
        },
        roles: {
          all: "All",
          drivers: "Drivers",
          detailers: "Detailers",
          partners: "Partners",
          driver: "Driver",
          detailer: "Detailer",
          partner: "Partner",
        },
        statuses: {
          allStatuses: "All statuses",
          new: "New",
          in_review: "In Review",
          approved: "Approved",
          rejected: "Rejected",
        },
        sort: {
          newest: "Newest first",
          oldest: "Oldest first",
        },
        searchPlaceholder: "Search…",
        refresh: "Refresh",
        table: {
          nameCompany: "Name / Company",
          role: "Role",
          location: "Location",
          email: "Email",
          status: "Status",
          submitted: "Submitted",
          empty: "No applications",
        },
        detail: {
          loading: "Loading…",
          close: "Close",
          fields: {
            company: "Company",
            businessType: "Business type",
            contactPerson: "Contact person",
            email: "Email",
            phone: "Phone",
            locations: "Locations",
            country: "Country",
            city: "City",
            website: "Website",
            googleMaps: "Google Maps",
            social: "Social",
            fullName: "Full name",
            experience: "Experience",
            services: "Services",
            training: "Training",
            academyTrainer: "Academy / trainer",
            instagram: "Instagram",
            facebook: "Facebook",
            portfolio: "Portfolio",
            vehicle: "Vehicle",
            heardAbout: "Heard about",
            motivation: "Motivation",
            businessDescription: "Business description",
            servicesToOffer: "Services to offer",
            language: "Language",
            submitted: "Submitted",
            updated: "Updated",
            applicationId: "Application ID",
          },
          adminNotes: "Admin notes",
          saveNotes: "Save notes",
          saved: "Saved",
          saveFailed: "Failed",
          actions: {
            email: "Email",
            call: "Call",
            whatsapp: "WhatsApp",
            instagram: "Instagram",
            facebook: "Facebook",
            website: "Website",
            maps: "Maps",
            portfolio: "Portfolio",
            copy: "Copy",
            copied: "Copied",
          },
          delete: {
            button: "Delete application",
            title: "Delete this application?",
            desc: "This will permanently remove the application. This action cannot be undone.",
            confirm: "Delete",
            cancel: "Cancel",
            deleting: "Deleting…",
            deleted: "Application deleted",
            failed: "Delete failed",
          },
        },
      },

    },
    legal: {
      impressum: {
        title: "Imprint",
        subtitle: "Information according to § 5 DDG",
        sections: [
          {
            h: "Service provider (§ 5 DDG)",
            p: "PUREGLOSS\nOwner: Vladyslav Lysyi\nLegal form: Sole proprietorship (Einzelunternehmen)\nRüdesheimer Ring 129\n53879 Euskirchen\nGermany",
          },
          {
            h: "Contact",
            p: "Phone: +49 176 22038169\nWhatsApp: +49 176 22038169\nEmail: info@puregloss.eu\nWebsite: https://puregloss.eu",
          },
          {
            h: "VAT identification number",
            p: "VAT identification number pursuant to § 27a of the German VAT Act:\nDE367513046",
          },
          {
            h: "Responsible for content",
            p: "Responsible for content according to § 18 (2) MStV:\nVladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Germany",
          },
          {
            h: "EU dispute resolution",
            p: "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr\nOur email address can be found in the imprint above.",
          },
          {
            h: "Consumer dispute resolution",
            p: "We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board within the meaning of § 36 of the German Consumer Dispute Resolution Act (VSBG).",
          },
          {
            h: "Liability for content",
            p: "As a service provider we are responsible for our own content on these pages according to § 7 (1) DDG and general laws. According to §§ 8 to 10 DDG, however, we are not obliged as a service provider to monitor transmitted or stored third-party information.",
          },
          {
            h: "Liability for links",
            p: "Our offer contains links to external third-party websites over whose content we have no influence. We cannot assume any liability for these external contents. The respective provider or operator of the linked pages is always responsible for their contents.",
          },
          {
            h: "Copyright",
            p: "The content and works on these pages created by the site operator are subject to German copyright law. Duplication, processing, distribution and any form of commercialisation of such material beyond the scope of copyright law requires the written consent of the respective author or creator.",
          },
        ],
        back: "Back to home",
      },
      datenschutz: {
        title: "Privacy Policy",
        subtitle: "GDPR / BDSG-neu / TTDSG",
        sections: [
          { h: "1. Controller", p: "The controller responsible for data processing under the GDPR is:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129\n53879 Euskirchen, Germany\nPhone: +49 176 22038169\nEmail: info@puregloss.eu" },
          { h: "2. General information", p: "We take the protection of your personal data very seriously and treat it confidentially in accordance with the GDPR, BDSG-neu and TTDSG. Personal data is only collected to the extent necessary for the performance of our contractual and legal obligations or where you have expressly consented." },
          { h: "3. SSL/TLS encryption", p: "This website uses SSL/TLS encryption for security reasons and to protect the transmission of confidential content. You can identify an encrypted connection by the \"https://\" address bar and the lock icon in your browser." },
          { h: "4. Server log files / hosting", p: "This website is hosted by Emergent Labs, Inc. The provider automatically collects server log files containing your IP address (stored in truncated form), date/time of the request, requested URL, referrer URL, browser and operating system. This data is used exclusively for technical delivery, security and error analysis. Legal basis: Art. 6 (1) (f) GDPR. Storage period: max. 30 days." },
          { h: "5. Contact (email, phone, WhatsApp)", p: "When you contact us by email, phone or messenger, we store your details (name, contact data, message) to process your enquiry and for follow-up questions. Legal basis: Art. 6 (1) (b) GDPR (pre-contract / contract) or Art. 6 (1) (f) GDPR (legitimate interest). Data is deleted once the purpose no longer applies, at the latest after applicable statutory retention periods (§ 257 HGB, § 147 AO – up to 10 years)." },
          { h: "6. Quote/enquiry form", p: "Via our form you can request a non-binding quote. We process: name, phone number, email (optional), city/location, vehicle/object details, uploaded photos, preferred contact channel and your message. Data is used solely to prepare the quote and coordinate an appointment. Legal basis: Art. 6 (1) (b) GDPR." },
          { h: "7. Booking form", p: "For a binding booking we additionally collect your requested address (service location), date and time. This data is essential to perform our mobile detailing/cleaning service. Legal basis: Art. 6 (1) (b) GDPR." },
          { h: "8. WhatsApp", p: "Our website contains buttons that open a direct chat via WhatsApp (WhatsApp Ireland Limited, part of the Meta group). Only when you actively click a WhatsApp button is a connection established to WhatsApp/Meta servers and your message and phone number transmitted to them. Part of the data processing takes place outside the EU (USA). Legal basis: Art. 6 (1) (a) GDPR (consent via active click) and Art. 6 (1) (b) GDPR. Details: https://www.whatsapp.com/legal/privacy-policy-eea." },
          { h: "9. PUREGLOSS CLUB (bonus programme)", p: "When you join the PUREGLOSS CLUB we process: name (optional), email address, language preference, join timestamp and a system-generated voucher code. Purpose: issuing and managing the one-time €25 welcome voucher, providing the associated PDF, proof of consent and immediate customer communication regarding the bonus programme. Legal basis: Art. 6 (1) (a) and (b) GDPR. You may withdraw your consent at any time with effect for the future (info@puregloss.eu)." },
          { h: "10. Newsletter / promotions", p: "For sending promotional information we store your email address, the moment of consent, plus your IP address and browser user-agent as proof of consent. Subscription only happens after active confirmation of the GDPR consent checkbox. You can unsubscribe at any time by writing to info@puregloss.eu; we will delete your data immediately, no later than within 7 days. Legal basis: Art. 6 (1) (a) GDPR." },
          { h: "11. Email delivery (Resend)", p: "We use Resend (Resend, Inc., San Francisco, CA, USA) to send transactional and promotional emails. Your email address, message content and delivery metadata (timestamps, bounce status) are processed. A data-processing agreement pursuant to Art. 28 GDPR is in place. Legal basis: Art. 6 (1) (b) and (f) GDPR. Transfer to a third country (USA) is safeguarded by EU standard contractual clauses under Art. 46 GDPR. Details: https://resend.com/legal/privacy-policy." },
          { h: "12. Cookies and local storage", p: "This website uses only strictly necessary local storage (\"localStorage\") to ensure core functionality (language preference, CLUB popup state, consent preference). This data stays inside your browser and is never transmitted to us. NO marketing, tracking, analytics or third-party cookies are set. Legal basis: § 25 (2) No. 2 TTDSG (strictly necessary)." },
          { h: "13. Fonts", p: "For visual consistency we use the typeface \"Cabinet Grotesk\", delivered by Fontshare (Indian Type Foundry Pvt. Ltd., Ahmedabad, India). Loading the site establishes a connection to Fontshare's servers, during which your IP address may be transmitted. Legal basis: Art. 6 (1) (f) GDPR. Google Fonts are no longer used; all other typefaces are loaded from the user's operating system (system fonts), so no data transfer takes place." },
          { h: "14. Image material", p: "This website contains before/after photos, portfolio images and stock photos. Personal identifiers (licence plates, individuals inside vehicles) are anonymised or removed before publication." },
          { h: "15. File uploads", p: "Photos uploaded via our enquiry form are stored on our infrastructure and used solely to prepare your quote. Legal basis: Art. 6 (1) (b) GDPR. Deletion occurs at the latest 12 months after your enquiry is closed." },
          { h: "16. Recipients / third-party disclosure", p: "Personal data is only shared with: our email service provider (Resend), our hosting provider (Emergent Labs, Inc.) and – if you use it – WhatsApp/Meta. All providers are contractually obliged to comply with the GDPR. There is NO transfer to any other third parties for advertising purposes." },
          { h: "17. Retention", p: "Personal data is stored only as long as necessary for the purpose or as required by statutory retention obligations (typically 6 years under § 257 HGB, 10 years under § 147 AO for tax-relevant documents)." },
          { h: "18. Your rights as a data subject", p: "Under the GDPR you have the following rights:\n• access (Art. 15)\n• rectification (Art. 16)\n• erasure (Art. 17)\n• restriction (Art. 18)\n• data portability (Art. 20)\n• objection (Art. 21)\n• withdrawal of consent with effect for the future (Art. 7 (3))\n\nTo exercise your rights, an informal message to info@puregloss.eu is sufficient." },
          { h: "19. Right to complain to the supervisory authority", p: "You have the right to lodge a complaint with a supervisory authority regarding the processing of your personal data. The competent authority for our registered office is:\n\nLandesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)\nKavalleriestraße 2-4, 40213 Düsseldorf\nPhone: +49 211 38424-0\nEmail: poststelle@ldi.nrw.de\nhttps://www.ldi.nrw.de" },
          { h: "20. Updates", p: "This privacy policy is currently valid. Due to updates on our website or changes in legal requirements it may be necessary to change this privacy policy. The latest version can always be viewed at https://puregloss.eu/datenschutz." },
          { h: "21. Signup security log (PUREGLOSS Club)", p: "For every new PUREGLOSS Club signup we additionally store technical information for security, fraud prevention, spam prevention and abuse detection. This includes: your IP address, an approximate location (country, region, approximate city) derived from that IP address — never an exact position —, browser and device information (User-Agent, operating system, device type), and the signup timestamp. The location is always approximate and is not used to identify you individually. Legal basis: Art. 6(1)(f) GDPR (legitimate interest in providing a secure, abuse-free service). This information is visible only internally and is not shared with third parties, except for the technically necessary IP geolocation service." },
        ],
        back: "Back to home",
      },
      agb: {
        title: "General Terms & Conditions",
        subtitle: "Status February 2026",
        sections: [
          { h: "§ 1 Scope", p: "These General Terms and Conditions apply to all contracts between PUREGLOSS – Vladyslav Lysyi (\"Provider\") and consumers or businesses (\"Customer\") regarding the services offered on https://puregloss.eu (mobile detailing, interior and exterior cleaning, upholstery and sofa cleaning)." },
          { h: "§ 2 Conclusion of contract", p: "The presentation of services on the website does not constitute a legally binding offer but an invitation to submit an offer (invitatio ad offerendum). The customer submits a non-binding enquiry via our form; the Provider then prepares an individual quote by email, phone or WhatsApp. The contract only comes into effect once the offer is explicitly accepted by both sides or once the Provider begins performance." },
          { h: "§ 3 Scope of services", p: "The precise scope of services is defined in the individual quote. Vehicle or object condition may influence effort and therefore the final price; material changes will be agreed with the customer before performance." },
          { h: "§ 4 Prices and payment", p: "All prices are in Euro including statutory VAT. Payment is made on site after service performance in cash or – where offered – by card/instant transfer. Statutory rules (§§ 286 ff. BGB) apply in the event of default." },
          { h: "§ 5 Appointments, cancellation, delay", p: "Appointments are confirmed by email or messenger. The customer may cancel or reschedule a confirmed appointment free of charge up to 24 hours before the start. For later cancellations a no-show fee of 50 % of the agreed price may be charged. If the Provider is prevented from attending for an important reason, a replacement date is offered immediately." },
          { h: "§ 6 Customer's duties to cooperate", p: "The customer provides a suitable workplace (access to the vehicle/object, sufficient space, water supply where required, 230 V power). Personal belongings must be removed prior to work." },
          { h: "§ 7 Warranty and liability", p: "Statutory warranty rights apply. The Provider has unlimited liability for damages arising from injury to life, body or health as well as intentional or grossly negligent conduct. In cases of simple negligence – except for the breach of essential contractual duties – liability is excluded. Otherwise liability is limited to typical, foreseeable damages. The Provider assumes no liability for pre-existing damage (e.g. scratches, stone chips, hardened stains); such pre-damage is documented on request before work begins." },
          { h: "§ 8 Consumer withdrawal right", p: "Consumers have a statutory withdrawal right pursuant to § 312g in conjunction with § 355 BGB. Details are set out in our Withdrawal Notice." },
          { h: "§ 9 Dispute resolution", p: "The EU Commission provides a platform for online dispute resolution: https://ec.europa.eu/consumers/odr. We are neither willing nor obliged to participate in dispute resolution before a consumer arbitration board." },
          { h: "§ 10 Final provisions", p: "German law applies to the exclusion of the UN Sales Convention. Place of performance is Euskirchen. Where legally permissible, the place of jurisdiction is the Provider's registered office. Should individual provisions be or become invalid, the remainder of these terms shall remain unaffected." },
        ],
        back: "Back to home",
      },
      widerruf: {
        title: "Withdrawal Notice",
        subtitle: "Your rights as a consumer",
        sections: [
          { h: "Right of withdrawal", p: "You have the right to withdraw from this contract within fourteen days without giving any reason. The withdrawal period is fourteen days from the day of the conclusion of the contract.\n\nTo exercise the right of withdrawal, you must inform us:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Germany\nPhone: +49 176 22038169\nEmail: info@puregloss.eu\n\nof your decision to withdraw from this contract by an unequivocal statement (e.g. a letter sent by post or an email). You may use the sample withdrawal form below but it is not obligatory.\n\nTo meet the withdrawal deadline, it is sufficient for you to send your communication concerning your exercise of the right of withdrawal before the withdrawal period has expired." },
          { h: "Consequences of withdrawal", p: "If you withdraw from this contract, we shall reimburse to you all payments received from you, including the costs of delivery (with the exception of the supplementary costs resulting from your choice of a type of delivery other than the least expensive type of standard delivery offered by us), without undue delay and in any event not later than 14 days from the day on which we are informed about your decision to withdraw from this contract. We will carry out such reimbursement using the same means of payment as you used for the initial transaction, unless you have expressly agreed otherwise; in any event, you will not incur any fees as a result of such reimbursement." },
          { h: "Early expiry of the right of withdrawal for services", p: "The right of withdrawal for service contracts expires if the trader has fully performed the service and started performance after the consumer's express prior consent and confirmation of acknowledgement that the right of withdrawal will be lost upon full performance (§ 356 (4) BGB)." },
          { h: "Sample withdrawal form", p: "(If you want to withdraw from the contract, please complete and return this form.)\n\nTo: PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen, Germany, Email: info@puregloss.eu\n\nI/We (*) hereby give notice that I/we (*) withdraw from my/our (*) contract of sale of the following goods (*)/for the provision of the following service (*):\n\n___________________________________\n\nOrdered on (*)/received on (*):\n___________________________________\n\nName of consumer(s):\n___________________________________\n\nAddress of consumer(s):\n___________________________________\n\nDate: _______________\n\nSignature of consumer(s) (only if this form is notified on paper):\n___________________________________\n\n(*) Delete as applicable." },
        ],
        back: "Back to home",
      },
      cookies: {
        title: "Cookie Policy",
        subtitle: "Cookies & local storage",
        sections: [
          { h: "1. Principle", p: "This website does NOT use tracking, marketing or third-party cookies. Analytics tools such as Google Analytics, Google Tag Manager or the Meta Pixel are NOT used. We exclusively use strictly necessary browser local storage." },
          { h: "2. Purpose of local storage", p: "We store in your browser:\n• your chosen language (e.g. DE/EN/UA)\n• whether you have joined PUREGLOSS CLUB (so the popup does not re-appear)\n• your preferred UI display (e.g. last active form flow)\n\nThis data never leaves your browser and is NOT transmitted to our servers or third parties." },
          { h: "3. Legal basis", p: "The storage described above is strictly necessary for the proper provision of the website (§ 25 (2) No. 2 TTDSG) and therefore does not require separate consent." },
          { h: "4. Deletion / objection", p: "You can delete local storage at any time via your browser settings (e.g. Chrome → Settings → Privacy and security → Clear browsing data → \"Cookies and other site data\"). After deletion the website will return to its default state." },
          { h: "5. External services", p: "If you actively click a WhatsApp button, you leave our site and enter an environment where WhatsApp/Meta may set its own cookies. This is outside our control. See our privacy policy, section WhatsApp." },
        ],
        back: "Back to home",
      },
    },
  },
};

// ---------------------------------------------------------------------------
// Polish (PL) — complete native dictionary. Written natively, professional
// tone appropriate for a premium mobile detailing service in Poland/DACH.
// Structure mirrors translations.en exactly (full key parity).
// ---------------------------------------------------------------------------
translations.pl = {
  seo: {
    title: "PUREGLOSS — Mobilny detailing samochodowy i pranie tapicerki Euskirchen",
    description:
      "Mobilny detailing samochodowy oraz profesjonalne pranie kanap z dojazdem. Euskirchen • Bonn • Brühl • Wesseling • Kolonia • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen i okolice. Bezpłatna wycena w ciągu 1 godziny.",
    keywords:
      "Auto Detailing Euskirchen, Mobile Detailing Euskirchen, detailing samochodowy Euskirchen, pranie tapicerki Euskirchen, czyszczenie kanap Euskirchen, mobilne pranie tapicerki",
  },
  nav: {
    home: "Start",
    services: "Usługi",
    beforeAfter: "Przed / Po",
    reviews: "Opinie",
    prices: "Cennik",
    serviceArea: "Obszar działania",
    promotions: "Promocje",
    faq: "FAQ",
    contact: "Kontakt",
    academy: "Academy",
    works: "Realizacje",
    club: "PUREGLOSS CLUB",
    cta: "WhatsApp",
  },
  cta: {
    getPrice: "Zapytaj o cenę",
    getPriceShort: "Cena",
    bookAppointment: "Zarezerwuj termin",
    bookAppointmentShort: "Rezerwacja",
    checkAvailability: "Sprawdź dostępność w swoim mieście",
    joinWaitingList: "Zapisz się na listę",
    whatsapp: "WhatsApp",
    readyTitle: "Gotowy, aby zacząć?",
    readyDesc: "Otrzymaj szybką wycenę lub zarezerwuj termin.",
  },
  promotions: {
    eyebrow: "Promocje i oferty specjalne",
    title: "Promocje i oferty specjalne",
    desc: "Bądź pierwszy, który dowie się o sezonowych rabatach, pakietach i ekskluzywnych ofertach premium PUREGLOSS.",
    nameLabel: "Imię (opcjonalnie)",
    emailLabel: "E-mail",
    emailPlaceholder: "twoj@email.com",
    cta: "Zapisz się",
    gdpr: "Wyrażam zgodę na otrzymywanie wiadomości marketingowych zgodnie z",
    successTitle: "Dziękujemy!",
    successMessage: "Dodaliśmy Cię do listy ofert PUREGLOSS.",
    error: "Zapisanie nie powiodło się. Spróbuj ponownie.",
  },
  ctaBlocks: {
    services: { title: "Gotowy, aby zacząć?", desc: "Otrzymaj szybką wycenę lub zarezerwuj termin.", primary: "Zapytaj o cenę", secondary: "Zarezerwuj termin" },
    pricing: { title: "Wybrałeś pakiet?", desc: "Zarezerwuj termin lub poproś o dokładną wycenę.", primary: "Zapytaj o cenę", secondary: "Zarezerwuj termin" },
    serviceArea: { title: "Przyjeżdżamy do Ciebie", desc: "Sprawdź dostępność w swoim mieście.", primary: "Sprawdź dostępność", secondary: "Zarezerwuj termin" },
    academy: { title: "PUREGLOSS Academy", desc: "Naucz się mobilnego detailingu w Niemczech. Miejsca wkrótce dostępne.", primary: "Zapisz się na listę" },
  },
  serviceAreaMap: {
    title: "Obszar działania",
    desc: "Usługa mobilna w Euskirchen, Kolonii, Bonn i okolicach.",
    mobileTag: "Usługa mobilna — przyjeżdżamy do Ciebie",
    cityAvailability: "Usługa mobilna u Ciebie",
  },
  trustBadge: "Bezpłatna wycena w ciągu 1 godziny",
  floatingEstimate: "Bezpłatna wycena po zgłoszeniu",
  basedIn: "Siedziba: Euskirchen",
  whatsappConsent: {
    eyebrow: "Informacja o prywatności",
    title: "Za chwilę otworzysz WhatsApp",
    body: "Po potwierdzeniu Twój numer telefonu i wiadomość zostaną przekazane do WhatsApp Ireland Ltd. (Meta). Część przetwarzania odbywa się poza UE (USA).",
    details: "Podstawa prawna: art. 6 ust. 1 lit. a RODO (zgoda). Szczegóły w naszej",
    datenschutzLink: "Polityce prywatności",
    confirm: "Przejdź do WhatsApp",
    cancel: "Anuluj",
    close: "Zamknij",
  },
  fullAreaText:
    "Euskirchen • Bonn • Brühl • Wesseling • Kolonia • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen i okolice",
  hero: {
    eyebrow: "Mobilny detailing • Euskirchen",
    title: "PUREGLOSS",
    subtitle: "Detailing i pranie tapicerki",
    desc: "Mobilny detailing samochodowy oraz profesjonalne pranie kanap — przyjeżdżamy do Ciebie.",
    ctaPrimary: "Otrzymaj wycenę",
    ctaSecondary: "Napisz na WhatsApp",
    scroll: "Przewiń",
  },
  area: {
    label: "Obszar działania",
    suffix: "i okolice",
  },
  services: {
    eyebrow: "Usługi",
    title: "Premium pielęgnacja Twojego auta i mebli",
    desc: "Profesjonalna usługa mobilna — wszystko, aby Twoje rzeczy znów wyglądały bez zarzutu.",
    vehicleTitle: "Detailing pojazdu",
    vehicleItems: [
      "Detailing wnętrza",
      "Pranie foteli",
      "Pielęgnacja skóry",
      "Usuwanie zapachów",
      "Mycie ręczne",
      "Czyszczenie felg",
      "Pielęgnacja opon",
      "Przygotowanie do sprzedaży",
    ],
    sofaTitle: "Pranie kanap i tapicerki",
    sofaItems: [
      "Kanapy",
      "Fotele",
      "Materace",
      "Meble tapicerowane",
      "Usuwanie plam",
      "Usuwanie zapachów",
      "Pranie głębokie",
      "Pranie dywanów",
    ],
  },
  pricing: {
    eyebrow: "Cennik",
    title: "Przejrzyste ceny",
    auto: "Auto",
    polishing: "Korekta lakieru i polerowanie",
    furniture: "Meble",
    from: "od",
    items: {
      auto: [
        { name: "Pranie wnętrza", price: "49€" },
        { name: "Mycie zewnętrzne", price: "39€" },
        { name: "Pakiet kompleksowy", price: "89€" },
        { name: "Przygotowanie do sprzedaży", price: "119€" },
      ],
      furniture: [
        { name: "Fotel", price: "25€" },
        { name: "Kanapa 2-osobowa", price: "49€" },
        { name: "Kanapa 3-osobowa", price: "69€" },
        { name: "Narożnik", price: "99€" },
        { name: "Materac", price: "39€" },
      ],
    },
    note: "Ostateczna cena zależy od stanu pojazdu lub mebla. Wyślij zdjęcia, a otrzymasz bezpłatną wycenę.",
    lockedBadge: "JUŻ WKRÓTCE",
    lockedTitle: "Korekta lakieru i polerowanie",
    lockedDesc:
      "Profesjonalna korekta lakieru i polerowanie maszynowe są chwilowo niedostępne — usługa ruszy wkrótce.",
    lockedDisabled: "Rezerwacja tymczasowo niedostępna",
    ctaGetEstimate: "Otrzymaj wycenę",
    lockedItems: [
      { name: "Polerowanie 1-etapowe", price: "149€" },
      { name: "Polerowanie 2-etapowe", price: "249€" },
      { name: "Polerowanie 3-etapowe", price: "349€" },
    ],
  },
  stats: [
    { value: "100%", label: "Usługa mobilna" },
    { value: "PRO", label: "Produkty premium" },
    { value: "24/7", label: "Elastyczne terminy" },
    { value: "★★★★★", label: "Profesjonalny efekt" },
  ],
  beforeAfter: {
    eyebrow: "Efekty",
    title: "Przed i po",
    desc: "Przesuń suwak, aby zobaczyć różnicę.",
    categories: { cars: "Samochody", sofas: "Kanapy" },
    beforeLabel: "Przed",
    afterLabel: "Po",
  },
  instaProof: {
    eyebrow: "Portfolio",
    title: "Nasze prawdziwe realizacje",
    desc: "Zobacz realne efekty PUREGLOSS: samochody, kanapy, materace i inne prace przed/po.",
    stats: ["Prawdziwi klienci", "Zdjęcia przed / po", "Nowe realizacje co tydzień"],
    cta: "Zobacz wszystkie prace",
    handle: "@puregloss.eu",
  },
  serviceLabels: {
    Innenraum: "Wnętrze",
    "Außenreinigung": "Mycie zewnętrzne",
    Sitzreinigung: "Pranie foteli",
    Lederpflege: "Pielęgnacja skóry",
    Felgenreinigung: "Czyszczenie felg",
    Politur: "Polerowanie",
    Scheinwerfer: "Reflektory",
  },
  furnitureServiceLabels: {
    Sofa: "Kanapa",
    Matratze: "Materac",
    Sessel: "Fotel",
    "Stühle": "Krzesła",
    Bürostuhl: "Krzesło biurowe",
    Teppich: "Dywan",
    Polster: "Tapicerka",
  },
  brandLabels: {
    Audi: "Audi", BMW: "BMW", "Mercedes-Benz": "Mercedes-Benz",
    Porsche: "Porsche", Volkswagen: "Volkswagen", Tesla: "Tesla",
    Skoda: "Skoda", Ford: "Ford", Opel: "Opel", Toyota: "Toyota",
    Hyundai: "Hyundai", Other: "Inna",
  },
  furnitureTypeLabels: {
    "2-Sitzer Sofa": "Kanapa 2-osobowa",
    "3-Sitzer Sofa": "Kanapa 3-osobowa",
    Ecksofa: "Narożnik",
    Matratze: "Materac",
    Sessel: "Fotel",
    Stuhl: "Krzesło",
    Bürostuhl: "Krzesło biurowe",
    Teppich: "Dywan",
    Other: "Inne",
  },
  works: {
    heroTitle: "Nasze realizacje",
    heroSubtitle: "Prawdziwe efekty naszych prac: samochody, kanapy, materace i tapicerka.",
    empty: "Wkrótce dodamy więcej realizacji.",
    filterAll: "Wszystkie",
    filterCategory: "Kategoria",
    filterService: "Usługa",
    filterBrand: "Marka",
    filterType: "Rodzaj mebla",
    catVehicle: "Pojazdy",
    catFurniture: "Meble",
    viewBtn: "Zobacz",
    getPriceCta: "Zapytaj o cenę",
    beforeLabel: "Przed",
    afterLabel: "Po",
    cityLabel: "Miasto",
    serviceLabel: "Usługa",
    brandLabel: "Marka",
    modelLabel: "Model",
    typeLabel: "Rodzaj",
    descriptionLabel: "Opis",
    sliderHint: "Przesuń, aby porównać",
    beforeGallery: "Zdjęcia przed",
    afterGallery: "Zdjęcia po",
    close: "Zamknij",
    photoSoon: "Zdjęcie zostanie dodane wkrótce",
    getSameServiceCta: "Otrzymaj wycenę",
    likeResultTitle: "Podoba Ci się efekt?",
    likeResultDesc: "Taki sam rezultat możemy osiągnąć dla Twojego auta lub mebla.",
    ctaFreeQuote: "Bezpłatna wycena",
    ctaBookSlot: "Zarezerwuj termin",
  },
  club: {
    title: "Witaj w PUREGLOSS CLUB",
    subtitle: "Odblokuj ekskluzywne przywileje i dołącz do klubu — bezpłatnie.",
    benefit1: "🎁 Bon powitalny 25 € przy zamówieniu od 100 €",
    benefit2: "⚡ Wcześniejszy dostęp do promocji i ofert",
    benefit3: "👑 Ekskluzywne korzyści dla członków PUREGLOSS CLUB",
    benefit4: "",
    nameLabel: "Imię (opcjonalnie)",
    emailLabel: "E-mail",
    gdpr: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z Polityką prywatności.",
    joinCta: "Dołącz bezpłatnie",
    joining: "Przetwarzanie...",
    finePrint: "Bon ważny 6 miesięcy, jednorazowy. Minimalna wartość zamówienia 100 €.",
    close: "Zamknij",
    alreadyRegistered: "Ten adres e-mail jest już zarejestrowany w PUREGLOSS CLUB.",
    genericError: "Nie udało się dołączyć. Spróbuj ponownie.",
    emailInvalid: "Wprowadź poprawny adres e-mail",
    gdprRequired: "Zaakceptuj Politykę prywatności",
    successTitle: "Witaj w PUREGLOSS CLUB!",
    successMessage: "Twój bon powitalny 25 € jest aktywny. Obowiązuje na dowolną usługę PUREGLOSS przy zamówieniu od 100 €.",
    successCta: "Poproś o bezpłatną wycenę",
  },
  clubAdmin: {
    tab: "PUREGLOSS CLUB",
    empty: "Brak członków klubu.",
    filterAll: "Wszyscy",
    filterActive: "Aktywni",
    filterUsed: "Wykorzystany",
    filterExpired: "Wygasłe",
    filterEmailNotSent: "E-mail niewysłany",
    filterEmailSent: "E-mail wysłany",
    searchPlaceholder: "Szukaj po imieniu, e-mailu lub kodzie vouchera",
    newMemberBtn: "Nowy członek",
    newMemberTitle: "Utwórz członka klubu",
    sendWelcomeCheckbox: "Wyślij e-mail powitalny teraz",
    createBtn: "Utwórz",
    redeemBtn: "Zrealizuj voucher",
    redeemTitle: "Zrealizować voucher?",
    redeemDesc: "Status zmieni się na „Wykorzystany”, a data realizacji zostanie zapisana.",
    redeemConfirm: "Zrealizuj",
    redeemed: "Voucher zrealizowany.",
    regenerateBtn: "Wygeneruj PDF ponownie",
    regenerated: "PDF vouchera wygenerowany ponownie.",
    emptySearch: "Brak wyników dla Twojego zapytania.",
    colName: "Imię",
    colEmail: "E-mail",
    colJoined: "Dołączenie",
    colBonusStart: "Start bonusu",
    colBonusEnd: "Koniec bonusu",
    colBonus: "Bonus powitalny",
    colCondition: "Warunek",
    colSecond: "Drugie pranie",
    colVoucherCode: "Kod vouchera",
    colStatus: "Status",
    colEmailStatus: "E-mail",
    statusActive: "aktywny",
    statusUsed: "wykorzystany",
    statusExpired: "wygasł",
    emailNotSent: "niewysłany",
    emailSent: "wysłany",
    emailFailed: "błąd",
    markUsed: "Oznacz jako wykorzystany",
    markActive: "Oznacz jako aktywny",
    markExpired: "Oznacz jako wygasły",
    editBtn: "Edytuj",
    deleteBtn: "Usuń",
    sendWelcome: "Wyślij e-mail powitalny",
    deleteTitle: "Usunąć członka klubu?",
    deleteDesc: "Czy na pewno chcesz usunąć tego członka klubu?",
    deleteConfirm: "Usuń",
    cancel: "Anuluj",
    resendNotConnected: "Wysyłka e-mail zostanie podłączona przez Resend w kolejnym kroku.",
    emailSentToast: "E-mail powitalny wysłany pomyślnie.",
    emailFailedToast: "Wysyłka e-maila nie powiodła się",
    updated: "Członek zaktualizowany.",
    deleted: "Członek usunięty.",
    actionFailed: "Operacja nie powiodła się.",
    editTitle: "Edytuj członka",
    notesLabel: "Notatki",
    saveBtn: "Zapisz",
  },
  worksAdmin: {
    tab: "Realizacje",
    addBtn: "Dodaj realizację",
    editBtn: "Edytuj",
    deleteBtn: "Usuń",
    publish: "Opublikowane",
    draft: "Szkic",
    statusLabel: "Status",
    createTitle: "Nowa realizacja",
    editTitle: "Edytuj realizację",
    titleField: "Tytuł",
    titlePlaceholder: "np. BMW M3 — pełny detailing wnętrza",
    categoryField: "Kategoria",
    serviceField: "Usługa",
    brandField: "Marka pojazdu",
    modelField: "Model",
    furnitureTypeField: "Rodzaj mebla",
    cityField: "Miasto",
    descriptionField: "Krótki opis",
    beforePhotos: "Zdjęcia przed (do 5)",
    afterPhotos: "Zdjęcia po (do 5)",
    uploadBtn: "Wgraj zdjęcia",
    selectPlaceholder: "— Wybierz —",
    cancel: "Anuluj",
    save: "Zapisz",
    empty: "Brak realizacji. Kliknij „Dodaj realizację”, aby utworzyć pierwszą.",
    deleteTitle: "Usunąć realizację?",
    deleteDesc: "Czy na pewno chcesz usunąć tę realizację? Tej czynności nie można cofnąć.",
    workCreated: "Realizacja utworzona.",
    workUpdated: "Realizacja zaktualizowana.",
    workDeleted: "Realizacja usunięta.",
    actionFailed: "Operacja nie powiodła się.",
    maxPhotos: "Maksymalnie 5 zdjęć.",
    requiredCategory: "Wybierz kategorię",
    uploadFailed: "Wgrywanie zdjęcia nie powiodło się: ",
    unsupportedFile: "Nieobsługiwany plik: ",
    supportedFormats: "Dozwolone: JPG, PNG, WEBP",
    uploadingProgress: "Wgrywanie {done}/{total}...",
  },
  reviews: {
    eyebrow: "Opinie",
    title: "Co mówią nasi klienci",
    items: [
      { text: "Po przygotowaniu do sprzedaży samochód wyglądał znacznie lepiej i sprzedał się szybciej.", author: "Andreas K.", city: "Kolonia" },
      { text: "Chcieliśmy wyrzucić kanapę, ale po praniu znów wygląda jak nowa.", author: "Marina S.", city: "Bonn" },
      { text: "Bardzo wygodne, że usługa jest realizowana u nas w domu. Wszystko wykonane starannie.", author: "Thomas L.", city: "Euskirchen" },
      { text: "Uczciwa cena, świetny efekt i profesjonalne podejście.", author: "Olena P.", city: "Brühl" },
      { text: "Polecam PUREGLOSS. Na pewno skorzystam ponownie.", author: "Markus B.", city: "Hürth" },
    ],
  },
  howItWorks: {
    eyebrow: "Jak to działa",
    title: "Prosty proces",
    steps: [
      "Wysyłasz zdjęcia",
      "Otrzymujesz wycenę",
      "Ustalamy dogodny termin",
      "Przyjeżdżamy do Ciebie",
      "Cieszysz się efektem",
    ],
  },
  newsletter: {
    eyebrow: "Newsletter",
    title: "Nie przegap promocji i ofert specjalnych",
    placeholder: "twoj@email.com",
    cta: "Zapisz się",
    thanks: "Dziękujemy za zapisanie!",
    gdpr: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z Polityką prywatności.",
    error: "Zapisanie nie powiodło się. Spróbuj ponownie.",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Najczęściej zadawane pytania",
    items: [
      { q: "Ile kosztuje pranie samochodu?", a: "Ceny zaczynają się od 39€ za mycie zewnętrzne i 49€ za wnętrze. Pełny pakiet od 89€. Dokładna cena zależy od stanu pojazdu." },
      { q: "Ile trwa czyszczenie?", a: "Zazwyczaj 2–5 godzin, w zależności od stanu i wybranego pakietu." },
      { q: "Czy muszę gdzieś dojechać?", a: "Nie. Świadczymy usługę mobilną i przyjeżdżamy do Twojego domu lub biura z całym sprzętem." },
      { q: "Czy pierzecie kanapy, materace i dywany?", a: "Tak. Pierzemy kanapy, fotele, materace, narożniki, dywany i inne meble tapicerowane." },
      { q: "Czy można wyprać tylko fotele?", a: "Tak. Oferujemy pranie częściowe — np. tylko przednich foteli lub bagażnika." },
      { q: "Czy usuwacie zapachy?", a: "Tak. Używamy profesjonalnych środków do usuwania zapachów — dym, zwierzęta, jedzenie." },
      { q: "Jakie obszary obsługujecie?", a: "Euskirchen • Bonn • Brühl • Wesseling • Kolonia • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen i okolice." },
      { q: "Jak zarezerwować usługę?", a: "Wypełnij formularz na stronie lub napisz do nas na WhatsApp. Potwierdzimy dogodny termin w ciągu godziny." },
      { q: "Jak otrzymać dokładną cenę?", a: "Wyślij nam kilka zdjęć przez WhatsApp — odpowiemy w ciągu godziny. Wycena jest bezpłatna." },
      { q: "Jakie formy płatności akceptujecie?", a: "Gotówka, przelew bankowy lub PayPal. Płatność po wykonaniu usługi." },
    ],
  },
  quote: {
    eyebrow: "Zapytanie o wycenę",
    title: "Otrzymaj bezpłatną wycenę",
    desc: "Wypełnij formularz — otworzymy WhatsApp z Twoją wiadomością. Odpowiadamy w ciągu 1 godziny.",
    name: "Imię",
    phone: "Numer telefonu",
    city: "Miasto",
    cityPlaceholder: "—",
    serviceType: "Rodzaj usługi",
    message: "Wiadomość",
    photos: "Zdjęcia (opcjonalnie)",
    photosHint: "Dodaj zdjęcia — po kliknięciu otworzy się WhatsApp, aby je załączyć",
    submit: "Otrzymaj wycenę",
    successHint: "Za chwilę otworzy się WhatsApp",
    serviceOptions: [
      "Detailing wnętrza",
      "Detailing zewnętrza",
      "Pełny detailing",
      "Pranie kanapy",
      "Pranie materaca",
      "Pranie dywanu",
    ],
    cityOther: "Inne / okolica",
    uploading: "Wgrywanie...",
    emailLabel: "E-mail",
    preferredContactLabel: "Preferowana forma kontaktu",
    preferredContactPlaceholder: "Wybierz formę",
    preferredContactRequired: "Wybierz preferowaną formę kontaktu",
    preferredContactOptions: ["WhatsApp", "Telegram", "E-mail", "Telefon"],
    gdpr: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z Polityką prywatności.",
    submitError: "Nie udało się wysłać zapytania. Spróbuj ponownie.",
    successTitle: "Dziękujemy za zgłoszenie!",
    successMessage: "Twoje zgłoszenie zostało przyjęte i jest przetwarzane. Skontaktujemy się z Tobą wkrótce wybraną formą kontaktu.",
    successPhone: "+49 176 22038169",
    successOpenWhatsApp: "Otwórz WhatsApp",
    successClose: "Zamknij",
  },
  booking: {
    flowGetPrice: "Zapytaj o cenę",
    flowBook: "Zarezerwuj termin",
    address: "Adres",
    itemDetails: "Model auta lub szczegóły kanapy",
    preferredDate: "Preferowana data",
    preferredTime: "Preferowana godzina",
    pickDate: "Wybierz datę",
    pickTime: "Wybierz godzinę",
    booked: "Zarezerwowane",
    blocked: "Niedostępne",
    tooSoon: "Wymagany minimum 8-dniowy wyprzedzenie rezerwacji",
    submit: "Zarezerwuj termin",
    successTitle: "Dziękujemy. Twoje zgłoszenie rezerwacji zostało przyjęte",
    successMessage: "Potwierdzimy termin przez WhatsApp w ciągu 24 godzin.",
    noSlot: "Brak wolnych terminów w tym dniu",
    previousMonth: "Poprzedni miesiąc",
    nextMonth: "Następny miesiąc",
    legend: {
      available: "Dostępne",
      booked: "Zarezerwowane",
      unavailable: "Niedostępne",
    },
  },
  student: {
    loginButton: "Logowanie kursanta",
    loginTitle: "Logowanie kursanta",
    loginSubtitle: "Dostęp do PUREGLOSS Academy.",
    email: "E-mail",
    password: "Hasło",
    signIn: "Zaloguj się",
    signingIn: "Logowanie...",
    invalidCredentials: "Nieprawidłowy e-mail lub hasło",
    accountPaused: "Konto jest wstrzymane. Skontaktuj się z PUREGLOSS Academy.",
    backToAcademy: "Powrót do Academy",
    logout: "Wyloguj",
    dashboard: {
      welcome: "Witaj",
      package: "Pakiet",
      startDate: "Data startu",
      progress: "Postęp",
      status: "Status",
      completedOf: "ukończono z",
      modulesTitle: "Moduły kursu",
      locked: "Zablokowane",
      unlock: "Dostępne za",
      startLesson: "Rozpocznij",
      markCompleted: "Oznacz jako ukończone",
      markIncomplete: "Cofnij",
      completed: "Ukończone",
      certificateTitle: "Certyfikacja",
      certificateDesc: "Twój certyfikat będzie dostępny po zdaniu egzaminu końcowego.",
      certificatePending: "Certyfikat dostępny po ukończeniu kursu",
    },
    statusLabels: {
      Active: "Aktywny",
      Paused: "Wstrzymany",
      Completed: "Ukończony",
    },
  },
  academy: {
    nav: "Academy",
    eyebrow: "PUREGLOSS Academy",
    title: "PUREGLOSS Academy",
    subtitle: "Program szkoleniowy z mobilnego detailingu samochodowego.\nDla Niemiec, Polski, Ukrainy i całej Europy.",
    coverage: "Odpowiedni dla kursantów z Niemiec, Polski, Ukrainy i innych krajów europejskich.",
    hero: {
      cta: "Zapisz się na listę",
      secondary: "Dowiedz się więcej",
    },
    why: {
      eyebrow: "Dlaczego PUREGLOSS Academy",
      title: "Dlaczego PUREGLOSS Academy?",
      desc: "To nie kolejny kurs online — to kompletna ścieżka zawodowa w mobilnym detailingu.",
      items: [
        { title: "Praktyczna wiedza", desc: "Techniki i procesy z codziennej pracy PUREGLOSS." },
        { title: "Systemy krok po kroku", desc: "Uporządkowane instrukcje, checklisty i szablony — nie przypadkowe filmy." },
        { title: "Certyfikat", desc: "Oficjalny certyfikat PUREGLOSS Academy po ukończeniu." },
        { title: "Dostęp do społeczności", desc: "Prywatna społeczność kursantów i absolwentów." },
        { title: "Możliwa współpraca", desc: "Najlepsi kursanci mogą uzyskać dostęp do PUREGLOSS Network." },
        { title: "Gotowe procesy biznesowe", desc: "Szablony komunikacji, wyceny i kontroli jakości gotowe do użycia." },
        { title: "Fokus na mobilny detailing", desc: "Cały program dostosowany do usług mobilnych." },
        { title: "Ścieżka kariery", desc: "Od początkującego do własnej mobilnej usługi lub partnera PUREGLOSS." },
      ],
    },
    who: {
      eyebrow: "Dla kogo",
      title: "Dla kogo jest ten kurs?",
      items: [
        "Przyszli detailerzy",
        "Początkujący bez doświadczenia",
        "Ukraińcy i międzynarodowi kursanci",
        "Osoby szukające praktycznych umiejętności",
        "Przyszli właściciele usług mobilnych",
        "Osoby dążące do samozatrudnienia",
      ],
      note: "Do pracy mobilnej zalecany jest własny pojazd, ale nie jest wymagany do zapisu na listę.",
    },
    packages: {
      eyebrow: "Pakiety szkoleniowe",
      title: "Wybierz swój program",
      desc: "Trzy poziomy — od podstaw po start pełnej mobilnej usługi detailingu.",
      comingSoon: "Wkrótce",
      includes: "Zawiera",
      certificate: "Certyfikat",
      foundation: {
        icon: "🥉",
        name: "Foundation",
        oldPrice: "249€",
        newPrice: "149€",
        tagline: "Dla całkowicie początkujących.",
        items: [
          "Wprowadzenie do mobilnego detailingu",
          "Podstawy czyszczenia wnętrza",
          "Podstawy bezpiecznego mycia zewnętrznego",
          "Lista rekomendowanego sprzętu",
          "Lista rekomendowanej chemii",
          "Instrukcje stosowania chemii",
          "Poradnik mikrofibry",
          "Poradnik szczotek i akcesoriów",
          "Podstawy wyceny",
          "Podstawy komunikacji z klientem",
          "Przegląd procesu usługi",
          "Checklisty PDF",
          "Test wiedzy",
          "Certyfikat PUREGLOSS Foundation",
        ],
        note: "Bez części praktycznej.",
        certificateName: "Certyfikat PUREGLOSS Foundation",
      },
      professional: {
        icon: "🥈",
        name: "Professional",
        oldPrice: "499€",
        newPrice: "349€",
        badge: "najpopularniejszy",
        tagline: "Wszystko z Foundation plus:",
        items: [
          "Zaawansowane pranie wnętrza",
          "Pranie foteli",
          "Pranie dywanów",
          "Pielęgnacja plastików",
          "Pielęgnacja skóry",
          "Podstawy prania kanap i tapicerki",
          "Bezpieczne stosowanie chemii",
          "Poradnik zdjęć przed / po",
          "Przygotowanie auta do sprzedaży",
          "System szacowania czasu",
          "System szacowania cen",
          "Jak zdobyć pierwszych klientów",
          "Strategia ulotek",
          "Strategia wizytówek",
          "Strategia platform lokalnych",
          "Poradnik konfiguracji Google Business Profile",
          "Poradnik indeksowania w Google",
          "Skrypty komunikacji z klientem",
          "Analiza case study",
          "Zadania praktyczne",
          "50% rabatu na stronę PUREGLOSS",
        ],
        certificateName: "Certyfikat PUREGLOSS Professional",
      },
      elite: {
        icon: "👑",
        name: "Elite",
        oldPrice: "999€",
        newPrice: "749€",
        badge: "premium",
        tagline: "Wszystko z Professional plus:",
        items: [
          "Osobisty mentoring",
          "Rzeczywiste przykłady procesów",
          "Systemy kontroli jakości",
          "Systemy procesów biznesowych",
          "Zarządzanie terminami",
          "Kalkulacja zysku",
          "Systemy stałych klientów",
          "Systemy utrzymania klientów",
          "Przygotowanie do PUREGLOSS Network",
          "Priorytetowa weryfikacja certyfikatu",
          "Szkolenie praktyczne z mentorem (jeśli dostępne)",
          "Bezpłatna strona typu one-page PUREGLOSS",
          "Osobiste wsparcie przy konfiguracji Google Business Profile",
          "Osobiste wsparcie przy indeksowaniu Google",
        ],
        certificateName: "Certyfikat PUREGLOSS Elite",
      },
    },
    polishingDisclaimer: "Polerowanie i pielęgnacja lakieru są omawiane wyłącznie teoretycznie. Praktyczna korekta lakieru nie jest częścią kursu.",
    certification: {
      eyebrow: "Certyfikacja",
      title: "Certyfikacja i egzamin końcowy",
      desc: "Każdy kursant musi zdać egzamin końcowy, aby otrzymać oficjalny certyfikat PUREGLOSS Academy.",
      items: [
        "Egzamin teoretyczny",
        "Weryfikacja wiedzy",
        "Zrozumienie procesu",
        "Zrozumienie obsługi klienta",
      ],
      award: "Po pomyślnym ukończeniu kursant otrzymuje:",
      awardName: "Certyfikat PUREGLOSS Academy",
    },
    career: {
      eyebrow: "Kariera",
      title: "Możliwości po ukończeniu szkolenia",
      desc: "Najlepsi kursanci mogą uzyskać dostęp do:",
      items: [
        "Program PUREGLOSS Certified Detailer",
        "PUREGLOSS Partner Network",
        "Wyróżniony profil detailera",
        "Przyszłe polecenia klientów",
        "Możliwości przyszłej współpracy",
      ],
      note: "Nie gwarantujemy pracy — to możliwe szanse po pomyślnym ukończeniu.",
    },
    notIncluded: {
      eyebrow: "Nie zawarte",
      title: "Co nie jest zawarte",
      items: [
        "Chemia",
        "Zestaw startowy",
        "Płatna reklama",
        "Zaawansowana praktyka korekty lakieru",
        "Publiczne konto detailera PUREGLOSS",
      ],
    },
    waitlist: {
      eyebrow: "Lista oczekujących",
      title: "Zapisz się na listę",
      desc: "Zostaw kontakt, a powiadomimy Cię o starcie zajęć — z dostępem early-bird.",
      name: "Imię",
      phone: "Telefon",
      email: "E-mail",
      country: "Kraj",
      language: "Język zajęć",
      package: "Interesujący pakiet",
      message: "Wiadomość",
      submit: "Zapisz się",
      sending: "Wysyłanie...",
      successTitle: "Dziękujemy!",
      successMessage: "Twoje zgłoszenie zostało przyjęte. Wkrótce się odezwiemy.",
      error: "Nie udało się wysłać zgłoszenia. Spróbuj ponownie.",
      gdpr: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z Polityką prywatności.",
    },
    future: {
      title: "Wkrótce w Academy",
      items: ["Lekcje wideo", "Moduły kursu", "Certyfikaty", "Panel kursanta", "Zakup kursów"],
    },
    pricing: {
      oldLabel: "Stara cena",
      currentLabel: "Aktualna cena",
      badgePopular: "NAJPOPULARNIEJSZY",
      badgePremium: "PROGRAM PREMIUM",
      save: "Oszczędzasz",
    },
    cohort: {
      eyebrow: "🔥 Pierwsza edycja",
      title: "Pierwsza edycja PUREGLOSS Academy",
      desc: "Tylko pierwszych 20 kursantów dołączy do inauguracyjnej edycji Academy.",
      note: "Po zakończeniu pierwszej edycji mogą zostać otwarte kolejne terminy zapisów.",
    },
    bonuses: {
      eyebrow: "🎁 Bonusy dla kursantów",
      title: "Bonusy dla kursantów",
      desc: "Wszystko w komplecie — gotowe materiały, które oszczędzają tygodnie pracy.",
      items: [
        "Checklisty PDF PUREGLOSS",
        "Skrypty komunikacji z klientem",
        "Lista rekomendowanej chemii",
        "Lista rekomendowanego sprzętu",
        "Szablony kalkulacji cen",
        "Szablony procesu usługi",
      ],
    },
    certificatePreview: {
      eyebrow: "🏅 Certyfikat",
      title: "Certyfikat PUREGLOSS Academy",
      subtitle: "Każdy kursant, który pomyślnie zda egzamin końcowy, otrzymuje oficjalny certyfikat PUREGLOSS Academy.",
      alt: "Podgląd certyfikatu PUREGLOSS Academy",
    },
    earnings: {
      eyebrow: "💰 Potencjał dochodowy",
      title: "Potencjał dochodowy mobilnego detailingu",
      desc: "Przykładowe wyliczenia przy stałym harmonogramie:",
      items: [
        { vehicles: "1 pojazd dziennie", income: "≈ 1 780€ / miesiąc" },
        { vehicles: "2 pojazdy dziennie", income: "≈ 3 560€ / miesiąc" },
        { vehicles: "3 pojazdy dziennie", income: "≈ 5 340€ / miesiąc" },
      ],
      disclaimer:
        "Wyniki zależą od kraju, cen, popytu na rynku, jakości usługi i liczby klientów. Nie gwarantujemy dochodu.",
    },
    network: {
      eyebrow: "🚀 PUREGLOSS Network",
      title: "PUREGLOSS Network",
      desc: "Najlepsi absolwenci mogą otrzymać w przyszłości:",
      items: [
        "Status PUREGLOSS Certified Detailer",
        "Miejsce w przyszłej sieci PUREGLOSS Network",
        "Polecenia klientów w przyszłości",
        "Możliwości współpracy z PUREGLOSS",
      ],
      note: "Nie obiecujemy zatrudnienia — to możliwości na przyszłość.",
    },
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Skontaktuj się z nami",
  },
  brands: {
    eyebrow: "Sprzęt Premium",
    title: "Produkty i sprzęt Premium",
    desc: "Dla profesjonalnych efektów używamy produktów i sprzętu premium wiodących marek.",
    items: [
      { name: "Koch-Chemie", category: "Chemia detailingowa" },
      { name: "Kärcher", category: "Sprzęt profesjonalny" },
    ],
  },
  footer: {
    tagline: "Detailing i pranie tapicerki",
    area: "Obszar działania",
    rights: "Wszelkie prawa zastrzeżone.",
    legal: "Informacje prawne",
    impressum: "Impressum",
    datenschutz: "Polityka prywatności",
    agb: "Regulamin",
    widerruf: "Prawo odstąpienia",
    cookies: "Cookies",
    madeIn: "Stworzone z ★ w Euskirchen",
    verifiedCustomer: "Zweryfikowany klient",
  },
  admin: {
    title: "Admin · Zgłoszenia",
    password: "Hasło",
    signIn: "Zaloguj się",
    invalidPassword: "Nieprawidłowe hasło",
    back: "Powrót do strony",
    logout: "Wyloguj",
    refresh: "Odśwież",
    tabs: {
      overview: "Przegląd",
      auto: "Auto",
      furniture: "Meble",
      bookings: "Rezerwacje",
      newsletter: "Newsletter",
      detailers: "Detailerzy",
      clients: "Klienci",
      academy: "Academy",
      calendar: "Kalendarz",
    },
    stats: {
      autoNew: "Nowe auto",
      furnitureNew: "Nowe meble",
      inProgress: "W trakcie",
      scheduled: "Zaplanowane",
      completed: "Ukończone",
      rejected: "Odrzucone",
      completedMonth: "Ukończone w tym miesiącu",
      completedYear: "Ukończone w tym roku",
      revenue: "Szacowany przychód",
      aov: "Średnia wartość zamówienia",
      totalLeads: "Wszystkie zgłoszenia",
      activeLeads: "Aktywne zgłoszenia",
      conversion: "Konwersja",
      bookings: "Rezerwacje",
      leadVolume: "Wolumen zgłoszeń — ostatnie 14 dni",
      revenueVolume: "Szacowany przychód — ostatnie 14 dni (€)",
      topCities: "Najlepsze miasta",
      topServices: "Najlepsze usługi",
      recentLeads: "Ostatnie zgłoszenia",
      leadsCount: "Liczba zgłoszeń",
      revenueEur: "Przychód",
      noData: "Brak danych",
    },
    statusLabels: {
      NEW: "Nowe",
      IN_PROGRESS: "W trakcie",
      SCHEDULED: "Zaplanowane",
      COMPLETED: "Ukończone",
      REJECTED: "Odrzucone",
    },
    academyStatusLabels: {
      NEW: "Nowe",
      CONTACTED: "Skontaktowany",
      ENROLLED: "Zapisany",
      GRADUATED: "Absolwent",
      REJECTED: "Odrzucony",
    },
    card: {
      phone: "Telefon",
      email: "E-mail",
      city: "Miasto",
      service: "Usługa",
      carModel: "Auto",
      package: "Pakiet",
      message: "Wiadomość",
      photos: "Zdjęcia",
      status: "Status",
      estimatedPrice: "Szacowana cena",
      detailer: "Detailer",
      whatsapp: "WhatsApp",
      call: "Zadzwoń",
      emailAction: "Wyślij e-mail",
      telegram: "Telegram",
      preferredContact: "Forma kontaktu",
      edit: "Edytuj",
      delete: "Usuń",
      duplicate: "Duplikuj",
      internalNotes: "Notatki wewnętrzne",
      internalNotesPlaceholder: "Tylko admin — np. Zadzwonić po 18:00, klient VIP, zabrać ekstraktor...",
      createdAt: "Utworzone",
      updatedAt: "Ostatnia zmiana",
      editLead: "Edytuj zgłoszenie",
      saveChanges: "Zapisz zmiany",
      cancel: "Anuluj",
      deleteLeadTitle: "Usunąć zgłoszenie?",
      deleteLeadDesc: "Czy na pewno chcesz trwale usunąć to zgłoszenie? Tej czynności nie można cofnąć.",
      deleteConfirm: "Usuń",
      leadDeletedToast: "Zgłoszenie usunięte pomyślnie.",
      leadUpdatedToast: "Zgłoszenie zaktualizowane pomyślnie.",
      leadDuplicatedToast: "Zgłoszenie zduplikowane.",
      priceUpdatedToast: "Cena zaktualizowana.",
      notesSavedToast: "Notatki zapisane.",
      actionFailedToast: "Operacja nie powiodła się. Spróbuj ponownie.",
      clickToEditPrice: "Kliknij, aby edytować",
      priceInvalid: "Wprowadź poprawną liczbę (€)",
      emailInvalid: "Wprowadź poprawny e-mail",
      phoneInvalid: "Wprowadź poprawny telefon",
      nameRequired: "Imię jest wymagane",
      phoneRequired: "Telefon jest wymagany",
      detailerNone: "— Brak detailera —",
      estimatedPriceHint: "Przykład: 89, 149, 399",
      serviceHint: "Dowolny tekst: np. Renowacja skóry, Czyszczenie silnika...",
      history: "Historia",
      notSet: "nie ustawiono",
      viewPhotos: "Zobacz zdjęcia",
      unread: "NOWE",
      empty: "Brak zgłoszeń.",
      leadType: "Typ",
      leadTypeAuto: "Auto",
      leadTypeFurniture: "Meble",
      leadTypeAcademy: "Academy",
      leadTypeBooking: "Rezerwacja",
      date: "Data",
      customer: "Klient",
      all: "Wszystkie",
      sort: "Sortuj",
      assignDetailer: "Przypisz detailera",
      requestReview: "Poproś o opinię",
      address: "Adres",
      item: "Pozycja",
      sendWhatsApp: "Wyślij przez WhatsApp",
      sendEmail: "Wyślij e-mailem",
      copyLink: "Skopiuj link",
      copied: "Skopiowano",
      close: "Zamknij",
    },
    sorts: {
      newest: "Najnowsze",
      oldest: "Najstarsze",
      priceDesc: "Najwyższa cena",
      priceAsc: "Najniższa cena",
      city: "Miasto A→Z",
      detailer: "Detailer",
      bookingDate: "Data rezerwacji",
    },
    detailers: {
      title: "Detailerzy",
      id: "ID",
      name: "Imię",
      completedJobs: "Ukończone",
      revenue: "Przychód",
      commission: "Prowizja",
      rating: "Ocena",
      status: "Status",
      active: "aktywny",
      inactive: "nieaktywny",
    },
    newsletterTable: {
      email: "E-mail",
      lang: "Język",
      source: "Źródło",
      created: "Data",
      empty: "Brak subskrybentów.",
    },
    clients: {
      title: "Klienci",
      search: "Szukaj po imieniu, telefonie lub e-mailu…",
      levels: "Brąz 1-2 · Srebro 3-4 · Złoto 5+ ukończonych zleceń",
      name: "Imię",
      orders: "Zamówienia",
      completed: "Ukończone",
      revenue: "Przychód",
      level: "Poziom",
    },
    academy: {
      title: "Academy — Lista oczekujących",
      empty: "Brak wpisów.",
      package: "Pakiet",
      language: "Język",
      totalLabel: "Suma listy oczekujących",
      interestedLabel: "Zainteresowani kursanci",
      enrolledLabel: "Zapisani",
      graduatedLabel: "Absolwenci",
      byLanguageLabel: "Wg języka",
    },
    students: {
      tab: "Kursanci",
      title: "Kursanci Academy",
      empty: "Brak kursantów.",
      add: "Dodaj kursanta",
      edit: "Edytuj",
      delete: "Usuń",
      resetPassword: "Zresetuj hasło",
      activate: "Aktywuj kursanta",
      copyMessage: "Skopiuj wiadomość",
      copied: "Skopiowano",
      cols: {
        studentId: "ID",
        name: "Imię",
        email: "E-mail",
        package: "Pakiet",
        status: "Status",
        startDate: "Start",
        progress: "Postęp",
        actions: "Akcje",
      },
      form: {
        name: "Imię",
        email: "E-mail",
        password: "Hasło",
        newPassword: "Nowe hasło",
        packageType: "Pakiet",
        startDate: "Data startu",
        status: "Status",
        save: "Zapisz",
        cancel: "Anuluj",
        create: "Utwórz",
      },
      statusLabels: {
        Active: "Aktywny",
        Paused: "Wstrzymany",
        Completed: "Ukończony",
      },
      accessMessage:
        "Twój dostęp do PUREGLOSS Academy jest aktywny.\nZaloguj się tutaj:\nhttps://puregloss.eu/academy/login\n\nE-mail:\n{email}\n\nHasło:\n{password}",
    },
    calendar: {
      title: "Kalendarz rezerwacji",
      legendAvailable: "Dostępne",
      legendBooked: "Zarezerwowane",
      legendUnavailable: "Niedostępne",
      blockDay: "Zablokuj dzień",
      unblock: "Odblokuj",
      blocked: "Zablokowane",
      bookings: "Rezerwacje",
    },
  },
  legal: {
    impressum: {
      title: "Impressum",
      subtitle: "Informacje zgodnie z § 5 DDG",
      sections: [
        {
          h: "Usługodawca (§ 5 DDG)",
          p: "PUREGLOSS\nWłaściciel: Vladyslav Lysyi\nForma prawna: Jednoosobowa działalność gospodarcza (Einzelunternehmen)\nRüdesheimer Ring 129\n53879 Euskirchen\nNiemcy",
        },
        {
          h: "Kontakt",
          p: "Telefon: +49 176 22038169\nWhatsApp: +49 176 22038169\nE-mail: info@puregloss.eu\nStrona: https://puregloss.eu",
        },
        {
          h: "Numer identyfikacji VAT",
          p: "Numer identyfikacji podatkowej zgodnie z § 27a niemieckiej ustawy o VAT:\nDE367513046",
        },
        {
          h: "Odpowiedzialny za treści",
          p: "Odpowiedzialny za treści zgodnie z § 18 ust. 2 MStV:\nVladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Niemcy",
        },
        {
          h: "Rozstrzyganie sporów w UE",
          p: "Komisja Europejska udostępnia platformę do rozstrzygania sporów online (ODR): https://ec.europa.eu/consumers/odr\nNasz adres e-mail znajduje się powyżej.",
        },
        {
          h: "Konsumenckie rozstrzyganie sporów",
          p: "Nie jesteśmy skłonni ani zobowiązani do udziału w procedurach rozstrzygania sporów przed konsumencką izbą arbitrażową w rozumieniu § 36 niemieckiej ustawy VSBG.",
        },
        {
          h: "Odpowiedzialność za treści",
          p: "Jako usługodawca odpowiadamy za własne treści zgodnie z § 7 ust. 1 DDG i przepisami ogólnymi. Zgodnie z §§ 8–10 DDG nie mamy jednak obowiązku monitorowania przesyłanych lub przechowywanych informacji osób trzecich.",
        },
        {
          h: "Odpowiedzialność za linki",
          p: "Nasza oferta zawiera linki do zewnętrznych stron osób trzecich, na których treści nie mamy wpływu. Nie ponosimy odpowiedzialności za te zewnętrzne treści. Za treść linkowanych stron zawsze odpowiada ich dostawca lub operator.",
        },
        {
          h: "Prawa autorskie",
          p: "Treści i utwory na tych stronach stworzone przez operatora podlegają niemieckiemu prawu autorskiemu. Kopiowanie, przetwarzanie, rozpowszechnianie i każda forma komercjalizacji poza zakresem prawa autorskiego wymaga pisemnej zgody autora lub twórcy.",
        },
      ],
      back: "Powrót do strony głównej",
    },
    datenschutz: {
      title: "Polityka prywatności",
      subtitle: "RODO / BDSG-neu / TTDSG",
      sections: [
        { h: "1. Administrator", p: "Administratorem danych osobowych zgodnie z RODO jest:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129\n53879 Euskirchen, Niemcy\nTelefon: +49 176 22038169\nE-mail: info@puregloss.eu" },
        { h: "2. Informacje ogólne", p: "Traktujemy ochronę Twoich danych osobowych bardzo poważnie i przetwarzamy je poufnie zgodnie z RODO, BDSG-neu i TTDSG. Dane osobowe są zbierane tylko w zakresie niezbędnym do realizacji naszych zobowiązań umownych i prawnych lub gdy wyraziłeś na to wyraźną zgodę." },
        { h: "3. Szyfrowanie SSL/TLS", p: "Ta strona używa szyfrowania SSL/TLS ze względów bezpieczeństwa i dla ochrony transmisji treści poufnych. Szyfrowane połączenie rozpoznasz po adresie „https://” i ikonie kłódki w przeglądarce." },
        { h: "4. Pliki dziennika serwera / hosting", p: "Ta strona jest hostowana przez Emergent Labs, Inc. Dostawca automatycznie zbiera pliki dziennika zawierające adres IP (zapisywany w skróconej formie), datę/godzinę zapytania, żądany URL, referrer, przeglądarkę i system operacyjny. Dane wykorzystywane są wyłącznie do dostarczania technicznego, bezpieczeństwa i analizy błędów. Podstawa prawna: art. 6 ust. 1 lit. f RODO. Okres przechowywania: maks. 30 dni." },
        { h: "5. Kontakt (e-mail, telefon, WhatsApp)", p: "Gdy kontaktujesz się z nami mailem, telefonem lub komunikatorem, zapisujemy Twoje dane (imię, dane kontaktowe, wiadomość) w celu obsługi zapytania i ewentualnych pytań uzupełniających. Podstawa prawna: art. 6 ust. 1 lit. b RODO (umowa) lub art. 6 ust. 1 lit. f RODO (uzasadniony interes). Dane usuwamy, gdy przestają być potrzebne, najpóźniej po upływie ustawowych okresów przechowywania (§ 257 HGB, § 147 AO – do 10 lat)." },
        { h: "6. Formularz wyceny / zapytania", p: "Przez nasz formularz możesz poprosić o niezobowiązującą wycenę. Przetwarzamy: imię, telefon, e-mail (opcjonalnie), miasto/lokalizację, dane pojazdu/obiektu, przesłane zdjęcia, preferowany kanał kontaktu i Twoją wiadomość. Dane wykorzystujemy wyłącznie do przygotowania wyceny i ustalenia terminu. Podstawa prawna: art. 6 ust. 1 lit. b RODO." },
        { h: "7. Formularz rezerwacji", p: "Dla wiążącej rezerwacji dodatkowo zbieramy adres (miejsce usługi), datę i godzinę. Dane te są niezbędne do wykonania naszej usługi mobilnej. Podstawa prawna: art. 6 ust. 1 lit. b RODO." },
        { h: "8. WhatsApp", p: "Nasza strona zawiera przyciski otwierające czat WhatsApp (WhatsApp Ireland Limited, część grupy Meta). Dopiero po aktywnym kliknięciu przycisku WhatsApp nawiązywane jest połączenie z serwerami WhatsApp/Meta, a Twoja wiadomość i numer telefonu są im przekazywane. Część przetwarzania odbywa się poza UE (USA). Podstawa prawna: art. 6 ust. 1 lit. a RODO (zgoda przez aktywne kliknięcie) i art. 6 ust. 1 lit. b RODO. Szczegóły: https://www.whatsapp.com/legal/privacy-policy-eea." },
        { h: "9. PUREGLOSS CLUB (program bonusowy)", p: "Przy dołączeniu do PUREGLOSS CLUB przetwarzamy: imię (opcjonalnie), e-mail, preferowany język, moment dołączenia i systemowo wygenerowany kod vouchera. Cel: wydanie i zarządzanie jednorazowym voucherem powitalnym 25€, udostępnienie PDF, dowód zgody i komunikacja z klientem w sprawie programu bonusowego. Podstawa prawna: art. 6 ust. 1 lit. a i b RODO. Możesz w każdej chwili wycofać zgodę ze skutkiem na przyszłość (info@puregloss.eu)." },
        { h: "10. Newsletter / promocje", p: "W celu wysyłki informacji promocyjnych zapisujemy Twój adres e-mail, moment udzielenia zgody oraz Twój adres IP i user-agent przeglądarki jako dowód zgody. Zapis następuje dopiero po aktywnym potwierdzeniu checkboxa zgody. W każdej chwili możesz się wypisać, pisząc na info@puregloss.eu; usuniemy Twoje dane niezwłocznie, najpóźniej w ciągu 7 dni. Podstawa prawna: art. 6 ust. 1 lit. a RODO." },
        { h: "11. Wysyłka e-mail (Resend)", p: "Do wysyłki e-maili transakcyjnych i promocyjnych używamy Resend (Resend, Inc., San Francisco, CA, USA). Przetwarzane są Twój adres e-mail, treść wiadomości i metadane dostarczenia (znaczniki czasu, status bounce). Zawarto umowę powierzenia zgodnie z art. 28 RODO. Podstawa prawna: art. 6 ust. 1 lit. b i f RODO. Transfer do państwa trzeciego (USA) jest zabezpieczony standardowymi klauzulami umownymi UE (art. 46 RODO). Szczegóły: https://resend.com/legal/privacy-policy." },
        { h: "12. Cookies i local storage", p: "Ta strona używa wyłącznie ściśle niezbędnego local storage w przeglądarce („localStorage”), aby zapewnić podstawowe funkcje (język, stan popupa CLUB, preferencje zgody). Dane pozostają w Twojej przeglądarce i nie są nam przekazywane. NIE stosujemy plików cookie marketingowych, śledzących, analitycznych ani osób trzecich. Podstawa prawna: § 25 ust. 2 nr 2 TTDSG (ściśle niezbędne)." },
        { h: "13. Czcionki", p: "Dla spójności wizualnej używamy kroju „Cabinet Grotesk” dostarczanego przez Fontshare (Indian Type Foundry Pvt. Ltd., Ahmedabad, Indie). Podczas ładowania strony nawiązywane jest połączenie z serwerami Fontshare, przy czym może zostać przekazany Twój adres IP. Podstawa prawna: art. 6 ust. 1 lit. f RODO. Google Fonts nie są już używane; pozostałe czcionki są ładowane z systemu użytkownika, przez co nie ma transferu danych." },
        { h: "14. Materiały graficzne", p: "Ta strona zawiera zdjęcia przed/po, obrazy portfolio i zdjęcia stockowe. Dane identyfikacyjne (tablice rejestracyjne, osoby w pojazdach) są anonimizowane lub usuwane przed publikacją." },
        { h: "15. Przesyłanie plików", p: "Zdjęcia przesłane przez nasz formularz zapytania są przechowywane w naszej infrastrukturze i wykorzystywane wyłącznie do przygotowania wyceny. Podstawa prawna: art. 6 ust. 1 lit. b RODO. Usunięcie następuje najpóźniej 12 miesięcy po zamknięciu Twojego zapytania." },
        { h: "16. Odbiorcy / udostępnianie osobom trzecim", p: "Dane osobowe udostępniamy wyłącznie: naszemu dostawcy e-mail (Resend), naszemu dostawcy hostingu (Emergent Labs, Inc.) oraz – jeśli z niego korzystasz – WhatsApp/Meta. Wszyscy dostawcy są zobowiązani umownie do przestrzegania RODO. NIE przekazujemy danych innym stronom trzecim w celach reklamowych." },
        { h: "17. Przechowywanie", p: "Dane osobowe przechowujemy tylko tak długo, jak jest to niezbędne do celu lub wymagane ustawowo (zwykle 6 lat wg § 257 HGB, 10 lat wg § 147 AO dla dokumentów podatkowych)." },
        { h: "18. Twoje prawa jako osoby, której dane dotyczą", p: "Zgodnie z RODO przysługują Ci następujące prawa:\n• dostęp (art. 15)\n• sprostowanie (art. 16)\n• usunięcie (art. 17)\n• ograniczenie (art. 18)\n• przenoszenie danych (art. 20)\n• sprzeciw (art. 21)\n• wycofanie zgody ze skutkiem na przyszłość (art. 7 ust. 3)\n\nAby skorzystać z tych praw, wystarczy nieformalna wiadomość na info@puregloss.eu." },
        { h: "19. Prawo do skargi do organu nadzorczego", p: "Masz prawo złożyć skargę do organu nadzorczego dotyczącą przetwarzania Twoich danych osobowych. Właściwy organ dla naszej siedziby to:\n\nLandesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)\nKavalleriestraße 2-4, 40213 Düsseldorf\nTelefon: +49 211 38424-0\nE-mail: poststelle@ldi.nrw.de\nhttps://www.ldi.nrw.de" },
        { h: "20. Aktualizacje", p: "Ta polityka prywatności obowiązuje w aktualnej wersji. W związku z aktualizacjami strony lub zmianami przepisów może być konieczna jej modyfikacja. Aktualną wersję znajdziesz zawsze pod adresem https://puregloss.eu/datenschutz." },
        { h: "21. Dziennik bezpieczeństwa rejestracji (PUREGLOSS Club)", p: "Przy każdej nowej rejestracji w PUREGLOSS Club dodatkowo zapisujemy informacje techniczne w celu zapewnienia bezpieczeństwa, zapobiegania oszustwom, ochrony przed spamem i wykrywania nadużyć. Obejmuje to: Twój adres IP, przybliżoną lokalizację (kraj, region, przybliżone miasto) ustaloną na podstawie tego adresu IP — nigdy dokładnej pozycji, — informacje o przeglądarce i urządzeniu (User-Agent, system operacyjny, typ urządzenia) oraz znacznik czasu rejestracji. Lokalizacja jest zawsze przybliżona i nie służy indywidualnej identyfikacji. Podstawa prawna: art. 6 ust. 1 lit. f RODO (uzasadniony interes w zapewnieniu bezpiecznej i wolnej od nadużyć usługi). Informacje te są dostępne wyłącznie wewnętrznie i nie są udostępniane osobom trzecim, z wyjątkiem technicznie niezbędnej usługi geolokalizacji IP." },
      ],
      back: "Powrót do strony głównej",
    },
    agb: {
      title: "Ogólne warunki handlowe",
      subtitle: "Stan: luty 2026",
      sections: [
        { h: "§ 1 Zakres obowiązywania", p: "Niniejsze Ogólne Warunki Handlowe mają zastosowanie do wszystkich umów między PUREGLOSS – Vladyslav Lysyi („Usługodawca”) a konsumentami lub przedsiębiorcami („Klient”) dotyczących usług oferowanych na https://puregloss.eu (mobilny detailing, pranie wnętrza i mycie zewnętrzne, pranie tapicerki i kanap)." },
        { h: "§ 2 Zawarcie umowy", p: "Prezentacja usług na stronie nie stanowi prawnie wiążącej oferty, lecz zaproszenie do składania ofert (invitatio ad offerendum). Klient składa niezobowiązujące zapytanie przez formularz; Usługodawca przygotowuje następnie indywidualną wycenę mailem, telefonicznie lub przez WhatsApp. Umowa dochodzi do skutku po wyraźnej akceptacji oferty przez obie strony lub po rozpoczęciu wykonywania usługi." },
        { h: "§ 3 Zakres usług", p: "Dokładny zakres usług określa indywidualna wycena. Stan pojazdu lub obiektu może wpływać na nakład pracy i cenę końcową; istotne zmiany są uzgadniane z klientem przed realizacją." },
        { h: "§ 4 Ceny i płatność", p: "Wszystkie ceny są w euro z ustawowym VAT. Płatność następuje na miejscu po wykonaniu usługi gotówką lub – gdzie oferowane – kartą / przelewem natychmiastowym. W przypadku zwłoki obowiązują przepisy ustawowe (§§ 286 i nast. BGB)." },
        { h: "§ 5 Terminy, anulowanie, opóźnienie", p: "Terminy potwierdzane są mailem lub komunikatorem. Klient może bezpłatnie anulować lub przełożyć potwierdzony termin do 24 godzin przed rozpoczęciem. Po tym czasie może zostać naliczona opłata w wysokości 50% uzgodnionej ceny. Jeśli Usługodawca nie może stawić się z ważnego powodu, niezwłocznie proponowany jest nowy termin." },
        { h: "§ 6 Obowiązki współpracy klienta", p: "Klient zapewnia odpowiednie miejsce pracy (dostęp do pojazdu/obiektu, wystarczającą przestrzeń, dostęp do wody w razie potrzeby, prąd 230 V). Rzeczy osobiste muszą zostać usunięte przed rozpoczęciem prac." },
        { h: "§ 7 Rękojmia i odpowiedzialność", p: "Obowiązują ustawowe prawa z rękojmi. Usługodawca ponosi nieograniczoną odpowiedzialność za szkody na życiu, ciele lub zdrowiu oraz za działanie umyślne lub rażąco niedbałe. W przypadku zwykłego niedbalstwa – z wyjątkiem naruszenia istotnych obowiązków umownych – odpowiedzialność jest wyłączona. W pozostałych przypadkach odpowiedzialność ogranicza się do typowych, przewidywalnych szkód. Usługodawca nie odpowiada za istniejące wcześniej uszkodzenia (rysy, odpryski, zaschnięte plamy); takie uszkodzenia są na życzenie dokumentowane przed rozpoczęciem prac." },
        { h: "§ 8 Prawo konsumenta do odstąpienia", p: "Konsumentom przysługuje ustawowe prawo odstąpienia zgodnie z § 312g w związku z § 355 BGB. Szczegóły w naszym Pouczeniu o odstąpieniu." },
        { h: "§ 9 Rozstrzyganie sporów", p: "Komisja UE udostępnia platformę online do rozstrzygania sporów: https://ec.europa.eu/consumers/odr. Nie jesteśmy skłonni ani zobowiązani do udziału w postępowaniu przed konsumencką izbą arbitrażową." },
        { h: "§ 10 Postanowienia końcowe", p: "Stosuje się prawo niemieckie z wyłączeniem Konwencji Wiedeńskiej. Miejscem wykonania jest Euskirchen. W dopuszczalnym prawem zakresie właściwość miejscowa to siedziba Usługodawcy. Jeżeli poszczególne postanowienia okażą się nieważne, pozostałe postanowienia pozostają w mocy." },
      ],
      back: "Powrót do strony głównej",
    },
    widerruf: {
      title: "Pouczenie o prawie odstąpienia",
      subtitle: "Twoje prawa jako konsumenta",
      sections: [
        { h: "Prawo odstąpienia", p: "Masz prawo odstąpić od niniejszej umowy w ciągu czternastu dni bez podania przyczyny. Termin odstąpienia wynosi czternaście dni od dnia zawarcia umowy.\n\nAby skorzystać z prawa odstąpienia, musisz poinformować nas:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Niemcy\nTelefon: +49 176 22038169\nE-mail: info@puregloss.eu\n\no swojej decyzji o odstąpieniu w drodze jednoznacznego oświadczenia (np. listem lub e-mailem). Możesz skorzystać z poniższego wzorca, ale nie jest to obowiązkowe.\n\nDo dochowania terminu odstąpienia wystarczy, że wyślesz oświadczenie przed jego upływem." },
        { h: "Skutki odstąpienia", p: "W przypadku odstąpienia zwrócimy Ci wszystkie otrzymane od Ciebie płatności, w tym koszty dostawy (z wyjątkiem dodatkowych kosztów wynikających z wybranego przez Ciebie sposobu dostawy innego niż najtańszy oferowany standardowy sposób), niezwłocznie, a w każdym razie nie później niż 14 dni od dnia otrzymania powiadomienia o odstąpieniu. Zwrotu dokonamy tym samym sposobem płatności, którego użyłeś, chyba że wyraźnie ustalono inaczej; w żadnym wypadku nie poniesiesz z tego tytułu żadnych opłat." },
        { h: "Wcześniejsze wygaśnięcie prawa odstąpienia dla usług", p: "Prawo odstąpienia od umów o świadczenie usług wygasa, jeśli przedsiębiorca w pełni wykonał usługę i rozpoczął jej wykonywanie po wyraźnej uprzedniej zgodzie konsumenta i potwierdzeniu przyjęcia do wiadomości, że utraci on prawo odstąpienia po pełnym wykonaniu (§ 356 ust. 4 BGB)." },
        { h: "Wzór formularza odstąpienia", p: "(Jeśli chcesz odstąpić od umowy, wypełnij i odeślij ten formularz.)\n\nDo: PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen, Niemcy, E-mail: info@puregloss.eu\n\nJa/My (*) niniejszym informuję/informujemy (*) o odstąpieniu od mojej/naszej (*) umowy sprzedaży następujących towarów (*)/umowy o świadczenie następującej usługi (*):\n\n___________________________________\n\nZamówionych dnia (*)/otrzymanych dnia (*):\n___________________________________\n\nImię i nazwisko konsumenta(-ów):\n___________________________________\n\nAdres konsumenta(-ów):\n___________________________________\n\nData: _______________\n\nPodpis konsumenta(-ów) (tylko przy formularzu papierowym):\n___________________________________\n\n(*) Niepotrzebne skreślić." },
      ],
      back: "Powrót do strony głównej",
    },
    cookies: {
      title: "Polityka Cookies",
      subtitle: "Cookies i local storage",
      sections: [
        { h: "1. Zasada", p: "Ta strona NIE używa plików cookie śledzących, marketingowych ani osób trzecich. Narzędzia analityczne takie jak Google Analytics, Google Tag Manager czy Meta Pixel NIE są używane. Korzystamy wyłącznie ze ściśle niezbędnego local storage przeglądarki." },
        { h: "2. Cel local storage", p: "W Twojej przeglądarce zapisujemy:\n• wybrany język (np. DE/EN/UA/PL/RU)\n• informację, że dołączyłeś do PUREGLOSS CLUB (aby popup się nie pokazywał ponownie)\n• preferencje interfejsu (np. ostatni aktywny formularz)\n\nDane te nigdy nie opuszczają Twojej przeglądarki i NIE są przekazywane na nasze serwery ani osobom trzecim." },
        { h: "3. Podstawa prawna", p: "Opisane wyżej przechowywanie jest ściśle niezbędne do prawidłowego działania strony (§ 25 ust. 2 nr 2 TTDSG) i nie wymaga odrębnej zgody." },
        { h: "4. Usuwanie / sprzeciw", p: "Local storage możesz w dowolnym momencie usunąć w ustawieniach przeglądarki (np. Chrome → Ustawienia → Prywatność i bezpieczeństwo → Wyczyść dane przeglądania → „Pliki cookie i inne dane witryn”). Po usunięciu strona wróci do stanu domyślnego." },
        { h: "5. Usługi zewnętrzne", p: "Jeśli aktywnie klikniesz przycisk WhatsApp, opuszczasz naszą stronę i wchodzisz w środowisko, w którym WhatsApp/Meta może ustawiać własne cookies. Jest to poza naszą kontrolą. Zobacz nasza polityka prywatności, sekcja WhatsApp." },
      ],
      back: "Powrót do strony głównej",
    },
  },
};

// ---------------------------------------------------------------------------
// Russian (RU) — complete native dictionary. Written natively in professional
// business Russian ("Вы"-form) appropriate for a premium mobile detailing
// service. Structure mirrors translations.en exactly (full key parity).
// ---------------------------------------------------------------------------
translations.ru = {
  seo: {
    title: "PUREGLOSS — Мобильный автодетейлинг и химчистка мебели Euskirchen",
    description:
      "Мобильный детейлинг автомобилей и профессиональная химчистка диванов с выездом. Euskirchen • Bonn • Brühl • Wesseling • Köln • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen и окрестности. Бесплатная оценка в течение 1 часа.",
    keywords:
      "Auto Detailing Euskirchen, Mobile Detailing Euskirchen, детейлинг Euskirchen, химчистка диванов Euskirchen, мобильная химчистка мебели, автодетейлинг",
  },
  nav: {
    home: "Главная",
    services: "Услуги",
    beforeAfter: "До / После",
    reviews: "Отзывы",
    prices: "Цены",
    serviceArea: "Зона обслуживания",
    promotions: "Акции",
    faq: "FAQ",
    contact: "Контакты",
    academy: "Academy",
    works: "Наши работы",
    club: "PUREGLOSS CLUB",
    cta: "WhatsApp",
  },
  cta: {
    getPrice: "Узнать цену",
    getPriceShort: "Цена",
    bookAppointment: "Забронировать",
    bookAppointmentShort: "Бронь",
    checkAvailability: "Проверить доступность в вашем городе",
    joinWaitingList: "Записаться в лист ожидания",
    whatsapp: "WhatsApp",
    readyTitle: "Готовы начать?",
    readyDesc: "Получите быструю оценку или забронируйте выезд.",
  },
  promotions: {
    eyebrow: "Акции и специальные предложения",
    title: "Акции и специальные предложения",
    desc: "Узнавайте первыми о сезонных скидках, пакетах и эксклюзивных предложениях PUREGLOSS.",
    nameLabel: "Имя (по желанию)",
    emailLabel: "E-mail",
    emailPlaceholder: "ваш@email.com",
    cta: "Подписаться",
    gdpr: "Я согласен на получение маркетинговых сообщений в соответствии с",
    successTitle: "Спасибо!",
    successMessage: "Вы добавлены в список специальных предложений PUREGLOSS.",
    error: "Не удалось подписаться. Попробуйте ещё раз.",
  },
  ctaBlocks: {
    services: { title: "Готовы начать?", desc: "Получите быструю оценку или забронируйте выезд.", primary: "Узнать цену", secondary: "Забронировать" },
    pricing: { title: "Выбрали пакет?", desc: "Забронируйте слот или запросите точную оценку.", primary: "Узнать цену", secondary: "Забронировать" },
    serviceArea: { title: "Мы выезжаем к вам", desc: "Проверьте доступность в вашем городе.", primary: "Проверить доступность", secondary: "Забронировать" },
    academy: { title: "PUREGLOSS Academy", desc: "Обучение мобильному детейлингу в Германии. Набор откроется скоро.", primary: "В лист ожидания" },
  },
  serviceAreaMap: {
    title: "Зона обслуживания",
    desc: "Мобильный сервис в Euskirchen, Кёльне, Бонне и окрестных городах.",
    mobileTag: "Мобильный сервис — мы выезжаем к вам",
    cityAvailability: "Мобильный сервис у вас",
  },
  trustBadge: "Бесплатная оценка в течение 1 часа",
  floatingEstimate: "Бесплатная оценка по запросу",
  basedIn: "База: Euskirchen",
  whatsappConsent: {
    eyebrow: "Уведомление о конфиденциальности",
    title: "Сейчас откроется WhatsApp",
    body: "После подтверждения ваш номер телефона и сообщение будут переданы в WhatsApp Ireland Ltd. (Meta). Часть обработки происходит за пределами ЕС (США).",
    details: "Правовое основание: ст. 6 (1) (a) GDPR (согласие). Подробнее в нашей",
    datenschutzLink: "Политике конфиденциальности",
    confirm: "Перейти в WhatsApp",
    cancel: "Отмена",
    close: "Закрыть",
  },
  fullAreaText:
    "Euskirchen • Bonn • Brühl • Wesseling • Кёльн • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen и окрестности",
  hero: {
    eyebrow: "Мобильный детейлинг • Euskirchen",
    title: "PUREGLOSS",
    subtitle: "Детейлинг и химчистка мебели",
    desc: "Мобильный автодетейлинг и профессиональная химчистка диванов — мы выезжаем к вам.",
    ctaPrimary: "Получить оценку",
    ctaSecondary: "Написать в WhatsApp",
    scroll: "Прокрутить",
  },
  area: {
    label: "Зона обслуживания",
    suffix: "и окрестности",
  },
  services: {
    eyebrow: "Услуги",
    title: "Премиум-уход за вашим авто и мебелью",
    desc: "Профессиональный мобильный сервис — всё, чтобы ваши вещи снова выглядели безупречно.",
    vehicleTitle: "Детейлинг автомобиля",
    vehicleItems: [
      "Химчистка салона",
      "Чистка сидений",
      "Уход за кожей",
      "Удаление запахов",
      "Ручная мойка",
      "Чистка дисков",
      "Уход за шинами",
      "Предпродажная подготовка",
    ],
    sofaTitle: "Химчистка мягкой мебели",
    sofaItems: [
      "Диваны",
      "Кресла",
      "Матрасы",
      "Мягкая мебель",
      "Удаление пятен",
      "Удаление запахов",
      "Глубокая чистка",
      "Чистка ковров",
    ],
  },
  pricing: {
    eyebrow: "Цены",
    title: "Прозрачные цены",
    auto: "Авто",
    polishing: "Полировка и коррекция ЛКП",
    furniture: "Мебель",
    from: "от",
    items: {
      auto: [
        { name: "Химчистка салона", price: "49€" },
        { name: "Мойка кузова", price: "39€" },
        { name: "Полный пакет", price: "89€" },
        { name: "Предпродажная подготовка", price: "119€" },
      ],
      furniture: [
        { name: "Кресло", price: "25€" },
        { name: "Диван 2-местный", price: "49€" },
        { name: "Диван 3-местный", price: "69€" },
        { name: "Угловой диван", price: "99€" },
        { name: "Матрас", price: "39€" },
      ],
    },
    note: "Точная цена зависит от состояния автомобиля или мебели. Пришлите фото — сделаем бесплатную оценку.",
    lockedBadge: "УЖЕ СКОРО",
    lockedTitle: "Полировка и коррекция ЛКП",
    lockedDesc:
      "Профессиональная коррекция лакокрасочного покрытия и машинная полировка временно недоступны — запуск состоится в ближайшее время.",
    lockedDisabled: "Бронирование временно недоступно",
    ctaGetEstimate: "Получить оценку",
    lockedItems: [
      { name: "Полировка в 1 этап", price: "149€" },
      { name: "Полировка в 2 этапа", price: "249€" },
      { name: "Полировка в 3 этапа", price: "349€" },
    ],
  },
  stats: [
    { value: "100%", label: "Мобильный сервис" },
    { value: "PRO", label: "Премиум-продукты" },
    { value: "24/7", label: "Гибкие слоты" },
    { value: "★★★★★", label: "Профессиональный результат" },
  ],
  beforeAfter: {
    eyebrow: "Результаты",
    title: "До и после",
    desc: "Потяните ползунок, чтобы увидеть разницу.",
    categories: { cars: "Автомобили", sofas: "Диваны" },
    beforeLabel: "До",
    afterLabel: "После",
  },
  instaProof: {
    eyebrow: "Портфолио",
    title: "Наши реальные работы",
    desc: "Смотрите настоящие результаты PUREGLOSS: авто, диваны, матрасы и другие работы «до / после».",
    stats: ["Реальные клиенты", "Фото до / после", "Новые работы каждую неделю"],
    cta: "Смотреть все работы",
    handle: "@puregloss.eu",
  },
  serviceLabels: {
    Innenraum: "Салон",
    "Außenreinigung": "Мойка кузова",
    Sitzreinigung: "Чистка сидений",
    Lederpflege: "Уход за кожей",
    Felgenreinigung: "Чистка дисков",
    Politur: "Полировка",
    Scheinwerfer: "Фары",
  },
  furnitureServiceLabels: {
    Sofa: "Диван",
    Matratze: "Матрас",
    Sessel: "Кресло",
    "Stühle": "Стулья",
    Bürostuhl: "Офисный стул",
    Teppich: "Ковёр",
    Polster: "Обивка",
  },
  brandLabels: {
    Audi: "Audi", BMW: "BMW", "Mercedes-Benz": "Mercedes-Benz",
    Porsche: "Porsche", Volkswagen: "Volkswagen", Tesla: "Tesla",
    Skoda: "Skoda", Ford: "Ford", Opel: "Opel", Toyota: "Toyota",
    Hyundai: "Hyundai", Other: "Другая",
  },
  furnitureTypeLabels: {
    "2-Sitzer Sofa": "Диван 2-местный",
    "3-Sitzer Sofa": "Диван 3-местный",
    Ecksofa: "Угловой диван",
    Matratze: "Матрас",
    Sessel: "Кресло",
    Stuhl: "Стул",
    Bürostuhl: "Офисный стул",
    Teppich: "Ковёр",
    Other: "Другое",
  },
  works: {
    heroTitle: "Наши работы",
    heroSubtitle: "Настоящие результаты нашей работы: авто, диваны, матрасы и мягкая мебель.",
    empty: "Работы скоро появятся.",
    filterAll: "Все",
    filterCategory: "Категория",
    filterService: "Услуга",
    filterBrand: "Марка",
    filterType: "Тип мебели",
    catVehicle: "Автомобили",
    catFurniture: "Мебель",
    viewBtn: "Смотреть",
    getPriceCta: "Узнать цену",
    beforeLabel: "До",
    afterLabel: "После",
    cityLabel: "Город",
    serviceLabel: "Услуга",
    brandLabel: "Марка",
    modelLabel: "Модель",
    typeLabel: "Тип",
    descriptionLabel: "Описание",
    sliderHint: "Потяните, чтобы сравнить",
    beforeGallery: "Фото «до»",
    afterGallery: "Фото «после»",
    close: "Закрыть",
    photoSoon: "Фото скоро добавим",
    getSameServiceCta: "Получить оценку",
    likeResultTitle: "Нравится результат?",
    likeResultDesc: "Такой же результат мы можем сделать для вашего авто или мебели.",
    ctaFreeQuote: "Бесплатная оценка",
    ctaBookSlot: "Забронировать выезд",
  },
  club: {
    title: "Добро пожаловать в PUREGLOSS CLUB",
    subtitle: "Откройте эксклюзивные привилегии и станьте участником — бесплатно.",
    benefit1: "🎁 Приветственный ваучер 25 € при заказе от 100 €",
    benefit2: "⚡ Ранний доступ к акциям и предложениям",
    benefit3: "👑 Эксклюзивные преимущества для участников PUREGLOSS CLUB",
    benefit4: "",
    nameLabel: "Имя (по желанию)",
    emailLabel: "E-mail",
    gdpr: "Я согласен на обработку моих данных в соответствии с Политикой конфиденциальности.",
    joinCta: "Стать участником бесплатно",
    joining: "Обработка...",
    finePrint: "Ваучер действует 6 месяцев, используется один раз. Минимальная сумма заказа 100 €.",
    close: "Закрыть",
    alreadyRegistered: "Этот e-mail уже зарегистрирован в PUREGLOSS CLUB.",
    genericError: "Не удалось вступить. Попробуйте ещё раз.",
    emailInvalid: "Введите корректный e-mail",
    gdprRequired: "Пожалуйста, примите Политику конфиденциальности",
    successTitle: "Добро пожаловать в PUREGLOSS CLUB!",
    successMessage: "Ваш приветственный ваучер на 25 € активирован. Он действует на любую услугу PUREGLOSS при заказе от 100 €.",
    successCta: "Запросить бесплатную оценку",
  },
  clubAdmin: {
    tab: "PUREGLOSS CLUB",
    empty: "Участников клуба пока нет.",
    filterAll: "Все",
    filterActive: "Активные",
    filterUsed: "Использованные",
    filterExpired: "Истёкшие",
    filterEmailNotSent: "E-mail не отправлен",
    filterEmailSent: "E-mail отправлен",
    searchPlaceholder: "Поиск по имени, e-mail или коду ваучера",
    newMemberBtn: "Новый участник",
    newMemberTitle: "Создать участника клуба",
    sendWelcomeCheckbox: "Отправить приветственное письмо сейчас",
    createBtn: "Создать",
    redeemBtn: "Погасить ваучер",
    redeemTitle: "Погасить ваучер?",
    redeemDesc: "Статус изменится на «Использован», а дата погашения будет сохранена.",
    redeemConfirm: "Погасить",
    redeemed: "Ваучер погашен.",
    regenerateBtn: "Перегенерировать PDF",
    regenerated: "PDF ваучера перегенерирован.",
    emptySearch: "По вашему запросу ничего не найдено.",
    colName: "Имя",
    colEmail: "E-mail",
    colJoined: "Вступление",
    colBonusStart: "Начало бонуса",
    colBonusEnd: "Конец бонуса",
    colBonus: "Приветственный бонус",
    colCondition: "Условие",
    colSecond: "Вторая химчистка",
    colVoucherCode: "Код ваучера",
    colStatus: "Статус",
    colEmailStatus: "E-mail",
    statusActive: "активный",
    statusUsed: "использован",
    statusExpired: "истёк",
    emailNotSent: "не отправлен",
    emailSent: "отправлен",
    emailFailed: "ошибка",
    markUsed: "Отметить как использованный",
    markActive: "Отметить как активный",
    markExpired: "Отметить как истёкший",
    editBtn: "Изменить",
    deleteBtn: "Удалить",
    sendWelcome: "Отправить приветственное письмо",
    deleteTitle: "Удалить участника клуба?",
    deleteDesc: "Вы уверены, что хотите удалить этого участника?",
    deleteConfirm: "Удалить",
    cancel: "Отмена",
    resendNotConnected: "Отправка e-mail будет подключена через Resend на следующем шаге.",
    emailSentToast: "Приветственное письмо успешно отправлено.",
    emailFailedToast: "Не удалось отправить письмо",
    updated: "Участник обновлён.",
    deleted: "Участник удалён.",
    actionFailed: "Действие не выполнено.",
    editTitle: "Редактировать участника",
    notesLabel: "Заметки",
    saveBtn: "Сохранить",
  },
  worksAdmin: {
    tab: "Работы",
    addBtn: "Добавить работу",
    editBtn: "Изменить",
    deleteBtn: "Удалить",
    publish: "Опубликовано",
    draft: "Черновик",
    statusLabel: "Статус",
    createTitle: "Новая работа",
    editTitle: "Редактировать работу",
    titleField: "Название",
    titlePlaceholder: "напр. BMW M3 — полный детейлинг салона",
    categoryField: "Категория",
    serviceField: "Услуга",
    brandField: "Марка авто",
    modelField: "Модель",
    furnitureTypeField: "Тип мебели",
    cityField: "Город",
    descriptionField: "Краткое описание",
    beforePhotos: "Фото «до» (до 5)",
    afterPhotos: "Фото «после» (до 5)",
    uploadBtn: "Загрузить фото",
    selectPlaceholder: "— Выберите —",
    cancel: "Отмена",
    save: "Сохранить",
    empty: "Работ пока нет. Нажмите «Добавить работу», чтобы создать первую.",
    deleteTitle: "Удалить работу?",
    deleteDesc: "Вы уверены, что хотите удалить эту работу? Это действие нельзя отменить.",
    workCreated: "Работа создана.",
    workUpdated: "Работа обновлена.",
    workDeleted: "Работа удалена.",
    actionFailed: "Действие не выполнено.",
    maxPhotos: "Максимум 5 фото.",
    requiredCategory: "Пожалуйста, выберите категорию",
    uploadFailed: "Не удалось загрузить фото: ",
    unsupportedFile: "Неподдерживаемый файл: ",
    supportedFormats: "Допустимо: JPG, PNG, WEBP",
    uploadingProgress: "Загрузка {done}/{total}...",
  },
  reviews: {
    eyebrow: "Отзывы",
    title: "Что говорят наши клиенты",
    items: [
      { text: "После предпродажной подготовки машина стала выглядеть заметно лучше и продалась быстрее.", author: "Андреас К.", city: "Köln" },
      { text: "Мы уже собирались выбросить диван, но после чистки он снова выглядит как новый.", author: "Марина С.", city: "Bonn" },
      { text: "Очень удобно, что специалист приезжает домой. Всё сделали аккуратно.", author: "Томас Л.", city: "Euskirchen" },
      { text: "Честная цена, отличный результат и профессиональный подход.", author: "Олена П.", city: "Brühl" },
      { text: "Рекомендую PUREGLOSS. Обязательно обращусь снова.", author: "Маркус Б.", city: "Hürth" },
    ],
  },
  howItWorks: {
    eyebrow: "Как это работает",
    title: "Простой процесс",
    steps: [
      "Вы присылаете фото",
      "Получаете оценку стоимости",
      "Выбираем удобное время",
      "Мы приезжаем к вам",
      "Наслаждаетесь результатом",
    ],
  },
  newsletter: {
    eyebrow: "Рассылка",
    title: "Не пропускайте акции и специальные предложения",
    placeholder: "ваш@email.com",
    cta: "Подписаться",
    thanks: "Спасибо за подписку!",
    gdpr: "Я согласен на обработку моих данных в соответствии с Политикой конфиденциальности.",
    error: "Не удалось подписаться. Попробуйте ещё раз.",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Частые вопросы",
    items: [
      { q: "Сколько стоит химчистка авто?", a: "Цены начинаются от 39€ за мойку кузова и 49€ за химчистку салона. Полный пакет — от 89€. Точная цена зависит от состояния." },
      { q: "Сколько длится чистка?", a: "Обычно 2–5 часов в зависимости от состояния и выбранного пакета." },
      { q: "Нужно ли куда-то ехать?", a: "Нет. Мы мобильный сервис и приезжаем к вам домой или в офис со всем оборудованием." },
      { q: "Чистите диваны, матрасы и ковры?", a: "Да. Мы чистим диваны, кресла, матрасы, угловые диваны, ковры и другую мягкую мебель." },
      { q: "Можно почистить только сиденья?", a: "Да. Предлагаем частичную химчистку — например, только передних сидений или багажника." },
      { q: "Удаляете запахи?", a: "Да. Используем профессиональные средства для устранения запахов — дыма, животных, еды." },
      { q: "В каких городах вы работаете?", a: "Euskirchen • Bonn • Brühl • Wesseling • Кёльн • Rheinbach • Weilerswist • Zülpich • Mechernich • Bad Münstereifel • Erftstadt • Hürth • Kerpen и окрестности." },
      { q: "Как записаться?", a: "Заполните форму на сайте или напишите нам в WhatsApp. Мы подтвердим удобное время в течение часа." },
      { q: "Как получить точную цену?", a: "Пришлите несколько фото в WhatsApp — ответим в течение часа. Оценка бесплатна." },
      { q: "Какие способы оплаты?", a: "Наличные, банковский перевод или PayPal. Оплата после выполнения работы." },
    ],
  },
  quote: {
    eyebrow: "Запрос оценки",
    title: "Получить бесплатную оценку",
    desc: "Заполните форму — откроется WhatsApp с вашим сообщением. Ответим в течение 1 часа.",
    name: "Имя",
    phone: "Номер телефона",
    city: "Город",
    cityPlaceholder: "—",
    serviceType: "Вид услуги",
    message: "Сообщение",
    photos: "Фото (по желанию)",
    photosHint: "Добавьте фото — после нажатия откроется WhatsApp, чтобы их прикрепить",
    submit: "Получить оценку",
    successHint: "WhatsApp откроется через мгновение",
    serviceOptions: [
      "Химчистка салона",
      "Мойка кузова",
      "Полный детейлинг",
      "Химчистка дивана",
      "Химчистка матраса",
      "Химчистка ковра",
    ],
    cityOther: "Другой / окрестности",
    uploading: "Загрузка...",
    emailLabel: "E-mail",
    preferredContactLabel: "Предпочтительный способ связи",
    preferredContactPlaceholder: "Выберите способ",
    preferredContactRequired: "Пожалуйста, выберите способ связи",
    preferredContactOptions: ["WhatsApp", "Telegram", "E-mail", "Телефон"],
    gdpr: "Я согласен на обработку моих данных в соответствии с Политикой конфиденциальности.",
    submitError: "Не удалось отправить запрос. Попробуйте ещё раз.",
    successTitle: "Спасибо за заявку!",
    successMessage: "Ваша заявка получена и уже обрабатывается. Мы свяжемся с вами удобным способом в ближайшее время.",
    successPhone: "+49 176 22038169",
    successOpenWhatsApp: "Открыть WhatsApp",
    successClose: "Закрыть",
  },
  booking: {
    flowGetPrice: "Узнать цену",
    flowBook: "Забронировать",
    address: "Адрес",
    itemDetails: "Модель авто или описание дивана",
    preferredDate: "Желаемая дата",
    preferredTime: "Желаемое время",
    pickDate: "Выберите дату",
    pickTime: "Выберите время",
    booked: "Занято",
    blocked: "Недоступно",
    tooSoon: "Бронирование доступно за 8+ дней",
    submit: "Забронировать",
    successTitle: "Спасибо. Ваша заявка на бронирование принята",
    successMessage: "Мы подтвердим слот через WhatsApp в течение 24 часов.",
    noSlot: "В этот день свободных слотов нет",
    previousMonth: "Предыдущий месяц",
    nextMonth: "Следующий месяц",
    legend: {
      available: "Свободно",
      booked: "Занято",
      unavailable: "Недоступно",
    },
  },
  student: {
    loginButton: "Вход для студентов",
    loginTitle: "Вход для студентов",
    loginSubtitle: "Доступ к PUREGLOSS Academy.",
    email: "E-mail",
    password: "Пароль",
    signIn: "Войти",
    signingIn: "Вход...",
    invalidCredentials: "Неверный e-mail или пароль",
    accountPaused: "Аккаунт приостановлен. Свяжитесь с PUREGLOSS Academy.",
    backToAcademy: "Назад в Academy",
    logout: "Выйти",
    dashboard: {
      welcome: "Добро пожаловать",
      package: "Пакет",
      startDate: "Дата старта",
      progress: "Прогресс",
      status: "Статус",
      completedOf: "выполнено из",
      modulesTitle: "Модули курса",
      locked: "Заблокировано",
      unlock: "Открывается через",
      startLesson: "Начать",
      markCompleted: "Отметить как выполнено",
      markIncomplete: "Снять отметку",
      completed: "Выполнено",
      certificateTitle: "Сертификация",
      certificateDesc: "Ваш сертификат будет доступен после сдачи финального экзамена.",
      certificatePending: "Сертификат доступен после завершения курса",
    },
    statusLabels: {
      Active: "Активный",
      Paused: "На паузе",
      Completed: "Завершён",
    },
  },
  academy: {
    nav: "Academy",
    eyebrow: "PUREGLOSS Academy",
    title: "PUREGLOSS Academy",
    subtitle: "Программа обучения мобильному автодетейлингу.\nДля Германии, Польши, Украины и всей Европы.",
    coverage: "Подходит для студентов из Германии, Польши, Украины и других стран Европы.",
    hero: {
      cta: "В лист ожидания",
      secondary: "Подробнее",
    },
    why: {
      eyebrow: "Почему PUREGLOSS Academy",
      title: "Почему PUREGLOSS Academy?",
      desc: "Это не очередной онлайн-курс, а полноценный профессиональный путь в мобильном детейлинге.",
      items: [
        { title: "Реальные знания", desc: "Практические техники и процессы из ежедневной работы PUREGLOSS." },
        { title: "Пошаговые системы", desc: "Структурированные инструкции, чек-листы и шаблоны — не случайные видео." },
        { title: "Сертификация", desc: "Официальный сертификат PUREGLOSS Academy после успешного окончания." },
        { title: "Доступ к сообществу", desc: "Приватное сообщество студентов и выпускников." },
        { title: "Возможное партнёрство", desc: "Лучшие студенты могут получить доступ к PUREGLOSS Network." },
        { title: "Готовые бизнес-процессы", desc: "Шаблоны коммуникации, ценообразования и контроля качества." },
        { title: "Фокус на мобильный сервис", desc: "Программа полностью адаптирована к мобильному детейлингу." },
        { title: "Карьерный путь", desc: "От новичка до собственного мобильного сервиса или партнёра PUREGLOSS." },
      ],
    },
    who: {
      eyebrow: "Для кого",
      title: "Для кого этот курс?",
      items: [
        "Будущие детейлеры",
        "Новички без опыта",
        "Украинцы и международные студенты",
        "Те, кто хочет получить практические навыки",
        "Будущие владельцы мобильного сервиса",
        "Те, кто стремится к самозанятости",
      ],
      note: "Личный автомобиль рекомендуется для мобильной работы, но не обязателен для записи в лист ожидания.",
    },
    packages: {
      eyebrow: "Пакеты обучения",
      title: "Выберите программу",
      desc: "Три уровня — от основ до запуска полноценного мобильного сервиса.",
      comingSoon: "Скоро",
      includes: "Включено",
      certificate: "Сертификат",
      foundation: {
        icon: "🥉",
        name: "Foundation",
        oldPrice: "249€",
        newPrice: "149€",
        tagline: "Для полных новичков.",
        items: [
          "Введение в мобильный детейлинг",
          "Основы химчистки салона",
          "Основы безопасной мойки кузова",
          "Список рекомендованного оборудования",
          "Список рекомендованной химии",
          "Инструкции по использованию химии",
          "Гайд по микрофибре",
          "Гайд по щёткам и аксессуарам",
          "Основы ценообразования",
          "Основы коммуникации с клиентом",
          "Обзор процесса услуги",
          "PDF чек-листы",
          "Проверка знаний",
          "Сертификат PUREGLOSS Foundation",
        ],
        note: "Без практического обучения.",
        certificateName: "Сертификат PUREGLOSS Foundation",
      },
      professional: {
        icon: "🥈",
        name: "Professional",
        oldPrice: "499€",
        newPrice: "349€",
        badge: "популярный",
        tagline: "Всё из Foundation плюс:",
        items: [
          "Продвинутая химчистка салона",
          "Чистка сидений",
          "Чистка ковров",
          "Уход за пластиком",
          "Уход за кожей",
          "Основы химчистки диванов и мебели",
          "Безопасное обращение с химией",
          "Гайд по фото до / после",
          "Предпродажная подготовка авто",
          "Система оценки времени",
          "Система расчёта цен",
          "Как найти первых клиентов",
          "Стратегия флаеров",
          "Стратегия визиток",
          "Стратегия локальных площадок",
          "Гайд по настройке Google Business Profile",
          "Гайд по индексации в Google",
          "Скрипты общения с клиентами",
          "Разбор кейсов",
          "Практические задания",
          "50% скидка на сайт PUREGLOSS",
        ],
        certificateName: "Сертификат PUREGLOSS Professional",
      },
      elite: {
        icon: "👑",
        name: "Elite",
        oldPrice: "999€",
        newPrice: "749€",
        badge: "премиум",
        tagline: "Всё из Professional плюс:",
        items: [
          "Персональный ментор",
          "Реальные примеры процессов",
          "Системы контроля качества",
          "Бизнес-процессы",
          "Управление записями",
          "Расчёт прибыли",
          "Системы работы с постоянными клиентами",
          "Системы удержания клиентов",
          "Подготовка к PUREGLOSS Network",
          "Приоритетная верификация сертификата",
          "Практика с ментором по возможности",
          "БЕСПЛАТНАЯ one-page сайт PUREGLOSS",
          "Персональная помощь с Google Business Profile",
          "Персональная помощь с индексацией в Google",
        ],
        certificateName: "Сертификат PUREGLOSS Elite",
      },
    },
    polishingDisclaimer: "Полировка и уход за ЛКП рассматриваются только как теоретическое введение. Практическая коррекция лака не входит в курс.",
    certification: {
      eyebrow: "Сертификация",
      title: "Сертификация и финальный экзамен",
      desc: "Все студенты сдают финальный экзамен перед получением официального сертификата PUREGLOSS Academy.",
      items: [
        "Теоретический экзамен",
        "Проверка знаний",
        "Понимание процесса",
        "Понимание работы с клиентом",
      ],
      award: "После успешного завершения студент получает:",
      awardName: "Сертификат PUREGLOSS Academy",
    },
    career: {
      eyebrow: "Карьера",
      title: "Возможности после обучения",
      desc: "Лучшие студенты могут получить доступ к:",
      items: [
        "Программа PUREGLOSS Certified Detailer",
        "PUREGLOSS Partner Network",
        "Выделенный профиль детейлера",
        "Рекомендации клиентов в будущем",
        "Возможности сотрудничества",
      ],
      note: "Мы не гарантируем трудоустройство — это возможности после успешного окончания.",
    },
    notIncluded: {
      eyebrow: "Не включено",
      title: "Что не входит",
      items: [
        "Химические продукты",
        "Стартовый набор",
        "Настройка платной рекламы",
        "Практика продвинутой коррекции ЛКП",
        "Публичный профиль детейлера PUREGLOSS",
      ],
    },
    waitlist: {
      eyebrow: "Лист ожидания",
      title: "Записаться в лист ожидания",
      desc: "Оставьте контакт — сообщим о старте занятий и о доступе early-bird.",
      name: "Имя",
      phone: "Телефон",
      email: "E-mail",
      country: "Страна",
      language: "Язык обучения",
      package: "Интересующий пакет",
      message: "Сообщение",
      submit: "Записаться",
      sending: "Отправка...",
      successTitle: "Спасибо!",
      successMessage: "Ваша заявка получена. Мы свяжемся с вами в ближайшее время.",
      error: "Не удалось отправить заявку. Попробуйте ещё раз.",
      gdpr: "Я согласен на обработку моих данных в соответствии с Политикой конфиденциальности.",
    },
    future: {
      title: "Скоро в Academy",
      items: ["Видеоуроки", "Модули курса", "Сертификаты", "Личный кабинет студента", "Покупка курсов"],
    },
    pricing: {
      oldLabel: "Старая цена",
      currentLabel: "Актуальная цена",
      badgePopular: "САМЫЙ ПОПУЛЯРНЫЙ",
      badgePremium: "ПРЕМИУМ ПРОГРАММА",
      save: "Экономия",
    },
    cohort: {
      eyebrow: "🔥 Первый набор",
      title: "Первый набор PUREGLOSS Academy",
      desc: "К первому запуску Academy присоединятся только 20 студентов.",
      note: "После завершения первого набора могут быть открыты новые периоды записи.",
    },
    bonuses: {
      eyebrow: "🎁 Бонусы студентам",
      title: "Бонусы студентам",
      desc: "Всё в комплекте — готовые материалы, которые экономят недели работы.",
      items: [
        "PDF чек-листы PUREGLOSS",
        "Скрипты общения с клиентами",
        "Список рекомендованной химии",
        "Список рекомендованного оборудования",
        "Шаблоны расчёта цен",
        "Шаблоны рабочих процессов",
      ],
    },
    certificatePreview: {
      eyebrow: "🏅 Сертификат",
      title: "Сертификат PUREGLOSS Academy",
      subtitle: "Каждый успешно сдавший финальный экзамен студент получает официальный сертификат PUREGLOSS Academy.",
      alt: "Превью сертификата PUREGLOSS Academy",
    },
    earnings: {
      eyebrow: "💰 Потенциал дохода",
      title: "Потенциал дохода в мобильном детейлинге",
      desc: "Примерные расчёты при стабильном графике:",
      items: [
        { vehicles: "1 автомобиль в день", income: "≈ 1 780€ / месяц" },
        { vehicles: "2 автомобиля в день", income: "≈ 3 560€ / месяц" },
        { vehicles: "3 автомобиля в день", income: "≈ 5 340€ / месяц" },
      ],
      disclaimer:
        "Результаты зависят от страны, цен, спроса, качества услуги и количества клиентов. Мы не гарантируем доход.",
    },
    network: {
      eyebrow: "🚀 PUREGLOSS Network",
      title: "PUREGLOSS Network",
      desc: "Лучшие выпускники могут получить в будущем:",
      items: [
        "Статус PUREGLOSS Certified Detailer",
        "Место в будущей сети PUREGLOSS Network",
        "Рекомендации клиентов в будущем",
        "Возможности сотрудничества с PUREGLOSS",
      ],
      note: "Мы не обещаем трудоустройство — это возможности на будущее.",
    },
  },
  contact: {
    eyebrow: "Контакты",
    title: "Свяжитесь с нами",
  },
  brands: {
    eyebrow: "Премиум оборудование",
    title: "Премиум продукты и оборудование",
    desc: "Для профессионального результата мы используем премиум-продукты и оборудование ведущих брендов.",
    items: [
      { name: "Koch-Chemie", category: "Автохимия" },
      { name: "Kärcher", category: "Профессиональное оборудование" },
    ],
  },
  footer: {
    tagline: "Детейлинг и химчистка мебели",
    area: "Зона обслуживания",
    rights: "Все права защищены.",
    legal: "Правовая информация",
    impressum: "Impressum",
    datenschutz: "Политика конфиденциальности",
    agb: "Условия",
    widerruf: "Право отказа",
    cookies: "Cookies",
    madeIn: "Сделано с ★ в Euskirchen",
    verifiedCustomer: "Проверенный клиент",
  },
  admin: {
    title: "Админ · Заявки",
    password: "Пароль",
    signIn: "Войти",
    invalidPassword: "Неверный пароль",
    back: "На сайт",
    logout: "Выйти",
    refresh: "Обновить",
    tabs: {
      overview: "Обзор",
      auto: "Авто",
      furniture: "Мебель",
      bookings: "Бронирования",
      newsletter: "Рассылка",
      detailers: "Детейлеры",
      clients: "Клиенты",
      academy: "Academy",
      calendar: "Календарь",
    },
    stats: {
      autoNew: "Новые авто",
      furnitureNew: "Новые мебель",
      inProgress: "В работе",
      scheduled: "Запланировано",
      completed: "Выполнено",
      rejected: "Отклонено",
      completedMonth: "Выполнено в этом месяце",
      completedYear: "Выполнено в этом году",
      revenue: "Расчётный доход",
      aov: "Средний чек",
      totalLeads: "Всего заявок",
      activeLeads: "Активные заявки",
      conversion: "Конверсия",
      bookings: "Бронирования",
      leadVolume: "Объём заявок — последние 14 дней",
      revenueVolume: "Расчётный доход — последние 14 дней (€)",
      topCities: "Топ городов",
      topServices: "Топ услуг",
      recentLeads: "Последние заявки",
      leadsCount: "Количество заявок",
      revenueEur: "Доход",
      noData: "Нет данных",
    },
    statusLabels: {
      NEW: "Новая",
      IN_PROGRESS: "В работе",
      SCHEDULED: "Запланирована",
      COMPLETED: "Выполнена",
      REJECTED: "Отклонена",
    },
    academyStatusLabels: {
      NEW: "Новый",
      CONTACTED: "На связи",
      ENROLLED: "Зачислен",
      GRADUATED: "Выпускник",
      REJECTED: "Отклонён",
    },
    card: {
      phone: "Телефон",
      email: "E-mail",
      city: "Город",
      service: "Услуга",
      carModel: "Авто",
      package: "Пакет",
      message: "Сообщение",
      photos: "Фото",
      status: "Статус",
      estimatedPrice: "Расчётная цена",
      detailer: "Детейлер",
      whatsapp: "WhatsApp",
      call: "Позвонить",
      emailAction: "Написать e-mail",
      telegram: "Telegram",
      preferredContact: "Способ связи",
      edit: "Изменить",
      delete: "Удалить",
      duplicate: "Дублировать",
      internalNotes: "Внутренние заметки",
      internalNotesPlaceholder: "Только для админа — например, звонить после 18:00, VIP клиент, взять экстрактор...",
      createdAt: "Создано",
      updatedAt: "Обновлено",
      editLead: "Редактировать заявку",
      saveChanges: "Сохранить изменения",
      cancel: "Отмена",
      deleteLeadTitle: "Удалить заявку?",
      deleteLeadDesc: "Вы уверены, что хотите безвозвратно удалить эту заявку? Это действие нельзя отменить.",
      deleteConfirm: "Удалить",
      leadDeletedToast: "Заявка успешно удалена.",
      leadUpdatedToast: "Заявка обновлена.",
      leadDuplicatedToast: "Заявка продублирована.",
      priceUpdatedToast: "Цена обновлена.",
      notesSavedToast: "Заметки сохранены.",
      actionFailedToast: "Действие не выполнено. Попробуйте ещё раз.",
      clickToEditPrice: "Нажмите, чтобы изменить",
      priceInvalid: "Введите корректное число (€)",
      emailInvalid: "Введите корректный e-mail",
      phoneInvalid: "Введите корректный телефон",
      nameRequired: "Имя обязательно",
      phoneRequired: "Телефон обязателен",
      detailerNone: "— Без детейлера —",
      estimatedPriceHint: "Пример: 89, 149, 399",
      serviceHint: "Свободный текст: напр. Реставрация кожи, Чистка двигателя...",
      history: "История",
      notSet: "не указано",
      viewPhotos: "Смотреть фото",
      unread: "НОВАЯ",
      empty: "Заявок пока нет.",
      leadType: "Тип",
      leadTypeAuto: "Авто",
      leadTypeFurniture: "Мебель",
      leadTypeAcademy: "Academy",
      leadTypeBooking: "Бронирование",
      date: "Дата",
      customer: "Клиент",
      all: "Все",
      sort: "Сортировка",
      assignDetailer: "Назначить детейлера",
      requestReview: "Запросить отзыв",
      address: "Адрес",
      item: "Позиция",
      sendWhatsApp: "Отправить в WhatsApp",
      sendEmail: "Отправить e-mail",
      copyLink: "Копировать ссылку",
      copied: "Скопировано",
      close: "Закрыть",
    },
    sorts: {
      newest: "Сначала новые",
      oldest: "Сначала старые",
      priceDesc: "Дорогие сверху",
      priceAsc: "Дешёвые сверху",
      city: "Город А→Я",
      detailer: "Детейлер",
      bookingDate: "Дата бронирования",
    },
    detailers: {
      title: "Детейлеры",
      id: "ID",
      name: "Имя",
      completedJobs: "Выполнено",
      revenue: "Доход",
      commission: "Комиссия",
      rating: "Рейтинг",
      status: "Статус",
      active: "активный",
      inactive: "неактивный",
    },
    newsletterTable: {
      email: "E-mail",
      lang: "Язык",
      source: "Источник",
      created: "Дата",
      empty: "Подписчиков нет.",
    },
    clients: {
      title: "Клиенты",
      search: "Поиск по имени, телефону или e-mail…",
      levels: "Бронза 1-2 · Серебро 3-4 · Золото 5+ выполненных заказов",
      name: "Имя",
      orders: "Заказы",
      completed: "Выполнено",
      revenue: "Доход",
      level: "Уровень",
    },
    academy: {
      title: "Academy — Лист ожидания",
      empty: "Записей нет.",
      package: "Пакет",
      language: "Язык",
      totalLabel: "Всего в листе ожидания",
      interestedLabel: "Заинтересованные студенты",
      enrolledLabel: "Зачисленные",
      graduatedLabel: "Выпускники",
      byLanguageLabel: "По языку",
    },
    students: {
      tab: "Студенты",
      title: "Студенты Academy",
      empty: "Студентов пока нет.",
      add: "Добавить студента",
      edit: "Изменить",
      delete: "Удалить",
      resetPassword: "Сбросить пароль",
      activate: "Активировать студента",
      copyMessage: "Скопировать сообщение",
      copied: "Скопировано",
      cols: {
        studentId: "ID",
        name: "Имя",
        email: "E-mail",
        package: "Пакет",
        status: "Статус",
        startDate: "Старт",
        progress: "Прогресс",
        actions: "Действия",
      },
      form: {
        name: "Имя",
        email: "E-mail",
        password: "Пароль",
        newPassword: "Новый пароль",
        packageType: "Пакет",
        startDate: "Дата старта",
        status: "Статус",
        save: "Сохранить",
        cancel: "Отмена",
        create: "Создать",
      },
      statusLabels: {
        Active: "Активный",
        Paused: "На паузе",
        Completed: "Завершён",
      },
      accessMessage:
        "Ваш доступ к PUREGLOSS Academy активен.\nВход здесь:\nhttps://puregloss.eu/academy/login\n\nE-mail:\n{email}\n\nПароль:\n{password}",
    },
    calendar: {
      title: "Календарь бронирований",
      legendAvailable: "Свободно",
      legendBooked: "Занято",
      legendUnavailable: "Недоступно",
      blockDay: "Заблокировать день",
      unblock: "Разблокировать",
      blocked: "Заблокировано",
      bookings: "Бронирования",
    },
  },
  legal: {
    impressum: {
      title: "Impressum",
      subtitle: "Сведения согласно § 5 DDG",
      sections: [
        {
          h: "Поставщик услуг (§ 5 DDG)",
          p: "PUREGLOSS\nВладелец: Vladyslav Lysyi\nПравовая форма: индивидуальный предприниматель (Einzelunternehmen)\nRüdesheimer Ring 129\n53879 Euskirchen\nГермания",
        },
        {
          h: "Контакты",
          p: "Телефон: +49 176 22038169\nWhatsApp: +49 176 22038169\nE-mail: info@puregloss.eu\nСайт: https://puregloss.eu",
        },
        {
          h: "Идентификационный номер НДС",
          p: "Идентификационный номер НДС согласно § 27a Закона о НДС Германии:\nDE367513046",
        },
        {
          h: "Ответственный за содержание",
          p: "Ответственный за содержание согласно § 18 (2) MStV:\nVladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Германия",
        },
        {
          h: "Разрешение споров в ЕС",
          p: "Европейская комиссия предоставляет платформу для онлайн-разрешения споров (ODR): https://ec.europa.eu/consumers/odr\nНаш e-mail указан в Impressum выше.",
        },
        {
          h: "Потребительское разрешение споров",
          p: "Мы не готовы и не обязаны участвовать в процедурах разрешения споров перед потребительским арбитражным органом в смысле § 36 Закона о разрешении потребительских споров Германии (VSBG).",
        },
        {
          h: "Ответственность за содержание",
          p: "Как поставщик услуг мы несём ответственность за собственное содержание на этих страницах согласно § 7 (1) DDG и общим законам. Согласно §§ 8–10 DDG мы не обязаны как поставщик услуг контролировать переданную или сохранённую информацию третьих лиц.",
        },
        {
          h: "Ответственность за ссылки",
          p: "Наш ресурс содержит ссылки на внешние сайты третьих лиц, на содержание которых мы не имеем влияния. За эти внешние материалы мы не несём ответственности. За содержание связанных страниц всегда отвечает соответствующий поставщик или оператор.",
        },
        {
          h: "Авторское право",
          p: "Содержимое и произведения на этих страницах, созданные оператором сайта, подлежат немецкому авторскому праву. Копирование, обработка, распространение и любая форма коммерциализации таких материалов вне рамок авторского права требуют письменного согласия соответствующего автора.",
        },
      ],
      back: "На главную",
    },
    datenschutz: {
      title: "Политика конфиденциальности",
      subtitle: "GDPR / BDSG-neu / TTDSG",
      sections: [
        { h: "1. Ответственное лицо", p: "Ответственным за обработку данных согласно GDPR является:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129\n53879 Euskirchen, Германия\nТелефон: +49 176 22038169\nE-mail: info@puregloss.eu" },
        { h: "2. Общая информация", p: "Мы серьёзно относимся к защите ваших персональных данных и обрабатываем их конфиденциально в соответствии с GDPR, BDSG-neu и TTDSG. Персональные данные собираются только в объёме, необходимом для исполнения наших договорных и юридических обязательств или при вашем явном согласии." },
        { h: "3. SSL/TLS шифрование", p: "Этот сайт использует шифрование SSL/TLS в целях безопасности и защиты передачи конфиденциального контента. Зашифрованное соединение можно определить по адресной строке «https://» и значку замка в браузере." },
        { h: "4. Файлы журнала сервера / хостинг", p: "Этот сайт хостится Emergent Labs, Inc. Провайдер автоматически собирает файлы журнала, содержащие IP-адрес (сохраняется в усечённом виде), дату/время запроса, запрошенный URL, referrer, браузер и ОС. Данные используются исключительно для технической доставки, безопасности и анализа ошибок. Правовое основание: ст. 6 (1) (f) GDPR. Срок хранения: макс. 30 дней." },
        { h: "5. Связь (e-mail, телефон, WhatsApp)", p: "При контакте с нами через e-mail, телефон или мессенджер мы сохраняем ваши данные (имя, контакты, сообщение) для обработки вашего запроса и последующих вопросов. Правовое основание: ст. 6 (1) (b) GDPR (договор) или ст. 6 (1) (f) GDPR (законный интерес). Данные удаляются, когда цель более не применима, самое позднее — по истечении установленных законом сроков хранения (§ 257 HGB, § 147 AO — до 10 лет)." },
        { h: "6. Форма запроса / оценки", p: "Через нашу форму вы можете запросить необязывающую оценку. Мы обрабатываем: имя, телефон, e-mail (опционально), город/местоположение, детали автомобиля/объекта, загруженные фото, предпочтительный канал связи и ваше сообщение. Данные используются исключительно для подготовки оценки и согласования времени. Правовое основание: ст. 6 (1) (b) GDPR." },
        { h: "7. Форма бронирования", p: "Для обязывающего бронирования мы дополнительно собираем ваш адрес (место оказания услуги), дату и время. Эти данные необходимы для оказания нашей мобильной услуги детейлинга/химчистки. Правовое основание: ст. 6 (1) (b) GDPR." },
        { h: "8. WhatsApp", p: "Наш сайт содержит кнопки, открывающие прямой чат в WhatsApp (WhatsApp Ireland Limited, часть группы Meta). Только при активном нажатии кнопки WhatsApp устанавливается соединение с серверами WhatsApp/Meta, и ваше сообщение и номер телефона передаются им. Часть обработки данных происходит за пределами ЕС (США). Правовое основание: ст. 6 (1) (a) GDPR (согласие через активный клик) и ст. 6 (1) (b) GDPR. Подробнее: https://www.whatsapp.com/legal/privacy-policy-eea." },
        { h: "9. PUREGLOSS CLUB (бонусная программа)", p: "При вступлении в PUREGLOSS CLUB мы обрабатываем: имя (опционально), e-mail, языковые предпочтения, момент вступления и системно сгенерированный код ваучера. Цель: выдача и управление одноразовым приветственным ваучером 25€, предоставление соответствующего PDF, подтверждение согласия и коммуникация с клиентом по бонусной программе. Правовое основание: ст. 6 (1) (a) и (b) GDPR. Вы можете в любой момент отозвать согласие с эффектом на будущее (info@puregloss.eu)." },
        { h: "10. Рассылка / акции", p: "Для отправки промо-информации мы храним ваш e-mail, момент согласия, а также ваш IP-адрес и user-agent браузера в качестве подтверждения согласия. Подписка происходит только после активного подтверждения чекбокса согласия GDPR. Вы можете отписаться в любой момент, написав на info@puregloss.eu; мы удалим ваши данные немедленно, самое позднее в течение 7 дней. Правовое основание: ст. 6 (1) (a) GDPR." },
        { h: "11. Отправка e-mail (Resend)", p: "Для отправки транзакционных и промо-писем мы используем Resend (Resend, Inc., Сан-Франциско, Калифорния, США). Обрабатываются ваш e-mail, содержание сообщения и метаданные доставки (метки времени, статус bounce). Заключён договор об обработке данных согласно ст. 28 GDPR. Правовое основание: ст. 6 (1) (b) и (f) GDPR. Передача в третью страну (США) обеспечена стандартными договорными положениями ЕС согласно ст. 46 GDPR. Подробнее: https://resend.com/legal/privacy-policy." },
        { h: "12. Cookies и локальное хранилище", p: "Этот сайт использует только строго необходимое локальное хранилище браузера («localStorage») для обеспечения базовой функциональности (языковые настройки, состояние всплывающего окна CLUB, предпочтения согласия). Данные остаются в вашем браузере и никогда не передаются нам. Маркетинговые, отслеживающие, аналитические cookies или cookies третьих сторон НЕ устанавливаются. Правовое основание: § 25 (2) № 2 TTDSG (строго необходимо)." },
        { h: "13. Шрифты", p: "Для визуальной консистентности мы используем шрифт «Cabinet Grotesk», доставляемый Fontshare (Indian Type Foundry Pvt. Ltd., Ахмадабад, Индия). При загрузке сайта устанавливается соединение с серверами Fontshare, при этом может передаваться ваш IP-адрес. Правовое основание: ст. 6 (1) (f) GDPR. Google Fonts больше не используются; остальные шрифты загружаются из системы пользователя, поэтому передачи данных не происходит." },
        { h: "14. Изображения", p: "Этот сайт содержит фото «до/после», изображения портфолио и стоковые фото. Идентификаторы личности (номерные знаки, лица в автомобилях) анонимизируются или удаляются перед публикацией." },
        { h: "15. Загрузка файлов", p: "Фотографии, загруженные через нашу форму запроса, хранятся на нашей инфраструктуре и используются исключительно для подготовки вашей оценки. Правовое основание: ст. 6 (1) (b) GDPR. Удаление происходит не позднее чем через 12 месяцев после закрытия вашего запроса." },
        { h: "16. Получатели / раскрытие третьим лицам", p: "Персональные данные передаются только: нашему поставщику e-mail (Resend), нашему хостинг-провайдеру (Emergent Labs, Inc.) и — если вы им пользуетесь — WhatsApp/Meta. Все поставщики договорно обязаны соблюдать GDPR. Мы НЕ передаём данные другим третьим лицам в рекламных целях." },
        { h: "17. Сроки хранения", p: "Персональные данные хранятся только столько, сколько необходимо для цели или требуется законом (обычно 6 лет по § 257 HGB, 10 лет по § 147 AO для налоговых документов)." },
        { h: "18. Ваши права как субъекта данных", p: "Согласно GDPR у вас есть следующие права:\n• доступ (ст. 15)\n• исправление (ст. 16)\n• удаление (ст. 17)\n• ограничение (ст. 18)\n• переносимость данных (ст. 20)\n• возражение (ст. 21)\n• отзыв согласия с эффектом на будущее (ст. 7 (3))\n\nДля осуществления прав достаточно неформального сообщения на info@puregloss.eu." },
        { h: "19. Право на жалобу в надзорный орган", p: "Вы имеете право подать жалобу в надзорный орган по поводу обработки ваших персональных данных. Компетентный орган для нашего юридического адреса:\n\nLandesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)\nKavalleriestraße 2-4, 40213 Düsseldorf\nТелефон: +49 211 38424-0\nE-mail: poststelle@ldi.nrw.de\nhttps://www.ldi.nrw.de" },
        { h: "20. Обновления", p: "Настоящая политика конфиденциальности действует в текущей редакции. В связи с обновлениями сайта или изменениями законодательства может потребоваться её изменение. Актуальную версию всегда можно посмотреть по адресу https://puregloss.eu/datenschutz." },
        { h: "21. Журнал безопасности при регистрации (PUREGLOSS Club)", p: "При каждой новой регистрации в PUREGLOSS Club мы дополнительно сохраняем техническую информацию для обеспечения безопасности, предотвращения мошенничества, защиты от спама и выявления злоупотреблений. Это включает: ваш IP-адрес, приближённое местоположение (страна, регион, приблизительный город), определённое по этому IP — никогда точное положение, — информацию о браузере и устройстве (User-Agent, операционная система, тип устройства), а также время регистрации. Местоположение всегда является приближённым и не используется для индивидуальной идентификации. Правовая основа: ст. 6(1)(f) GDPR (законный интерес в обеспечении безопасной и свободной от злоупотреблений услуги). Эта информация видна только внутри и не передаётся третьим лицам, за исключением технически необходимого сервиса IP-геолокации." },
      ],
      back: "На главную",
    },
    agb: {
      title: "Общие условия",
      subtitle: "Статус: февраль 2026",
      sections: [
        { h: "§ 1 Область применения", p: "Настоящие Общие условия применяются ко всем договорам между PUREGLOSS – Vladyslav Lysyi («Исполнитель») и потребителями или предпринимателями («Клиент») в отношении услуг, предлагаемых на https://puregloss.eu (мобильный детейлинг, химчистка салона и мойка кузова, химчистка мягкой мебели и диванов)." },
        { h: "§ 2 Заключение договора", p: "Представление услуг на сайте не является юридически обязательным предложением, а приглашением к оферте (invitatio ad offerendum). Клиент направляет необязывающий запрос через форму; Исполнитель затем готовит индивидуальную оценку по e-mail, телефону или WhatsApp. Договор вступает в силу после явного акцепта оферты обеими сторонами или после начала оказания услуги." },
        { h: "§ 3 Объём услуг", p: "Точный объём услуг определяется индивидуальной оценкой. Состояние автомобиля или объекта может повлиять на трудозатраты и итоговую цену; существенные изменения согласовываются с клиентом до начала работ." },
        { h: "§ 4 Цены и оплата", p: "Все цены указаны в евро с учётом НДС. Оплата производится на месте после оказания услуги наличными или — при доступности — картой / мгновенным переводом. В случае просрочки применяются законодательные нормы (§§ 286 и след. BGB)." },
        { h: "§ 5 Записи, отмена, задержки", p: "Записи подтверждаются по e-mail или мессенджеру. Клиент может бесплатно отменить или перенести подтверждённую запись не позднее чем за 24 часа до начала. При более поздней отмене может взиматься плата за отсутствие в размере 50% согласованной цены. Если Исполнитель не может прибыть по важной причине, немедленно предлагается новый срок." },
        { h: "§ 6 Обязанности клиента по содействию", p: "Клиент предоставляет подходящее рабочее место (доступ к автомобилю/объекту, достаточное пространство, доступ к воде при необходимости, электропитание 230 В). Личные вещи должны быть убраны до начала работ." },
        { h: "§ 7 Гарантия и ответственность", p: "Применяются законодательные гарантийные права. Исполнитель несёт неограниченную ответственность за ущерб, причинённый жизни, здоровью или телу, а также за умышленные или грубо неосторожные действия. При простой неосторожности — за исключением нарушения существенных договорных обязанностей — ответственность исключается. В остальных случаях ответственность ограничена типичным, предсказуемым ущербом. Исполнитель не несёт ответственности за уже существующие дефекты (царапины, сколы, засохшие пятна); такие повреждения по запросу документируются до начала работ." },
        { h: "§ 8 Право потребителя на отказ", p: "Потребителям предоставляется законодательное право отказа согласно § 312g в сочетании с § 355 BGB. Подробности изложены в нашем Уведомлении об отказе." },
        { h: "§ 9 Разрешение споров", p: "Комиссия ЕС предоставляет платформу для онлайн-разрешения споров: https://ec.europa.eu/consumers/odr. Мы не готовы и не обязаны участвовать в разрешении споров перед потребительским арбитражным органом." },
        { h: "§ 10 Заключительные положения", p: "Применяется немецкое право, за исключением Венской конвенции о международной купле-продаже. Место исполнения — Euskirchen. В допустимых законом пределах местом подсудности является юридический адрес Исполнителя. Если отдельные положения окажутся недействительными, остальные положения остаются в силе." },
      ],
      back: "На главную",
    },
    widerruf: {
      title: "Уведомление об отказе",
      subtitle: "Ваши права как потребителя",
      sections: [
        { h: "Право отказа", p: "Вы имеете право отказаться от настоящего договора в течение четырнадцати дней без объяснения причин. Срок отказа составляет четырнадцать дней со дня заключения договора.\n\nЧтобы воспользоваться правом отказа, вы должны уведомить нас:\n\nPUREGLOSS – Vladyslav Lysyi\nRüdesheimer Ring 129, 53879 Euskirchen, Германия\nТелефон: +49 176 22038169\nE-mail: info@puregloss.eu\n\nо своём решении отказаться от договора в форме недвусмысленного заявления (например, письмом по почте или e-mail). Вы можете использовать образец ниже, но это необязательно.\n\nДля соблюдения срока отказа достаточно отправить уведомление до истечения срока." },
        { h: "Последствия отказа", p: "При отказе от договора мы возместим все полученные от вас платежи, включая стоимость доставки (за исключением дополнительных расходов, связанных с выбранным вами способом доставки, отличным от наиболее дешёвого стандартного), без необоснованной задержки и в любом случае не позднее 14 дней со дня получения уведомления о вашем отказе. Возврат осуществляется тем же способом оплаты, который вы использовали для первоначальной сделки, если только вы не согласились явно на иное; в любом случае никаких комиссий с вас не удерживается." },
        { h: "Досрочное прекращение права отказа для услуг", p: "Право отказа от договоров об услугах прекращается, если исполнитель полностью оказал услугу и начал её оказание после явного предварительного согласия потребителя и подтверждения понимания, что при полном оказании услуги право отказа теряется (§ 356 (4) BGB)." },
        { h: "Образец формы отказа", p: "(Если вы хотите отказаться от договора, заполните и отправьте эту форму.)\n\nКому: PUREGLOSS – Vladyslav Lysyi, Rüdesheimer Ring 129, 53879 Euskirchen, Германия, E-mail: info@puregloss.eu\n\nНастоящим я/мы (*) уведомляю/уведомляем (*) об отказе от моего/нашего (*) договора купли-продажи следующих товаров (*)/оказания следующей услуги (*):\n\n___________________________________\n\nЗаказано (*)/получено (*):\n___________________________________\n\nИмя потребителя(-ей):\n___________________________________\n\nАдрес потребителя(-ей):\n___________________________________\n\nДата: _______________\n\nПодпись потребителя(-ей) (только при бумажной форме):\n___________________________________\n\n(*) Ненужное зачеркнуть." },
      ],
      back: "На главную",
    },
    cookies: {
      title: "Политика Cookies",
      subtitle: "Cookies и локальное хранилище",
      sections: [
        { h: "1. Принцип", p: "Этот сайт НЕ использует отслеживающие, маркетинговые cookies или cookies третьих сторон. Аналитические инструменты, такие как Google Analytics, Google Tag Manager или Meta Pixel, НЕ используются. Мы применяем исключительно строго необходимое локальное хранилище браузера." },
        { h: "2. Цель локального хранилища", p: "Мы сохраняем в вашем браузере:\n• выбранный язык (напр. DE/EN/UA/PL/RU)\n• присоединились ли вы к PUREGLOSS CLUB (чтобы popup не появлялся снова)\n• предпочтения интерфейса (напр. последний активный поток формы)\n\nЭти данные никогда не покидают ваш браузер и НЕ передаются на наши серверы или третьим лицам." },
        { h: "3. Правовое основание", p: "Описанное выше хранение строго необходимо для надлежащего функционирования сайта (§ 25 (2) № 2 TTDSG) и не требует отдельного согласия." },
        { h: "4. Удаление / возражение", p: "Локальное хранилище можно удалить в любой момент через настройки браузера (напр. Chrome → Настройки → Конфиденциальность и безопасность → Очистить данные просмотров → «Файлы cookie и другие данные сайтов»). После удаления сайт вернётся в состояние по умолчанию." },
        { h: "5. Внешние сервисы", p: "Если вы активно нажимаете кнопку WhatsApp, вы покидаете наш сайт и попадаете в среду, где WhatsApp/Meta может устанавливать собственные cookies. Это вне нашего контроля. См. нашу политику конфиденциальности, раздел WhatsApp." },
      ],
      back: "На главную",
    },
  },
};


// ---------------------------------------------------------------------------
// PUREGARAGE — native translations for the /app landing page.
// All 5 languages ship with equal, complete copy. No cross-language fallback.
// ---------------------------------------------------------------------------
const PUREGARAGE_I18N = {
  en: {
    nav: "PUREGARAGE",
    badge: "Coming Soon",
    seo: {
      title: "PUREGARAGE — Your car's digital life | PUREGLOSS",
      description: "PUREGARAGE is a digital garage, verified vehicle-care history, mobile detailer marketplace, rewards platform and future automotive service ecosystem — built by PUREGLOSS.",
      ogAlt: "PUREGARAGE — a premium automotive technology product by PUREGLOSS",
    },
    hero: {
      eyebrow: "PUREGLOSS PRESENTS",
      title: "Your car deserves a digital life.",
      subtitle: "Welcome to PUREGARAGE.",
      desc: "A digital garage, verified vehicle-care history, trusted mobile detailers and rewards — all in one premium automotive ecosystem.",
      primary: "Explore PUREGARAGE",
      secondary: "Join the Waitlist",
      scrollHint: "Scroll to explore",
    },
    intro: {
      eyebrow: "More than an app",
      title: "More than an app.\nYour vehicle's digital life.",
      desc: "PUREGARAGE brings together everything a modern vehicle owner needs — from a digital garage and verified service records to on-demand mobile detailers, smart reminders, rewards and an AI care assistant.",
      screens: [
        { title: "Digital Garage", desc: "Every vehicle. Every detail. One profile." },
        { title: "Book a Detailer", desc: "Trusted professionals near you." },
        { title: "Verified History", desc: "Every service, permanently recorded." },
        { title: "Rewards", desc: "Every service moves you forward." },
      ],
    },
    garage: {
      eyebrow: "Digital Garage",
      title: "Your vehicle.\nYour history.\nAlways with you.",
      desc: "A complete profile for every car you own — with photos, mileage, current care condition and the next recommended service.",
      vehicleName: "Audi A6",
      spec: { year: "Year", color: "Color", mileage: "Mileage", condition: "Care condition" },
      colorValue: "Mythos Black",
      conditionValue: "Excellent",
      nextService: "Next recommended service",
      nextServiceValue: "Interior deep clean · in 42 days",
      categories: ["Interior", "Leather", "Exterior", "Wheels", "Protection", "Service history"],
    },
    history: {
      eyebrow: "Verified history",
      title: "Every service becomes part of your vehicle's story.",
      desc: "A permanent, tamper-proof timeline of every treatment your car has received.",
      verifiedBadge: "PUREGARAGE Verified History",
      qrTitle: "Share a verified vehicle-care history",
      qrDesc: "A future feature: buyers can scan a QR code to view the full, verified care history of your car.",
      futureBadge: "Future feature",
      items: [
        { date: "March 14, 2026", km: "48 210 km", title: "Complete interior detailing", provider: "PUREGLOSS · Verified", note: "Full seats, carpets, plastics and headliner refresh." },
        { date: "March 14, 2026", km: "48 210 km", title: "Leather protection", provider: "PUREGLOSS · Verified", note: "Conditioner and UV-protection applied to all leather surfaces." },
        { date: "February 02, 2026", km: "46 980 km", title: "Seat deep cleaning", provider: "PUREGLOSS · Verified", note: "Water-extraction on all seats with odour neutralisation." },
        { date: "November 18, 2025", km: "44 105 km", title: "Exterior detailing", provider: "PUREGLOSS · Verified", note: "Hand wash, decontamination, sealant and tyre care." },
        { date: "November 18, 2025", km: "44 105 km", title: "Paint protection", provider: "PUREGLOSS · Verified", note: "Long-life polymer sealant." },
        { date: "Recommended", km: "≈ 51 000 km", title: "Next recommended care", provider: "PUREGARAGE Assistant", note: "Interior refresh · leather reconditioning." },
      ],
    },
    detailers: {
      eyebrow: "Detailers near you",
      title: "Professional care.\nWherever your car is.",
      desc: "See verified mobile detailers online near you. Preview their portfolio, ratings and response time — then request their service.",
      radiusLabel: "Within a 30 km radius",
      onlineNow: "Online now",
      etaLabel: "ETA",
      bookCta: "Book Detailer",
      verified: "Verified",
      completedJobs: "completed jobs",
      responseTime: "Response time",
      experience: "Experience",
      certificationLevel: "Certification level",
      note: "This is a product presentation. Real detailer location and booking will be enabled in the live app.",
      samples: [
        { name: "Andrii M.", area: "Köln", rating: 4.9, jobs: 214, eta: "22 min", level: "Elite Detailer" },
        { name: "Lukas B.", area: "Bonn", rating: 4.8, jobs: 128, eta: "35 min", level: "Verified Detailer" },
        { name: "Sofia K.", area: "Euskirchen", rating: 5.0, jobs: 76, eta: "18 min", level: "Academy Certified" },
      ],
    },
    verified: {
      eyebrow: "Verified detailers",
      title: "Trusted professionals.\nNot open registration.",
      desc: "PUREGARAGE is not a self-serve platform. Every detailer is manually reviewed before they can accept jobs.",
      steps: [
        { title: "Submit application", desc: "Basic profile and business information." },
        { title: "Professional experience", desc: "Years of practice, specialisations, references." },
        { title: "Portfolio & equipment", desc: "Real photos of previous work and tools." },
        { title: "Certificates", desc: "Optional, but weighted during review." },
        { title: "Manual PUREGARAGE review", desc: "Our team reviews every application in person." },
        { title: "Approval or interview", desc: "Approved, or invited for a short interview." },
      ],
      levels: [
        { name: "Applicant", desc: "Application received." },
        { name: "Verified Detailer", desc: "Approved after manual review." },
        { name: "PUREGLOSS Academy Certified", desc: "Trained and certified by our own Academy." },
        { name: "Elite Detailer", desc: "Top-rated, priority visibility and priority jobs." },
      ],
      academyNote: "PUREGLOSS Academy graduates may receive priority verification. External professionals are welcome to apply and will be reviewed manually.",
    },
    rewards: {
      eyebrow: "Rewards & levels",
      title: "Every service moves you forward.",
      desc: "The more you care for your vehicle, the more PUREGARAGE gives back.",
      progressLabel: "Level progress",
      currentLabel: "Current level",
      nextLabel: "Next level",
      levels: ["Bronze", "Silver", "Gold", "Black", "Diamond"],
      exampleTitle: "Example rewards",
      examples: [
        "€10 voucher",
        "€20 voucher",
        "Percentage discount",
        "Free leather protection",
        "Complimentary add-on service",
        "Priority booking",
        "Exclusive PUREGARAGE offers",
      ],
      exampleBadge: "Example — not a binding offer",
      disclaimer: "Reward examples shown here are illustrative. Final reward rules will be published inside the PUREGARAGE app.",
    },
    achievements: {
      eyebrow: "Achievements",
      title: "Your vehicle-care journey deserves recognition.",
      desc: "Unlock private badges as your history grows. Your activity stays private by default — there is no public customer leaderboard.",
      items: [
        "First Detail",
        "Interior Reset",
        "Leather Lover",
        "Five Services",
        "Ten Services",
        "Winter Ready",
        "Protection Expert",
        "Loyal Client",
        "PUREGARAGE Gold Member",
      ],
    },
    reminders: {
      eyebrow: "Smart reminders",
      title: "Know when your vehicle needs attention.",
      desc: "PUREGARAGE watches your history and gently reminds you when it's time. No spam — just useful, timely nudges.",
      items: [
        "One month since your last interior cleaning",
        "Leather protection renewal recommended",
        "Winter preparation available",
        "Next detailing recommendation",
        "Time to inspect the interior condition",
      ],
      basedOn: "Based on",
      basedOnItems: ["previous services", "time since last visit", "vehicle usage", "season", "your vehicle profile"],
    },
    ai: {
      eyebrow: "AI vehicle care",
      title: "Smarter care for your vehicle.",
      desc: "A friendly assistant that understands your car's history and helps you plan the right care at the right time.",
      capabilities: [
        "Explain visible interior wear",
        "Recommend suitable services",
        "Answer vehicle-care questions",
        "Suggest the next service",
        "Explain service history",
        "Help prepare a vehicle for sale",
      ],
      disclaimer: "AI recommendations are informational only and do not replace inspection by a qualified professional.",
    },
    twoExperiences: {
      eyebrow: "One app, two experiences",
      title: "One application.\nTwo professional experiences.",
      desc: "The same PUREGARAGE app adapts to your role — client or approved detailer.",
      clientTitle: "For clients",
      clientItems: [
        "Digital Garage",
        "Book a verified detailer",
        "Service history",
        "Before & after photos",
        "Reminders",
        "Rewards",
        "Achievements",
        "AI assistant",
        "Reviews",
        "Secure profile",
      ],
      detailerTitle: "For detailers",
      detailerItems: [
        "Approved professional account",
        "Nearby service requests",
        "Calendar",
        "Booking management",
        "Customer CRM",
        "Portfolio",
        "Earnings overview",
        "Ratings & reviews",
        "Online / offline status",
        "Navigation to client location",
        "Professional growth levels",
      ],
    },
    partners: {
      eyebrow: "Future automotive partners",
      title: "Built for the future of vehicle ownership.",
      tagline: "More vehicle history.\nMore trusted partners.\nOne digital garage.",
      locked: "Locked",
      comingIn: "Coming in a future PUREGARAGE release.",
      modules: [
        "Tyre Services",
        "Workshops",
        "Oil Services",
        "Vehicle Inspection",
        "Paint Protection Film",
        "Vehicle Wrapping",
        "Car Dealerships",
        "Insurance",
        "Charging Services",
      ],
      disclaimer: "These integrations are planned. They do not exist yet inside PUREGARAGE.",
    },
    contests: {
      eyebrow: "Contests & campaigns",
      title: "Exclusive campaigns for the PUREGARAGE community.",
      futureBadge: "Future campaign concept",
      items: [
        "Book a qualifying service and automatically enter a monthly prize campaign",
        "Seasonal vehicle-care campaigns",
        "Member-only rewards",
        "Limited PUREGLOSS promotions",
      ],
      disclaimer: "Official rules, eligibility and duration will always be displayed inside the app before any participation.",
    },
    roadmap: {
      eyebrow: "Roadmap",
      title: "Where PUREGARAGE is going.",
      labels: {
        concept: "Concept",
        inDev: "In development",
        planned: "Planned",
        future: "Future",
      },
      phases: [
        { name: "Phase 1", title: "Digital Garage and detailing history", label: "inDev" },
        { name: "Phase 2", title: "Verified mobile detailers and booking", label: "planned" },
        { name: "Phase 3", title: "Rewards, achievements and AI assistance", label: "planned" },
        { name: "Phase 4", title: "Automotive service partners", label: "future" },
        { name: "Phase 5", title: "Verified vehicle history ecosystem", label: "future" },
      ],
    },
    waitlist: {
      eyebrow: "Waitlist",
      title: "Be among the first to enter PUREGARAGE.",
      desc: "Leave your details and we'll invite you when your role opens up.",
      firstName: "First name",
      email: "Email",
      country: "Country",
      city: "City",
      interest: "I am interested as",
      interestClient: "Client",
      interestDetailer: "Detailer",
      interestPartner: "Automotive partner",
      vehicleBrand: "Vehicle brand (optional)",
      vehicleBrandPlaceholder: "e.g. Audi, BMW, Tesla",
      consent: "I consent to the processing of my data according to the",
      consentLink: "Privacy Policy",
      submit: "Join the waitlist",
      submitting: "Sending...",
      successTitle: "You're on the list.",
      successMessage: "We'll be in touch as soon as PUREGARAGE opens for your role.",
      duplicateMessage: "This email is already on the PUREGARAGE waitlist.",
      errorMessage: "Could not join the waitlist. Please try again.",
      firstNameRequired: "Please enter your first name",
      emailRequired: "Please enter a valid email",
      consentRequired: "Please accept the Privacy Policy",
    },
    footer: {
      productOf: "A PUREGLOSS product.",
      backToSite: "Back to PUREGLOSS",
    },
  },
  de: {
    nav: "PUREGARAGE",
    badge: "Bald verfügbar",
    seo: {
      title: "PUREGARAGE — Das digitale Leben Ihres Autos | PUREGLOSS",
      description: "PUREGARAGE ist eine digitale Garage, verifizierte Fahrzeug-Pflegehistorie, Marktplatz für mobile Detailer, Prämienplattform und zukünftiges Automotive-Service-Ökosystem — von PUREGLOSS.",
      ogAlt: "PUREGARAGE — ein Premium-Automotive-Produkt von PUREGLOSS",
    },
    hero: {
      eyebrow: "PUREGLOSS PRÄSENTIERT",
      title: "Ihr Auto verdient ein digitales Leben.",
      subtitle: "Willkommen bei PUREGARAGE.",
      desc: "Eine digitale Garage, verifizierte Pflegehistorie, geprüfte mobile Detailer und Prämien — vereint in einem Premium-Automotive-Ökosystem.",
      primary: "PUREGARAGE entdecken",
      secondary: "Auf die Warteliste",
      scrollHint: "Zum Erkunden scrollen",
    },
    intro: {
      eyebrow: "Mehr als eine App",
      title: "Mehr als eine App.\nDas digitale Leben Ihres Fahrzeugs.",
      desc: "PUREGARAGE vereint alles, was moderne Fahrzeugbesitzer brauchen — von einer digitalen Garage und verifizierten Servicedaten über mobile Detailer auf Abruf bis hin zu Erinnerungen, Prämien und einem KI-Pflegeassistenten.",
      screens: [
        { title: "Digitale Garage", desc: "Jedes Fahrzeug. Jedes Detail. Ein Profil." },
        { title: "Detailer buchen", desc: "Geprüfte Profis in Ihrer Nähe." },
        { title: "Verifizierte Historie", desc: "Jeder Service dauerhaft dokumentiert." },
        { title: "Prämien", desc: "Jeder Service bringt Sie weiter." },
      ],
    },
    garage: {
      eyebrow: "Digitale Garage",
      title: "Ihr Fahrzeug.\nIhre Historie.\nImmer dabei.",
      desc: "Ein vollständiges Profil für jedes Ihrer Fahrzeuge — mit Fotos, Kilometerstand, aktuellem Pflegezustand und dem nächsten empfohlenen Service.",
      vehicleName: "Audi A6",
      spec: { year: "Baujahr", color: "Farbe", mileage: "Kilometer", condition: "Pflegezustand" },
      colorValue: "Mythosschwarz",
      conditionValue: "Ausgezeichnet",
      nextService: "Nächster empfohlener Service",
      nextServiceValue: "Intensive Innenraumpflege · in 42 Tagen",
      categories: ["Innenraum", "Leder", "Außen", "Felgen", "Schutz", "Servicehistorie"],
    },
    history: {
      eyebrow: "Verifizierte Historie",
      title: "Jeder Service wird Teil der Geschichte Ihres Fahrzeugs.",
      desc: "Eine dauerhafte, manipulationssichere Zeitleiste jeder Pflege, die Ihr Auto erhalten hat.",
      verifiedBadge: "PUREGARAGE Verifizierte Historie",
      qrTitle: "Verifizierte Pflegehistorie teilen",
      qrDesc: "Zukunftsfunktion: Käufer scannen einen QR-Code und sehen die vollständige, verifizierte Pflegehistorie Ihres Autos.",
      futureBadge: "Zukünftige Funktion",
      items: [
        { date: "14. März 2026", km: "48 210 km", title: "Komplette Innenraumaufbereitung", provider: "PUREGLOSS · Verifiziert", note: "Sitze, Teppiche, Kunststoffe und Dachhimmel aufgefrischt." },
        { date: "14. März 2026", km: "48 210 km", title: "Lederschutz", provider: "PUREGLOSS · Verifiziert", note: "Pflege und UV-Schutz auf allen Lederflächen." },
        { date: "02. Februar 2026", km: "46 980 km", title: "Intensive Sitzreinigung", provider: "PUREGLOSS · Verifiziert", note: "Nassextraktion aller Sitze inkl. Geruchsneutralisation." },
        { date: "18. November 2025", km: "44 105 km", title: "Außenaufbereitung", provider: "PUREGLOSS · Verifiziert", note: "Handwäsche, Dekontamination, Versiegelung und Reifenpflege." },
        { date: "18. November 2025", km: "44 105 km", title: "Lackschutz", provider: "PUREGLOSS · Verifiziert", note: "Langzeit-Polymerversiegelung." },
        { date: "Empfohlen", km: "≈ 51 000 km", title: "Nächste empfohlene Pflege", provider: "PUREGARAGE Assistent", note: "Innenraumauffrischung · Lederpflege." },
      ],
    },
    detailers: {
      eyebrow: "Detailer in Ihrer Nähe",
      title: "Professionelle Pflege.\nWo auch immer Ihr Auto steht.",
      desc: "Sehen Sie verifizierte mobile Detailer online in Ihrer Nähe. Portfolio, Bewertungen und Reaktionszeit prüfen — und den Einsatz anfragen.",
      radiusLabel: "Im Umkreis von 30 km",
      onlineNow: "Jetzt online",
      etaLabel: "Ankunft",
      bookCta: "Detailer buchen",
      verified: "Verifiziert",
      completedJobs: "abgeschlossene Aufträge",
      responseTime: "Antwortzeit",
      experience: "Erfahrung",
      certificationLevel: "Zertifizierungsstufe",
      note: "Diese Darstellung ist illustrativ. Reale Ortung und Buchung erfolgen in der Live-App.",
      samples: [
        { name: "Andrii M.", area: "Köln", rating: 4.9, jobs: 214, eta: "22 Min.", level: "Elite Detailer" },
        { name: "Lukas B.", area: "Bonn", rating: 4.8, jobs: 128, eta: "35 Min.", level: "Verifizierter Detailer" },
        { name: "Sofia K.", area: "Euskirchen", rating: 5.0, jobs: 76, eta: "18 Min.", level: "Academy Zertifiziert" },
      ],
    },
    verified: {
      eyebrow: "Verifizierte Detailer",
      title: "Vertrauenswürdige Profis.\nKeine offene Registrierung.",
      desc: "PUREGARAGE ist keine Selbstbedienungsplattform. Jeder Detailer wird manuell geprüft, bevor Aufträge angenommen werden können.",
      steps: [
        { title: "Bewerbung einreichen", desc: "Basisprofil und Geschäftsangaben." },
        { title: "Berufserfahrung", desc: "Jahre der Praxis, Schwerpunkte, Referenzen." },
        { title: "Portfolio & Ausrüstung", desc: "Echte Fotos bisheriger Arbeiten und Werkzeuge." },
        { title: "Zertifikate", desc: "Optional, werden bei der Prüfung berücksichtigt." },
        { title: "Manuelle PUREGARAGE-Prüfung", desc: "Unser Team prüft jede Bewerbung persönlich." },
        { title: "Freigabe oder Interview", desc: "Freigabe oder Einladung zu einem kurzen Gespräch." },
      ],
      levels: [
        { name: "Bewerber", desc: "Bewerbung eingegangen." },
        { name: "Verifizierter Detailer", desc: "Freigegeben nach manueller Prüfung." },
        { name: "PUREGLOSS Academy Zertifiziert", desc: "Ausgebildet und zertifiziert durch unsere Academy." },
        { name: "Elite Detailer", desc: "Top bewertet, mit priorisierter Sichtbarkeit und Aufträgen." },
      ],
      academyNote: "Absolventen der PUREGLOSS Academy können eine bevorzugte Verifizierung erhalten. Externe Profis sind ebenfalls willkommen und werden manuell geprüft.",
    },
    rewards: {
      eyebrow: "Prämien & Stufen",
      title: "Jeder Service bringt Sie weiter.",
      desc: "Je mehr Sie sich um Ihr Fahrzeug kümmern, desto mehr gibt PUREGARAGE zurück.",
      progressLabel: "Fortschritt",
      currentLabel: "Aktuelle Stufe",
      nextLabel: "Nächste Stufe",
      levels: ["Bronze", "Silber", "Gold", "Black", "Diamond"],
      exampleTitle: "Beispielhafte Prämien",
      examples: [
        "10€ Gutschein",
        "20€ Gutschein",
        "Prozentualer Rabatt",
        "Kostenloser Lederschutz",
        "Kostenlose Zusatzleistung",
        "Bevorzugte Terminbuchung",
        "Exklusive PUREGARAGE-Angebote",
      ],
      exampleBadge: "Beispiel — kein bindendes Angebot",
      disclaimer: "Die hier gezeigten Prämien sind illustrativ. Die finalen Regeln werden in der PUREGARAGE-App veröffentlicht.",
    },
    achievements: {
      eyebrow: "Erfolge",
      title: "Ihr Pflegeweg verdient Anerkennung.",
      desc: "Sammeln Sie private Abzeichen, wenn Ihre Historie wächst. Ihre Aktivität bleibt standardmäßig privat — es gibt keine öffentliche Kundenrangliste.",
      items: [
        "Erstes Detailing",
        "Innenraum-Reset",
        "Leder-Kenner",
        "Fünf Services",
        "Zehn Services",
        "Winterbereit",
        "Schutz-Experte",
        "Treuer Kunde",
        "PUREGARAGE Gold Mitglied",
      ],
    },
    reminders: {
      eyebrow: "Intelligente Erinnerungen",
      title: "Wissen, wann Ihr Fahrzeug Pflege braucht.",
      desc: "PUREGARAGE beobachtet Ihre Historie und meldet sich rechtzeitig. Kein Spam — nur sinnvolle Hinweise.",
      items: [
        "Ein Monat seit der letzten Innenraumreinigung",
        "Auffrischung des Lederschutzes empfohlen",
        "Wintervorbereitung verfügbar",
        "Nächste Detailing-Empfehlung",
        "Zeit für eine Innenraum-Sichtprüfung",
      ],
      basedOn: "Basierend auf",
      basedOnItems: ["vorherigen Services", "Zeit seit dem letzten Besuch", "Fahrzeugnutzung", "Saison", "Ihrem Fahrzeugprofil"],
    },
    ai: {
      eyebrow: "KI Fahrzeugpflege",
      title: "Intelligentere Pflege für Ihr Fahrzeug.",
      desc: "Ein freundlicher Assistent, der die Geschichte Ihres Autos kennt und die richtige Pflege zum richtigen Zeitpunkt plant.",
      capabilities: [
        "Sichtbaren Innenraum-Verschleiß erklären",
        "Passende Services empfehlen",
        "Fragen zur Fahrzeugpflege beantworten",
        "Nächsten Service vorschlagen",
        "Servicehistorie erklären",
        "Fahrzeug für den Verkauf vorbereiten",
      ],
      disclaimer: "KI-Empfehlungen dienen nur zur Information und ersetzen keine Prüfung durch einen qualifizierten Fachbetrieb.",
    },
    twoExperiences: {
      eyebrow: "Eine App, zwei Erlebnisse",
      title: "Eine Anwendung.\nZwei professionelle Erlebnisse.",
      desc: "Dieselbe PUREGARAGE-App passt sich Ihrer Rolle an — Kunde oder freigegebener Detailer.",
      clientTitle: "Für Kunden",
      clientItems: [
        "Digitale Garage",
        "Verifizierten Detailer buchen",
        "Servicehistorie",
        "Vorher/Nachher-Fotos",
        "Erinnerungen",
        "Prämien",
        "Erfolge",
        "KI-Assistent",
        "Bewertungen",
        "Sicheres Profil",
      ],
      detailerTitle: "Für Detailer",
      detailerItems: [
        "Freigegebenes Profikonto",
        "Anfragen in der Nähe",
        "Kalender",
        "Auftragsverwaltung",
        "Kunden-CRM",
        "Portfolio",
        "Einnahmenübersicht",
        "Bewertungen & Rezensionen",
        "Online-/Offline-Status",
        "Navigation zum Kunden",
        "Professionelle Aufstiegsstufen",
      ],
    },
    partners: {
      eyebrow: "Zukünftige Partner",
      title: "Gebaut für die Zukunft des Fahrzeugbesitzes.",
      tagline: "Mehr Fahrzeughistorie.\nMehr vertrauenswürdige Partner.\nEine digitale Garage.",
      locked: "Gesperrt",
      comingIn: "Kommt in einer zukünftigen PUREGARAGE-Version.",
      modules: [
        "Reifenservice",
        "Werkstätten",
        "Ölservice",
        "Fahrzeuginspektion",
        "Lackschutzfolie",
        "Fahrzeugfolierung",
        "Autohäuser",
        "Versicherung",
        "Ladeservice",
      ],
      disclaimer: "Diese Integrationen sind geplant. Sie existieren noch nicht in PUREGARAGE.",
    },
    contests: {
      eyebrow: "Aktionen & Kampagnen",
      title: "Exklusive Kampagnen für die PUREGARAGE-Community.",
      futureBadge: "Zukünftiges Kampagnenkonzept",
      items: [
        "Qualifizierten Service buchen und automatisch an einer monatlichen Aktion teilnehmen",
        "Saisonale Fahrzeugpflege-Kampagnen",
        "Vorteile nur für Mitglieder",
        "Limitierte PUREGLOSS-Promotionen",
      ],
      disclaimer: "Offizielle Regeln, Teilnahmebedingungen und Dauer werden vor jeder Teilnahme in der App angezeigt.",
    },
    roadmap: {
      eyebrow: "Roadmap",
      title: "Wohin sich PUREGARAGE entwickelt.",
      labels: {
        concept: "Konzept",
        inDev: "In Entwicklung",
        planned: "Geplant",
        future: "Zukunft",
      },
      phases: [
        { name: "Phase 1", title: "Digitale Garage und Detailing-Historie", label: "inDev" },
        { name: "Phase 2", title: "Verifizierte mobile Detailer und Buchung", label: "planned" },
        { name: "Phase 3", title: "Prämien, Erfolge und KI-Unterstützung", label: "planned" },
        { name: "Phase 4", title: "Automotive-Service-Partner", label: "future" },
        { name: "Phase 5", title: "Verifiziertes Fahrzeughistorie-Ökosystem", label: "future" },
      ],
    },
    waitlist: {
      eyebrow: "Warteliste",
      title: "Seien Sie unter den Ersten in PUREGARAGE.",
      desc: "Hinterlassen Sie Ihre Daten — wir laden Sie ein, sobald Ihre Rolle geöffnet wird.",
      firstName: "Vorname",
      email: "E-Mail",
      country: "Land",
      city: "Stadt",
      interest: "Ich interessiere mich als",
      interestClient: "Kunde",
      interestDetailer: "Detailer",
      interestPartner: "Automotive-Partner",
      vehicleBrand: "Fahrzeugmarke (optional)",
      vehicleBrandPlaceholder: "z. B. Audi, BMW, Tesla",
      consent: "Ich willige in die Verarbeitung meiner Daten gemäß der",
      consentLink: "Datenschutzerklärung",
      submit: "Auf die Warteliste",
      submitting: "Sende...",
      successTitle: "Sie sind dabei.",
      successMessage: "Wir melden uns, sobald PUREGARAGE für Ihre Rolle öffnet.",
      duplicateMessage: "Diese E-Mail steht bereits auf der PUREGARAGE-Warteliste.",
      errorMessage: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
      firstNameRequired: "Bitte Vornamen angeben",
      emailRequired: "Bitte gültige E-Mail angeben",
      consentRequired: "Bitte Datenschutzerklärung akzeptieren",
    },
    footer: {
      productOf: "Ein PUREGLOSS-Produkt.",
      backToSite: "Zurück zu PUREGLOSS",
    },
  },
  ua: {
    nav: "PUREGARAGE",
    badge: "Скоро",
    seo: {
      title: "PUREGARAGE — цифрове життя вашого авто | PUREGLOSS",
      description: "PUREGARAGE — це цифровий гараж, підтверджена історія догляду за авто, маркетплейс мобільних детейлерів, платформа лояльності та майбутня автомобільна екосистема від PUREGLOSS.",
      ogAlt: "PUREGARAGE — преміальний автомобільний технологічний продукт від PUREGLOSS",
    },
    hero: {
      eyebrow: "ВІД PUREGLOSS",
      title: "Ваше авто заслуговує на цифрове життя.",
      subtitle: "Ласкаво просимо до PUREGARAGE.",
      desc: "Цифровий гараж, підтверджена історія догляду, перевірені мобільні детейлери та винагороди — усе в одній преміальній автомобільній екосистемі.",
      primary: "Дослідити PUREGARAGE",
      secondary: "Приєднатися до листа очікування",
      scrollHint: "Прокрутіть, щоб дослідити",
    },
    intro: {
      eyebrow: "Більше, ніж застосунок",
      title: "Більше, ніж застосунок.\nЦифрове життя вашого авто.",
      desc: "PUREGARAGE поєднує все, що потрібно сучасному власнику авто — від цифрового гаража та підтвердженої історії обслуговування до мобільних детейлерів на замовлення, розумних нагадувань, винагород та AI-помічника з догляду.",
      screens: [
        { title: "Цифровий гараж", desc: "Кожне авто. Кожна деталь. Один профіль." },
        { title: "Замовити детейлера", desc: "Перевірені майстри поруч." },
        { title: "Підтверджена історія", desc: "Кожен сервіс — назавжди зафіксований." },
        { title: "Винагороди", desc: "Кожен сервіс наближає до нового рівня." },
      ],
    },
    garage: {
      eyebrow: "Цифровий гараж",
      title: "Ваше авто.\nВаша історія.\nЗавжди з вами.",
      desc: "Повний профіль для кожного авто — з фото, пробігом, поточним станом догляду та наступною рекомендованою послугою.",
      vehicleName: "Audi A6",
      spec: { year: "Рік", color: "Колір", mileage: "Пробіг", condition: "Стан догляду" },
      colorValue: "Mythos Black",
      conditionValue: "Відмінний",
      nextService: "Наступний рекомендований сервіс",
      nextServiceValue: "Глибока чистка салону · через 42 дні",
      categories: ["Салон", "Шкіра", "Кузов", "Диски", "Захист", "Історія сервісу"],
    },
    history: {
      eyebrow: "Підтверджена історія",
      title: "Кожен сервіс стає частиною історії вашого авто.",
      desc: "Постійна, захищена від змін хронологія кожної процедури, яку отримало ваше авто.",
      verifiedBadge: "PUREGARAGE Підтверджена історія",
      qrTitle: "Поділіться підтвердженою історією догляду",
      qrDesc: "Майбутня функція: покупці можуть відсканувати QR-код і побачити повну підтверджену історію догляду за вашим авто.",
      futureBadge: "Майбутня функція",
      items: [
        { date: "14 березня 2026", km: "48 210 км", title: "Повний детейлінг салону", provider: "PUREGLOSS · Підтверджено", note: "Сидіння, килими, пластик та стеля — повне оновлення." },
        { date: "14 березня 2026", km: "48 210 км", title: "Захист шкіри", provider: "PUREGLOSS · Підтверджено", note: "Кондиціонер та UV-захист для всіх шкіряних поверхонь." },
        { date: "02 лютого 2026", km: "46 980 км", title: "Глибока чистка сидінь", provider: "PUREGLOSS · Підтверджено", note: "Екстракція всіх сидінь із нейтралізацією запахів." },
        { date: "18 листопада 2025", km: "44 105 км", title: "Детейлінг кузова", provider: "PUREGLOSS · Підтверджено", note: "Ручна мийка, деконтамінація, силант та догляд за шинами." },
        { date: "18 листопада 2025", km: "44 105 км", title: "Захист ЛФП", provider: "PUREGLOSS · Підтверджено", note: "Довготривалий полімерний силант." },
        { date: "Рекомендовано", km: "≈ 51 000 км", title: "Наступний рекомендований догляд", provider: "PUREGARAGE Assistant", note: "Оновлення салону · відновлення шкіри." },
      ],
    },
    detailers: {
      eyebrow: "Детейлери поруч",
      title: "Професійний догляд.\nДе б не було ваше авто.",
      desc: "Побачте перевірених мобільних детейлерів онлайн поблизу. Перегляньте портфоліо, рейтинг та час відповіді — і замовляйте.",
      radiusLabel: "У радіусі 30 км",
      onlineNow: "Онлайн зараз",
      etaLabel: "Прибуття",
      bookCta: "Замовити детейлера",
      verified: "Перевірений",
      completedJobs: "виконаних робіт",
      responseTime: "Час відповіді",
      experience: "Досвід",
      certificationLevel: "Рівень сертифікації",
      note: "Це презентація продукту. Реальна геолокація та бронювання будуть у застосунку.",
      samples: [
        { name: "Андрій М.", area: "Кельн", rating: 4.9, jobs: 214, eta: "22 хв", level: "Elite Detailer" },
        { name: "Лукас Б.", area: "Бонн", rating: 4.8, jobs: 128, eta: "35 хв", level: "Перевірений детейлер" },
        { name: "Софія К.", area: "Ойскірхен", rating: 5.0, jobs: 76, eta: "18 хв", level: "Сертифікований Academy" },
      ],
    },
    verified: {
      eyebrow: "Перевірені детейлери",
      title: "Довірені професіонали.\nНе відкрита реєстрація.",
      desc: "PUREGARAGE не платформа самореєстрації. Кожен детейлер проходить ручну перевірку, перш ніж прийматиме замовлення.",
      steps: [
        { title: "Подати заявку", desc: "Базовий профіль та інформація про діяльність." },
        { title: "Професійний досвід", desc: "Роки практики, спеціалізація, рекомендації." },
        { title: "Портфоліо та обладнання", desc: "Реальні фото попередніх робіт та інструментів." },
        { title: "Сертифікати", desc: "Необовʼязково, але враховуються при розгляді." },
        { title: "Ручний розгляд PUREGARAGE", desc: "Наша команда перевіряє кожну заявку особисто." },
        { title: "Схвалення або співбесіда", desc: "Схвалення або запрошення на коротку співбесіду." },
      ],
      levels: [
        { name: "Заявник", desc: "Заявку отримано." },
        { name: "Перевірений детейлер", desc: "Схвалено після ручної перевірки." },
        { name: "Сертифікований PUREGLOSS Academy", desc: "Навчений та сертифікований нашою Академією." },
        { name: "Elite Detailer", desc: "Топ-рейтинг, пріоритетна видимість і замовлення." },
      ],
      academyNote: "Випускники PUREGLOSS Academy можуть отримати пріоритетну верифікацію. Зовнішні професіонали також можуть подати заявку та пройти ручний розгляд.",
    },
    rewards: {
      eyebrow: "Винагороди та рівні",
      title: "Кожен сервіс просуває вас уперед.",
      desc: "Що більше ви піклуєтеся про своє авто, то більше PUREGARAGE повертає.",
      progressLabel: "Прогрес рівня",
      currentLabel: "Поточний рівень",
      nextLabel: "Наступний рівень",
      levels: ["Bronze", "Silver", "Gold", "Black", "Diamond"],
      exampleTitle: "Приклади винагород",
      examples: [
        "Ваучер 10€",
        "Ваучер 20€",
        "Відсоткова знижка",
        "Безкоштовний захист шкіри",
        "Безкоштовна додаткова послуга",
        "Пріоритетне бронювання",
        "Ексклюзивні пропозиції PUREGARAGE",
      ],
      exampleBadge: "Приклад — не є обовʼязковою пропозицією",
      disclaimer: "Наведені приклади ілюстративні. Остаточні правила винагород буде оприлюднено в застосунку PUREGARAGE.",
    },
    achievements: {
      eyebrow: "Досягнення",
      title: "Ваш шлях догляду заслуговує на визнання.",
      desc: "Відкривайте приватні значки з розвитком історії. Активність залишається приватною за замовчуванням — публічного рейтингу клієнтів немає.",
      items: [
        "Перший детейлінг",
        "Оновлення салону",
        "Любитель шкіри",
        "П'ять сервісів",
        "Десять сервісів",
        "Готовність до зими",
        "Експерт із захисту",
        "Постійний клієнт",
        "Учасник PUREGARAGE Gold",
      ],
    },
    reminders: {
      eyebrow: "Розумні нагадування",
      title: "Дізнавайтеся, коли авто потребує уваги.",
      desc: "PUREGARAGE стежить за вашою історією та обережно нагадує, коли час. Без спаму — лише корисні своєчасні підказки.",
      items: [
        "Місяць з моменту останньої чистки салону",
        "Рекомендовано оновити захист шкіри",
        "Доступна підготовка до зими",
        "Наступна рекомендація з детейлінгу",
        "Час оглянути стан салону",
      ],
      basedOn: "На основі",
      basedOnItems: ["попередніх сервісів", "часу від останнього візиту", "інтенсивності використання", "сезону", "профілю авто"],
    },
    ai: {
      eyebrow: "AI-догляд за авто",
      title: "Розумніший догляд за вашим авто.",
      desc: "Дружній помічник, який знає історію вашого авто та допомагає планувати правильний догляд у правильний час.",
      capabilities: [
        "Пояснювати видимий знос салону",
        "Рекомендувати відповідні сервіси",
        "Відповідати на питання догляду",
        "Пропонувати наступний сервіс",
        "Пояснювати історію сервісу",
        "Допомагати підготувати авто до продажу",
      ],
      disclaimer: "AI-рекомендації є лише інформаційними та не замінюють огляд кваліфікованого фахівця.",
    },
    twoExperiences: {
      eyebrow: "Один застосунок, два досвіди",
      title: "Один застосунок.\nДва професійні досвіди.",
      desc: "Той самий PUREGARAGE адаптується під вашу роль — клієнт чи схвалений детейлер.",
      clientTitle: "Для клієнтів",
      clientItems: [
        "Цифровий гараж",
        "Замовлення перевіреного детейлера",
        "Історія сервісу",
        "Фото до/після",
        "Нагадування",
        "Винагороди",
        "Досягнення",
        "AI-помічник",
        "Відгуки",
        "Захищений профіль",
      ],
      detailerTitle: "Для детейлерів",
      detailerItems: [
        "Схвалений професійний акаунт",
        "Замовлення поруч",
        "Календар",
        "Керування бронюваннями",
        "CRM клієнтів",
        "Портфоліо",
        "Огляд доходів",
        "Рейтинг та відгуки",
        "Статус онлайн/офлайн",
        "Навігація до клієнта",
        "Рівні професійного зростання",
      ],
    },
    partners: {
      eyebrow: "Майбутні партнери",
      title: "Створено для майбутнього володіння авто.",
      tagline: "Більше історії авто.\nБільше довірених партнерів.\nОдин цифровий гараж.",
      locked: "Заблоковано",
      comingIn: "Зʼявиться в майбутньому випуску PUREGARAGE.",
      modules: [
        "Шинний сервіс",
        "СТО",
        "Оливний сервіс",
        "Інспекція авто",
        "Захисна плівка",
        "Обклеювання авто",
        "Автодилери",
        "Страхування",
        "Зарядні станції",
      ],
      disclaimer: "Ці інтеграції заплановані. У PUREGARAGE їх поки немає.",
    },
    contests: {
      eyebrow: "Конкурси та кампанії",
      title: "Ексклюзивні кампанії для спільноти PUREGARAGE.",
      futureBadge: "Концепція майбутньої кампанії",
      items: [
        "Замовляйте кваліфікаційну послугу та автоматично беріть участь у щомісячній кампанії з призами",
        "Сезонні кампанії з догляду за авто",
        "Винагороди лише для учасників",
        "Обмежені промо-акції PUREGLOSS",
      ],
      disclaimer: "Офіційні правила, умови участі та тривалість завжди відображатимуться у застосунку перед участю.",
    },
    roadmap: {
      eyebrow: "Дорожня карта",
      title: "Куди рухається PUREGARAGE.",
      labels: {
        concept: "Концепція",
        inDev: "У розробці",
        planned: "Заплановано",
        future: "Майбутнє",
      },
      phases: [
        { name: "Фаза 1", title: "Цифровий гараж та історія детейлінгу", label: "inDev" },
        { name: "Фаза 2", title: "Перевірені мобільні детейлери та бронювання", label: "planned" },
        { name: "Фаза 3", title: "Винагороди, досягнення та AI-помічник", label: "planned" },
        { name: "Фаза 4", title: "Автомобільні сервісні партнери", label: "future" },
        { name: "Фаза 5", title: "Екосистема підтвердженої історії авто", label: "future" },
      ],
    },
    waitlist: {
      eyebrow: "Лист очікування",
      title: "Будьте серед перших у PUREGARAGE.",
      desc: "Залиште дані, і ми запросимо вас, коли ваша роль стане доступною.",
      firstName: "Імʼя",
      email: "Email",
      country: "Країна",
      city: "Місто",
      interest: "Мій інтерес",
      interestClient: "Клієнт",
      interestDetailer: "Детейлер",
      interestPartner: "Автомобільний партнер",
      vehicleBrand: "Марка авто (необовʼязково)",
      vehicleBrandPlaceholder: "напр. Audi, BMW, Tesla",
      consent: "Я даю згоду на обробку моїх даних відповідно до",
      consentLink: "Політики конфіденційності",
      submit: "Долучитися до листа",
      submitting: "Надсилаємо...",
      successTitle: "Ви у списку.",
      successMessage: "Ми звʼяжемось, щойно PUREGARAGE відкриється для вашої ролі.",
      duplicateMessage: "Ця пошта вже у листі очікування PUREGARAGE.",
      errorMessage: "Не вдалося долучитися. Спробуйте ще раз.",
      firstNameRequired: "Введіть імʼя",
      emailRequired: "Введіть коректну пошту",
      consentRequired: "Прийміть Політику конфіденційності",
    },
    footer: {
      productOf: "Продукт PUREGLOSS.",
      backToSite: "Повернутися до PUREGLOSS",
    },
  },
  pl: {
    nav: "PUREGARAGE",
    badge: "Wkrótce",
    seo: {
      title: "PUREGARAGE — cyfrowe życie Twojego auta | PUREGLOSS",
      description: "PUREGARAGE to cyfrowy garaż, zweryfikowana historia pielęgnacji auta, marketplace mobilnych detailerów, program lojalnościowy oraz przyszły ekosystem usług motoryzacyjnych od PUREGLOSS.",
      ogAlt: "PUREGARAGE — premium produkt technologiczny motoryzacyjny od PUREGLOSS",
    },
    hero: {
      eyebrow: "PUREGLOSS PREZENTUJE",
      title: "Twoje auto zasługuje na cyfrowe życie.",
      subtitle: "Witaj w PUREGARAGE.",
      desc: "Cyfrowy garaż, zweryfikowana historia pielęgnacji, zaufani mobilni detailerzy i nagrody — wszystko w jednym premium ekosystemie motoryzacyjnym.",
      primary: "Odkryj PUREGARAGE",
      secondary: "Dołącz do listy",
      scrollHint: "Przewiń, aby odkryć",
    },
    intro: {
      eyebrow: "Więcej niż aplikacja",
      title: "Więcej niż aplikacja.\nCyfrowe życie Twojego auta.",
      desc: "PUREGARAGE łączy wszystko, czego potrzebuje nowoczesny właściciel auta — od cyfrowego garażu i zweryfikowanych zapisów serwisowych po mobilnych detailerów na życzenie, mądre przypomnienia, nagrody i asystenta AI.",
      screens: [
        { title: "Cyfrowy garaż", desc: "Każde auto. Każdy szczegół. Jeden profil." },
        { title: "Zamów detailera", desc: "Zaufani profesjonaliści w pobliżu." },
        { title: "Zweryfikowana historia", desc: "Każda usługa zapisana na stałe." },
        { title: "Nagrody", desc: "Każda usługa przybliża Cię do nagrody." },
      ],
    },
    garage: {
      eyebrow: "Cyfrowy garaż",
      title: "Twoje auto.\nTwoja historia.\nZawsze z Tobą.",
      desc: "Kompletny profil każdego auta — ze zdjęciami, przebiegiem, aktualnym stanem pielęgnacji i kolejną zalecaną usługą.",
      vehicleName: "Audi A6",
      spec: { year: "Rok", color: "Kolor", mileage: "Przebieg", condition: "Stan pielęgnacji" },
      colorValue: "Mythos Black",
      conditionValue: "Doskonały",
      nextService: "Kolejna zalecana usługa",
      nextServiceValue: "Głębokie czyszczenie wnętrza · za 42 dni",
      categories: ["Wnętrze", "Skóra", "Kuzow", "Felgi", "Ochrona", "Historia serwisu"],
    },
    history: {
      eyebrow: "Zweryfikowana historia",
      title: "Każda usługa staje się częścią historii Twojego auta.",
      desc: "Stała, odporna na manipulację oś czasu każdej pielęgnacji, którą otrzymało Twoje auto.",
      verifiedBadge: "PUREGARAGE Zweryfikowana historia",
      qrTitle: "Podziel się zweryfikowaną historią pielęgnacji",
      qrDesc: "Funkcja przyszła: kupujący skanuje kod QR i widzi pełną, zweryfikowaną historię pielęgnacji Twojego auta.",
      futureBadge: "Funkcja przyszła",
      items: [
        { date: "14 marca 2026", km: "48 210 km", title: "Pełny detailing wnętrza", provider: "PUREGLOSS · Zweryfikowano", note: "Fotele, dywany, plastiki i podsufitka — pełne odświeżenie." },
        { date: "14 marca 2026", km: "48 210 km", title: "Ochrona skóry", provider: "PUREGLOSS · Zweryfikowano", note: "Kondycjoner i ochrona UV na wszystkich skórzanych powierzchniach." },
        { date: "02 lutego 2026", km: "46 980 km", title: "Głębokie pranie foteli", provider: "PUREGLOSS · Zweryfikowano", note: "Ekstrakcja wszystkich foteli z neutralizacją zapachów." },
        { date: "18 listopada 2025", km: "44 105 km", title: "Detailing zewnętrzny", provider: "PUREGLOSS · Zweryfikowano", note: "Mycie ręczne, dekontaminacja, sealant i pielęgnacja opon." },
        { date: "18 listopada 2025", km: "44 105 km", title: "Ochrona lakieru", provider: "PUREGLOSS · Zweryfikowano", note: "Długotrwały sealant polimerowy." },
        { date: "Zalecane", km: "≈ 51 000 km", title: "Kolejna zalecana pielęgnacja", provider: "PUREGARAGE Assistant", note: "Odświeżenie wnętrza · regeneracja skóry." },
      ],
    },
    detailers: {
      eyebrow: "Detailerzy w pobliżu",
      title: "Profesjonalna pielęgnacja.\nGdziekolwiek jest Twoje auto.",
      desc: "Zobacz zweryfikowanych mobilnych detailerów online w pobliżu. Przejrzyj portfolio, ocenę i czas reakcji — i zamów usługę.",
      radiusLabel: "W promieniu 30 km",
      onlineNow: "Teraz online",
      etaLabel: "Przyjazd",
      bookCta: "Zamów detailera",
      verified: "Zweryfikowany",
      completedJobs: "wykonanych zleceń",
      responseTime: "Czas reakcji",
      experience: "Doświadczenie",
      certificationLevel: "Poziom certyfikacji",
      note: "To prezentacja produktu. Realna geolokalizacja i rezerwacje będą w aplikacji na żywo.",
      samples: [
        { name: "Andrii M.", area: "Kolonia", rating: 4.9, jobs: 214, eta: "22 min", level: "Elite Detailer" },
        { name: "Lukas B.", area: "Bonn", rating: 4.8, jobs: 128, eta: "35 min", level: "Zweryfikowany Detailer" },
        { name: "Sofia K.", area: "Euskirchen", rating: 5.0, jobs: 76, eta: "18 min", level: "Certyfikat Academy" },
      ],
    },
    verified: {
      eyebrow: "Zweryfikowani detailerzy",
      title: "Zaufani profesjonaliści.\nBez otwartej rejestracji.",
      desc: "PUREGARAGE nie jest platformą samoobsługową. Każdy detailer jest ręcznie weryfikowany, zanim będzie mógł przyjmować zlecenia.",
      steps: [
        { title: "Złóż wniosek", desc: "Profil podstawowy i dane działalności." },
        { title: "Doświadczenie zawodowe", desc: "Lata praktyki, specjalizacje, referencje." },
        { title: "Portfolio i sprzęt", desc: "Prawdziwe zdjęcia wcześniejszych prac i narzędzi." },
        { title: "Certyfikaty", desc: "Opcjonalne, ale uwzględniane przy ocenie." },
        { title: "Ręczna weryfikacja PUREGARAGE", desc: "Nasz zespół osobiście weryfikuje każdy wniosek." },
        { title: "Zatwierdzenie lub rozmowa", desc: "Zatwierdzenie lub zaproszenie na krótką rozmowę." },
      ],
      levels: [
        { name: "Kandydat", desc: "Wniosek otrzymany." },
        { name: "Zweryfikowany detailer", desc: "Zatwierdzony po ręcznej weryfikacji." },
        { name: "Certyfikowany PUREGLOSS Academy", desc: "Wyszkolony i certyfikowany przez naszą Akademię." },
        { name: "Elite Detailer", desc: "Najlepiej oceniany, priorytetowa widoczność i zlecenia." },
      ],
      academyNote: "Absolwenci PUREGLOSS Academy mogą uzyskać priorytetową weryfikację. Zewnętrzni profesjonaliści są mile widziani i przechodzą ręczną weryfikację.",
    },
    rewards: {
      eyebrow: "Nagrody i poziomy",
      title: "Każda usługa przybliża Cię do celu.",
      desc: "Im bardziej dbasz o swoje auto, tym więcej PUREGARAGE Ci zwraca.",
      progressLabel: "Postęp poziomu",
      currentLabel: "Obecny poziom",
      nextLabel: "Kolejny poziom",
      levels: ["Bronze", "Silver", "Gold", "Black", "Diamond"],
      exampleTitle: "Przykładowe nagrody",
      examples: [
        "Voucher 10€",
        "Voucher 20€",
        "Procentowy rabat",
        "Bezpłatna ochrona skóry",
        "Bezpłatna usługa dodatkowa",
        "Priorytetowa rezerwacja",
        "Ekskluzywne oferty PUREGARAGE",
      ],
      exampleBadge: "Przykład — nie stanowi wiążącej oferty",
      disclaimer: "Pokazane przykłady mają charakter ilustracyjny. Ostateczne zasady zostaną opublikowane w aplikacji PUREGARAGE.",
    },
    achievements: {
      eyebrow: "Osiągnięcia",
      title: "Twoja podróż pielęgnacyjna zasługuje na uznanie.",
      desc: "Odkrywaj prywatne odznaki wraz z rozwojem historii. Aktywność jest domyślnie prywatna — nie ma publicznego rankingu klientów.",
      items: [
        "Pierwszy detailing",
        "Reset wnętrza",
        "Miłośnik skóry",
        "Pięć usług",
        "Dziesięć usług",
        "Gotowy na zimę",
        "Ekspert ochrony",
        "Lojalny klient",
        "Członek PUREGARAGE Gold",
      ],
    },
    reminders: {
      eyebrow: "Mądre przypomnienia",
      title: "Wiedz, kiedy auto potrzebuje uwagi.",
      desc: "PUREGARAGE obserwuje Twoją historię i delikatnie przypomina we właściwym momencie. Bez spamu — tylko przydatne wskazówki.",
      items: [
        "Miesiąc od ostatniego prania wnętrza",
        "Zalecane odświeżenie ochrony skóry",
        "Dostępne przygotowanie do zimy",
        "Kolejna rekomendacja detailingu",
        "Czas na przegląd stanu wnętrza",
      ],
      basedOn: "Na podstawie",
      basedOnItems: ["wcześniejszych usług", "czasu od ostatniej wizyty", "intensywności użytkowania", "sezonu", "profilu auta"],
    },
    ai: {
      eyebrow: "AI pielęgnacja auta",
      title: "Mądrzejsza pielęgnacja Twojego auta.",
      desc: "Przyjazny asystent, który zna historię Twojego auta i pomaga zaplanować właściwą pielęgnację we właściwym czasie.",
      capabilities: [
        "Wyjaśnia widoczne zużycie wnętrza",
        "Poleca odpowiednie usługi",
        "Odpowiada na pytania o pielęgnację",
        "Sugeruje kolejną usługę",
        "Wyjaśnia historię serwisu",
        "Pomaga przygotować auto do sprzedaży",
      ],
      disclaimer: "Rekomendacje AI mają charakter informacyjny i nie zastępują oceny wykwalifikowanego specjalisty.",
    },
    twoExperiences: {
      eyebrow: "Jedna aplikacja, dwa doświadczenia",
      title: "Jedna aplikacja.\nDwa profesjonalne doświadczenia.",
      desc: "Ta sama aplikacja PUREGARAGE dostosowuje się do Twojej roli — klienta lub zatwierdzonego detailera.",
      clientTitle: "Dla klientów",
      clientItems: [
        "Cyfrowy garaż",
        "Zamów zweryfikowanego detailera",
        "Historia serwisu",
        "Zdjęcia przed / po",
        "Przypomnienia",
        "Nagrody",
        "Osiągnięcia",
        "Asystent AI",
        "Opinie",
        "Bezpieczny profil",
      ],
      detailerTitle: "Dla detailerów",
      detailerItems: [
        "Zatwierdzone konto profesjonalne",
        "Zlecenia w pobliżu",
        "Kalendarz",
        "Zarządzanie rezerwacjami",
        "CRM klientów",
        "Portfolio",
        "Podgląd zarobków",
        "Oceny i opinie",
        "Status online / offline",
        "Nawigacja do klienta",
        "Poziomy rozwoju zawodowego",
      ],
    },
    partners: {
      eyebrow: "Przyszli partnerzy",
      title: "Zbudowane pod przyszłość posiadania auta.",
      tagline: "Więcej historii auta.\nWięcej zaufanych partnerów.\nJeden cyfrowy garaż.",
      locked: "Zablokowane",
      comingIn: "Dostępne w przyszłej wersji PUREGARAGE.",
      modules: [
        "Serwis opon",
        "Warsztaty",
        "Wymiana oleju",
        "Przegląd auta",
        "Folia PPF",
        "Oklejanie auta",
        "Salony samochodowe",
        "Ubezpieczenia",
        "Ładowanie",
      ],
      disclaimer: "Te integracje są planowane. Jeszcze nie istnieją w PUREGARAGE.",
    },
    contests: {
      eyebrow: "Konkursy i kampanie",
      title: "Ekskluzywne kampanie dla społeczności PUREGARAGE.",
      futureBadge: "Koncepcja przyszłej kampanii",
      items: [
        "Zamów kwalifikowaną usługę i automatycznie weź udział w miesięcznej kampanii z nagrodami",
        "Sezonowe kampanie pielęgnacyjne",
        "Nagrody tylko dla członków",
        "Limitowane promocje PUREGLOSS",
      ],
      disclaimer: "Oficjalne zasady, warunki i czas trwania będą zawsze wyświetlane w aplikacji przed uczestnictwem.",
    },
    roadmap: {
      eyebrow: "Roadmap",
      title: "Dokąd zmierza PUREGARAGE.",
      labels: {
        concept: "Koncepcja",
        inDev: "W rozwoju",
        planned: "Planowane",
        future: "Przyszłość",
      },
      phases: [
        { name: "Faza 1", title: "Cyfrowy garaż i historia detailingu", label: "inDev" },
        { name: "Faza 2", title: "Zweryfikowani mobilni detailerzy i rezerwacja", label: "planned" },
        { name: "Faza 3", title: "Nagrody, osiągnięcia i asystent AI", label: "planned" },
        { name: "Faza 4", title: "Partnerzy usług motoryzacyjnych", label: "future" },
        { name: "Faza 5", title: "Ekosystem zweryfikowanej historii auta", label: "future" },
      ],
    },
    waitlist: {
      eyebrow: "Lista oczekujących",
      title: "Bądź wśród pierwszych w PUREGARAGE.",
      desc: "Zostaw dane, a zaprosimy Cię, gdy Twoja rola się otworzy.",
      firstName: "Imię",
      email: "E-mail",
      country: "Kraj",
      city: "Miasto",
      interest: "Interesuję się jako",
      interestClient: "Klient",
      interestDetailer: "Detailer",
      interestPartner: "Partner motoryzacyjny",
      vehicleBrand: "Marka auta (opcjonalnie)",
      vehicleBrandPlaceholder: "np. Audi, BMW, Tesla",
      consent: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z",
      consentLink: "Polityką prywatności",
      submit: "Dołącz do listy",
      submitting: "Wysyłanie...",
      successTitle: "Jesteś na liście.",
      successMessage: "Odezwiemy się, gdy PUREGARAGE otworzy się dla Twojej roli.",
      duplicateMessage: "Ten e-mail już jest na liście PUREGARAGE.",
      errorMessage: "Nie udało się dołączyć. Spróbuj ponownie.",
      firstNameRequired: "Podaj imię",
      emailRequired: "Podaj poprawny e-mail",
      consentRequired: "Zaakceptuj Politykę prywatności",
    },
    footer: {
      productOf: "Produkt PUREGLOSS.",
      backToSite: "Powrót do PUREGLOSS",
    },
  },
  ru: {
    nav: "PUREGARAGE",
    badge: "Скоро",
    seo: {
      title: "PUREGARAGE — цифровая жизнь вашего авто | PUREGLOSS",
      description: "PUREGARAGE — это цифровой гараж, подтверждённая история ухода за автомобилем, маркетплейс мобильных детейлеров, программа лояльности и будущая автомобильная экосистема от PUREGLOSS.",
      ogAlt: "PUREGARAGE — премиальный автомобильный технологический продукт от PUREGLOSS",
    },
    hero: {
      eyebrow: "PUREGLOSS ПРЕДСТАВЛЯЕТ",
      title: "Ваш автомобиль заслуживает цифровой жизни.",
      subtitle: "Добро пожаловать в PUREGARAGE.",
      desc: "Цифровой гараж, подтверждённая история ухода, проверенные мобильные детейлеры и вознаграждения — всё в одной премиальной автомобильной экосистеме.",
      primary: "Открыть PUREGARAGE",
      secondary: "В лист ожидания",
      scrollHint: "Прокрутите, чтобы изучить",
    },
    intro: {
      eyebrow: "Больше, чем приложение",
      title: "Больше, чем приложение.\nЦифровая жизнь вашего авто.",
      desc: "PUREGARAGE объединяет всё, что нужно современному владельцу авто — от цифрового гаража и подтверждённых сервисных записей до мобильных детейлеров по запросу, умных напоминаний, вознаграждений и AI-ассистента.",
      screens: [
        { title: "Цифровой гараж", desc: "Каждое авто. Каждая деталь. Один профиль." },
        { title: "Заказать детейлера", desc: "Проверенные мастера рядом." },
        { title: "Подтверждённая история", desc: "Каждая услуга — навсегда." },
        { title: "Вознаграждения", desc: "Каждая услуга приближает к цели." },
      ],
    },
    garage: {
      eyebrow: "Цифровой гараж",
      title: "Ваше авто.\nВаша история.\nВсегда с вами.",
      desc: "Полный профиль для каждого автомобиля — с фото, пробегом, текущим состоянием ухода и следующей рекомендованной услугой.",
      vehicleName: "Audi A6",
      spec: { year: "Год", color: "Цвет", mileage: "Пробег", condition: "Состояние ухода" },
      colorValue: "Mythos Black",
      conditionValue: "Отличное",
      nextService: "Следующая рекомендованная услуга",
      nextServiceValue: "Глубокая химчистка салона · через 42 дня",
      categories: ["Салон", "Кожа", "Кузов", "Диски", "Защита", "История сервиса"],
    },
    history: {
      eyebrow: "Подтверждённая история",
      title: "Каждая услуга становится частью истории вашего авто.",
      desc: "Постоянная, защищённая от изменений хронология каждой процедуры, которую получил автомобиль.",
      verifiedBadge: "PUREGARAGE Подтверждённая история",
      qrTitle: "Поделитесь подтверждённой историей ухода",
      qrDesc: "Будущая функция: покупатели могут отсканировать QR-код и увидеть полную подтверждённую историю ухода за вашим авто.",
      futureBadge: "Будущая функция",
      items: [
        { date: "14 марта 2026", km: "48 210 км", title: "Полный детейлинг салона", provider: "PUREGLOSS · Подтверждено", note: "Сиденья, ковры, пластик и потолок — полное обновление." },
        { date: "14 марта 2026", km: "48 210 км", title: "Защита кожи", provider: "PUREGLOSS · Подтверждено", note: "Кондиционер и UV-защита для всех кожаных поверхностей." },
        { date: "02 февраля 2026", km: "46 980 км", title: "Глубокая химчистка сидений", provider: "PUREGLOSS · Подтверждено", note: "Экстракция всех сидений с нейтрализацией запахов." },
        { date: "18 ноября 2025", km: "44 105 км", title: "Детейлинг кузова", provider: "PUREGLOSS · Подтверждено", note: "Ручная мойка, деконтаминация, силант и уход за шинами." },
        { date: "18 ноября 2025", km: "44 105 км", title: "Защита ЛКП", provider: "PUREGLOSS · Подтверждено", note: "Долговременный полимерный силант." },
        { date: "Рекомендовано", km: "≈ 51 000 км", title: "Следующий рекомендованный уход", provider: "PUREGARAGE Assistant", note: "Обновление салона · восстановление кожи." },
      ],
    },
    detailers: {
      eyebrow: "Детейлеры рядом",
      title: "Профессиональный уход.\nГде бы ни было ваше авто.",
      desc: "Смотрите проверенных мобильных детейлеров онлайн рядом с вами. Портфолио, рейтинг и время отклика — и заказ услуги.",
      radiusLabel: "В радиусе 30 км",
      onlineNow: "Онлайн сейчас",
      etaLabel: "Прибытие",
      bookCta: "Заказать детейлера",
      verified: "Проверенный",
      completedJobs: "выполненных работ",
      responseTime: "Время отклика",
      experience: "Опыт",
      certificationLevel: "Уровень сертификации",
      note: "Это презентация продукта. Реальная геолокация и бронирования будут в приложении.",
      samples: [
        { name: "Андрей М.", area: "Кёльн", rating: 4.9, jobs: 214, eta: "22 мин", level: "Elite Detailer" },
        { name: "Лукас Б.", area: "Бонн", rating: 4.8, jobs: 128, eta: "35 мин", level: "Проверенный детейлер" },
        { name: "София К.", area: "Ойскирхен", rating: 5.0, jobs: 76, eta: "18 мин", level: "Сертификат Academy" },
      ],
    },
    verified: {
      eyebrow: "Проверенные детейлеры",
      title: "Доверенные профессионалы.\nБез открытой регистрации.",
      desc: "PUREGARAGE — не платформа самообслуживания. Каждый детейлер проходит ручную проверку перед тем, как принимать заказы.",
      steps: [
        { title: "Подать заявку", desc: "Базовый профиль и данные о деятельности." },
        { title: "Профессиональный опыт", desc: "Годы практики, специализация, рекомендации." },
        { title: "Портфолио и оборудование", desc: "Реальные фото прошлых работ и инструментов." },
        { title: "Сертификаты", desc: "Необязательны, но учитываются при рассмотрении." },
        { title: "Ручная проверка PUREGARAGE", desc: "Наша команда проверяет каждую заявку лично." },
        { title: "Одобрение или интервью", desc: "Одобрение или приглашение на короткое интервью." },
      ],
      levels: [
        { name: "Кандидат", desc: "Заявка получена." },
        { name: "Проверенный детейлер", desc: "Одобрен после ручной проверки." },
        { name: "Сертифицирован PUREGLOSS Academy", desc: "Обучен и сертифицирован нашей Академией." },
        { name: "Elite Detailer", desc: "Топ-рейтинг, приоритетная видимость и заказы." },
      ],
      academyNote: "Выпускники PUREGLOSS Academy могут получить приоритетную верификацию. Внешние профессионалы также приветствуются и проходят ручную проверку.",
    },
    rewards: {
      eyebrow: "Вознаграждения и уровни",
      title: "Каждая услуга продвигает вас вперёд.",
      desc: "Чем больше вы заботитесь об авто, тем больше PUREGARAGE возвращает вам.",
      progressLabel: "Прогресс уровня",
      currentLabel: "Текущий уровень",
      nextLabel: "Следующий уровень",
      levels: ["Bronze", "Silver", "Gold", "Black", "Diamond"],
      exampleTitle: "Примеры вознаграждений",
      examples: [
        "Ваучер 10€",
        "Ваучер 20€",
        "Процентная скидка",
        "Бесплатная защита кожи",
        "Бесплатная дополнительная услуга",
        "Приоритетное бронирование",
        "Эксклюзивные предложения PUREGARAGE",
      ],
      exampleBadge: "Пример — не обязывающее предложение",
      disclaimer: "Показанные примеры носят иллюстративный характер. Финальные правила будут опубликованы в приложении PUREGARAGE.",
    },
    achievements: {
      eyebrow: "Достижения",
      title: "Ваш путь ухода за авто заслуживает признания.",
      desc: "Открывайте приватные значки по мере роста истории. Активность остаётся приватной по умолчанию — публичного рейтинга клиентов нет.",
      items: [
        "Первый детейлинг",
        "Обновление салона",
        "Любитель кожи",
        "Пять услуг",
        "Десять услуг",
        "Готовность к зиме",
        "Эксперт по защите",
        "Лояльный клиент",
        "Участник PUREGARAGE Gold",
      ],
    },
    reminders: {
      eyebrow: "Умные напоминания",
      title: "Знайте, когда авто нужно внимание.",
      desc: "PUREGARAGE следит за вашей историей и мягко напоминает, когда пора. Без спама — только полезные подсказки.",
      items: [
        "Месяц с момента последней химчистки салона",
        "Рекомендовано обновить защиту кожи",
        "Доступна подготовка к зиме",
        "Следующая рекомендация по детейлингу",
        "Время осмотреть состояние салона",
      ],
      basedOn: "На основе",
      basedOnItems: ["предыдущих услуг", "времени с последнего визита", "интенсивности использования", "сезона", "профиля авто"],
    },
    ai: {
      eyebrow: "AI-уход за авто",
      title: "Умнее уход за вашим авто.",
      desc: "Дружелюбный ассистент, который знает историю вашего авто и помогает планировать нужный уход в нужное время.",
      capabilities: [
        "Объясняет видимый износ салона",
        "Рекомендует подходящие услуги",
        "Отвечает на вопросы по уходу",
        "Предлагает следующую услугу",
        "Объясняет историю сервиса",
        "Помогает подготовить авто к продаже",
      ],
      disclaimer: "Рекомендации AI носят информационный характер и не заменяют осмотр квалифицированным специалистом.",
    },
    twoExperiences: {
      eyebrow: "Одно приложение, два опыта",
      title: "Одно приложение.\nДва профессиональных опыта.",
      desc: "То же приложение PUREGARAGE адаптируется под вашу роль — клиент или одобренный детейлер.",
      clientTitle: "Для клиентов",
      clientItems: [
        "Цифровой гараж",
        "Заказ проверенного детейлера",
        "История сервиса",
        "Фото до / после",
        "Напоминания",
        "Вознаграждения",
        "Достижения",
        "AI-ассистент",
        "Отзывы",
        "Безопасный профиль",
      ],
      detailerTitle: "Для детейлеров",
      detailerItems: [
        "Одобренный профессиональный аккаунт",
        "Заявки рядом",
        "Календарь",
        "Управление бронированиями",
        "CRM клиентов",
        "Портфолио",
        "Обзор доходов",
        "Рейтинг и отзывы",
        "Статус онлайн / офлайн",
        "Навигация к клиенту",
        "Уровни профессионального роста",
      ],
    },
    partners: {
      eyebrow: "Будущие партнёры",
      title: "Создано для будущего владения авто.",
      tagline: "Больше истории авто.\nБольше доверенных партнёров.\nОдин цифровой гараж.",
      locked: "Заблокировано",
      comingIn: "Появится в будущем релизе PUREGARAGE.",
      modules: [
        "Шинный сервис",
        "СТО",
        "Замена масла",
        "Техосмотр",
        "Защитная плёнка",
        "Оклейка авто",
        "Автосалоны",
        "Страхование",
        "Зарядные станции",
      ],
      disclaimer: "Эти интеграции запланированы. В PUREGARAGE их пока нет.",
    },
    contests: {
      eyebrow: "Конкурсы и кампании",
      title: "Эксклюзивные кампании для сообщества PUREGARAGE.",
      futureBadge: "Концепция будущей кампании",
      items: [
        "Закажите квалификационную услугу и автоматически участвуйте в ежемесячной кампании с призами",
        "Сезонные кампании по уходу за авто",
        "Награды только для участников",
        "Ограниченные акции PUREGLOSS",
      ],
      disclaimer: "Официальные правила, условия и сроки всегда будут отображаться в приложении перед участием.",
    },
    roadmap: {
      eyebrow: "Дорожная карта",
      title: "Куда движется PUREGARAGE.",
      labels: {
        concept: "Концепция",
        inDev: "В разработке",
        planned: "Запланировано",
        future: "Будущее",
      },
      phases: [
        { name: "Фаза 1", title: "Цифровой гараж и история детейлинга", label: "inDev" },
        { name: "Фаза 2", title: "Проверенные мобильные детейлеры и бронирование", label: "planned" },
        { name: "Фаза 3", title: "Вознаграждения, достижения и AI-ассистент", label: "planned" },
        { name: "Фаза 4", title: "Автомобильные сервисные партнёры", label: "future" },
        { name: "Фаза 5", title: "Экосистема подтверждённой истории авто", label: "future" },
      ],
    },
    waitlist: {
      eyebrow: "Лист ожидания",
      title: "Будьте среди первых в PUREGARAGE.",
      desc: "Оставьте данные — пригласим, как только ваша роль станет доступна.",
      firstName: "Имя",
      email: "E-mail",
      country: "Страна",
      city: "Город",
      interest: "Мой интерес",
      interestClient: "Клиент",
      interestDetailer: "Детейлер",
      interestPartner: "Автомобильный партнёр",
      vehicleBrand: "Марка авто (по желанию)",
      vehicleBrandPlaceholder: "напр. Audi, BMW, Tesla",
      consent: "Я согласен на обработку моих данных согласно",
      consentLink: "Политике конфиденциальности",
      submit: "В лист ожидания",
      submitting: "Отправляем...",
      successTitle: "Вы в списке.",
      successMessage: "Мы свяжемся, как только PUREGARAGE откроется для вашей роли.",
      duplicateMessage: "Этот e-mail уже в листе ожидания PUREGARAGE.",
      errorMessage: "Не удалось присоединиться. Попробуйте ещё раз.",
      firstNameRequired: "Укажите имя",
      emailRequired: "Укажите корректный e-mail",
      consentRequired: "Примите Политику конфиденциальности",
    },
    footer: {
      productOf: "Продукт PUREGLOSS.",
      backToSite: "Вернуться в PUREGLOSS",
    },
  },
};

Object.keys(PUREGARAGE_I18N).forEach((code) => {
  if (translations[code]) {
    translations[code].puregarage = PUREGARAGE_I18N[code];
  }
});

// ---------------------------------------------------------------------------
// PUREGARAGE — Features grid (section below the Hero). Native strings for
// all 5 languages, appended to the existing puregarage.* namespace so that
// key parity remains 100 %.
// ---------------------------------------------------------------------------
const PUREGARAGE_FEATURES_I18N = {
  en: {
    eyebrow: "Ecosystem",
    title: "Everything your car deserves.",
    subtitle: "One ecosystem for vehicle care, maintenance, detailing and intelligent ownership.",
    items: [
      { title: "Digital Garage",       desc: "Store your complete vehicle history." },
      { title: "AI Vehicle Analysis",  desc: "AI-powered vehicle insights and recommendations." },
      { title: "Verified Detailers",   desc: "Find trusted premium detailing professionals." },
      { title: "Smart Maintenance",    desc: "Receive intelligent maintenance reminders." },
      { title: "Vehicle History",      desc: "Track every service, detailing session and document." },
      { title: "Rewards",              desc: "Earn premium rewards for taking care of your vehicle." },
    ],
  },
  de: {
    eyebrow: "Ökosystem",
    title: "Alles, was Ihr Auto verdient.",
    subtitle: "Ein Ökosystem für Fahrzeugpflege, Wartung, Detailing und intelligentes Fahrzeugerlebnis.",
    items: [
      { title: "Digitale Garage",         desc: "Speichern Sie die komplette Historie Ihres Fahrzeugs." },
      { title: "KI-Fahrzeuganalyse",      desc: "KI-gestützte Einblicke und Empfehlungen." },
      { title: "Verifizierte Detailer",   desc: "Finden Sie geprüfte Premium-Detailing-Profis." },
      { title: "Smarte Wartung",          desc: "Erhalten Sie intelligente Wartungserinnerungen." },
      { title: "Fahrzeughistorie",        desc: "Jeder Service, jede Aufbereitung und jedes Dokument." },
      { title: "Prämien",                 desc: "Prämien für die Pflege Ihres Fahrzeugs." },
    ],
  },
  ua: {
    eyebrow: "Екосистема",
    title: "Усе, на що заслуговує ваше авто.",
    subtitle: "Єдина екосистема для догляду, обслуговування, детейлінгу та розумного володіння авто.",
    items: [
      { title: "Цифровий гараж",           desc: "Зберігайте повну історію свого авто." },
      { title: "AI-аналіз авто",           desc: "Аналітика та рекомендації на основі AI." },
      { title: "Перевірені детейлери",     desc: "Знайдіть довірених преміальних майстрів." },
      { title: "Розумне обслуговування",   desc: "Отримуйте розумні нагадування про сервіс." },
      { title: "Історія авто",             desc: "Кожна послуга, сесія детейлінгу і документ." },
      { title: "Винагороди",               desc: "Отримуйте преміальні винагороди за догляд." },
    ],
  },
  pl: {
    eyebrow: "Ekosystem",
    title: "Wszystko, na co zasługuje Twoje auto.",
    subtitle: "Jeden ekosystem do pielęgnacji, serwisu, detailingu i inteligentnego posiadania auta.",
    items: [
      { title: "Cyfrowy garaż",              desc: "Zapisz pełną historię swojego auta." },
      { title: "Analiza AI pojazdu",         desc: "Wnioski i rekomendacje wspierane przez AI." },
      { title: "Zweryfikowani detailerzy",   desc: "Znajdź zaufanych premium detailerów." },
      { title: "Inteligentna konserwacja",   desc: "Otrzymuj mądre przypomnienia serwisowe." },
      { title: "Historia pojazdu",           desc: "Każda usługa, sesja detailingu i dokument." },
      { title: "Nagrody",                    desc: "Zdobywaj premium nagrody za dbanie o auto." },
    ],
  },
  ru: {
    eyebrow: "Экосистема",
    title: "Всё, чего заслуживает ваш автомобиль.",
    subtitle: "Единая экосистема для ухода, обслуживания, детейлинга и умного владения авто.",
    items: [
      { title: "Цифровой гараж",             desc: "Храните полную историю своего автомобиля." },
      { title: "AI-анализ авто",             desc: "Аналитика и рекомендации на базе AI." },
      { title: "Проверенные детейлеры",      desc: "Найдите доверенных премиум-мастеров." },
      { title: "Умное обслуживание",         desc: "Получайте умные напоминания о сервисе." },
      { title: "История автомобиля",         desc: "Каждая услуга, сессия детейлинга и документ." },
      { title: "Награды",                    desc: "Получайте премиальные награды за уход." },
    ],
  },
};

Object.keys(PUREGARAGE_FEATURES_I18N).forEach((code) => {
  if (translations[code] && translations[code].puregarage) {
    translations[code].puregarage.features = PUREGARAGE_FEATURES_I18N[code];
  }
});

// ---------------------------------------------------------------------------
// PUREGARAGE — "Your Digital Garage" centrepiece section (below Features).
// Non-visual copy strings across all 5 languages. Content strings that are
// intentionally universal (vehicle name, score numbers, dates) live in the
// component itself.
// ---------------------------------------------------------------------------
const PUREGARAGE_DGS_I18N = {
  en: {
    eyebrow: "Your Digital Garage",
    title: "Your Digital Garage.",
    subtitle: "Every vehicle. Every service. Every detail.\nOrganized beautifully in one intelligent ecosystem.",
    bullets: [
      "Complete verified service history for every car you own",
      "AI insights and reminders tailored to your vehicle",
      "Beautiful vehicle documents ready when you sell",
    ],
    ctaPrimary: "Explore Garage",
    ctaSecondary: "Learn more",
    dash: {
      score: "Vehicle Score",
      status: "Status",
      statusValue: "Excellent",
      protection: "Protection",
      protectionValue: "Ceramic Active",
      lastDetailing: "Last Detailing",
      lastDetailingValue: "14 July",
      mileage: "Mileage",
      upcoming: "Upcoming Service",
      upcomingValue: "Brake Inspection",
      timelineTitle: "Timeline",
      timeline: ["Interior Deep Clean", "Ceramic Coating", "Engine Bay Cleaning", "Tire Protection"],
      health: "Vehicle Health",
      recommendation: "AI Recommendation",
      recommendationValue: "Leather reconditioning in 3 weeks",
      maintenance: "Maintenance",
      maintenanceValue: "On schedule",
      protectionCard: "Protection",
      protectionCardValue: "12 months left",
      recent: "Recent Photos",
    },
  },
  de: {
    eyebrow: "Ihre digitale Garage",
    title: "Ihre digitale Garage.",
    subtitle: "Jedes Fahrzeug. Jeder Service. Jedes Detail.\nElegant organisiert in einem intelligenten Ökosystem.",
    bullets: [
      "Vollständige verifizierte Servicehistorie für jedes Ihrer Fahrzeuge",
      "KI-Einblicke und Erinnerungen, auf Ihr Auto zugeschnitten",
      "Schöne Fahrzeugdokumente, bereit für den Verkauf",
    ],
    ctaPrimary: "Garage entdecken",
    ctaSecondary: "Mehr erfahren",
    dash: {
      score: "Fahrzeug-Score",
      status: "Status",
      statusValue: "Ausgezeichnet",
      protection: "Schutz",
      protectionValue: "Keramik aktiv",
      lastDetailing: "Letzte Aufbereitung",
      lastDetailingValue: "14. Juli",
      mileage: "Kilometerstand",
      upcoming: "Nächster Service",
      upcomingValue: "Bremseninspektion",
      timelineTitle: "Verlauf",
      timeline: ["Intensive Innenraumreinigung", "Keramikversiegelung", "Motorraumreinigung", "Reifenschutz"],
      health: "Fahrzeugzustand",
      recommendation: "KI-Empfehlung",
      recommendationValue: "Lederpflege in 3 Wochen",
      maintenance: "Wartung",
      maintenanceValue: "Im Plan",
      protectionCard: "Schutz",
      protectionCardValue: "Noch 12 Monate",
      recent: "Neueste Fotos",
    },
  },
  ua: {
    eyebrow: "Ваш цифровий гараж",
    title: "Ваш цифровий гараж.",
    subtitle: "Кожне авто. Кожен сервіс. Кожна деталь.\nЕлегантно організовано в одній розумній екосистемі.",
    bullets: [
      "Повна підтверджена історія обслуговування кожного вашого авто",
      "AI-аналітика та нагадування, адаптовані до вашого авто",
      "Красиві документи авто, готові до продажу",
    ],
    ctaPrimary: "Дослідити гараж",
    ctaSecondary: "Дізнатися більше",
    dash: {
      score: "Оцінка авто",
      status: "Статус",
      statusValue: "Відмінно",
      protection: "Захист",
      protectionValue: "Кераміка активна",
      lastDetailing: "Останній детейлінг",
      lastDetailingValue: "14 липня",
      mileage: "Пробіг",
      upcoming: "Наступне ТО",
      upcomingValue: "Перевірка гальм",
      timelineTitle: "Хронологія",
      timeline: ["Глибока чистка салону", "Керамічне покриття", "Чистка моторного відсіку", "Захист шин"],
      health: "Стан авто",
      recommendation: "AI-рекомендація",
      recommendationValue: "Відновлення шкіри через 3 тижні",
      maintenance: "Обслуговування",
      maintenanceValue: "За планом",
      protectionCard: "Захист",
      protectionCardValue: "Залишилось 12 міс.",
      recent: "Нові фото",
    },
  },
  pl: {
    eyebrow: "Twój cyfrowy garaż",
    title: "Twój cyfrowy garaż.",
    subtitle: "Każdy pojazd. Każda usługa. Każdy szczegół.\nPięknie uporządkowane w jednym inteligentnym ekosystemie.",
    bullets: [
      "Pełna zweryfikowana historia serwisowa każdego auta",
      "Analiza AI i przypomnienia dopasowane do Twojego auta",
      "Piękne dokumenty pojazdu gotowe do sprzedaży",
    ],
    ctaPrimary: "Odkryj garaż",
    ctaSecondary: "Dowiedz się więcej",
    dash: {
      score: "Ocena pojazdu",
      status: "Status",
      statusValue: "Doskonały",
      protection: "Ochrona",
      protectionValue: "Ceramika aktywna",
      lastDetailing: "Ostatni detailing",
      lastDetailingValue: "14 lipca",
      mileage: "Przebieg",
      upcoming: "Nadchodzący serwis",
      upcomingValue: "Kontrola hamulców",
      timelineTitle: "Historia",
      timeline: ["Głębokie czyszczenie wnętrza", "Powłoka ceramiczna", "Czyszczenie komory silnika", "Ochrona opon"],
      health: "Stan pojazdu",
      recommendation: "Rekomendacja AI",
      recommendationValue: "Regeneracja skóry za 3 tygodnie",
      maintenance: "Konserwacja",
      maintenanceValue: "Zgodnie z planem",
      protectionCard: "Ochrona",
      protectionCardValue: "12 miesięcy pozostało",
      recent: "Ostatnie zdjęcia",
    },
  },
  ru: {
    eyebrow: "Ваш цифровой гараж",
    title: "Ваш цифровой гараж.",
    subtitle: "Каждое авто. Каждый сервис. Каждая деталь.\nЭлегантно организовано в единой интеллектуальной экосистеме.",
    bullets: [
      "Полная подтверждённая история обслуживания каждого авто",
      "AI-аналитика и напоминания, подстроенные под ваш автомобиль",
      "Красивые документы авто, готовые к продаже",
    ],
    ctaPrimary: "Открыть гараж",
    ctaSecondary: "Узнать больше",
    dash: {
      score: "Оценка авто",
      status: "Статус",
      statusValue: "Отличное",
      protection: "Защита",
      protectionValue: "Керамика активна",
      lastDetailing: "Последний детейлинг",
      lastDetailingValue: "14 июля",
      mileage: "Пробег",
      upcoming: "Ближайшее ТО",
      upcomingValue: "Проверка тормозов",
      timelineTitle: "Хронология",
      timeline: ["Глубокая химчистка салона", "Керамическое покрытие", "Чистка моторного отсека", "Защита шин"],
      health: "Состояние авто",
      recommendation: "AI-рекомендация",
      recommendationValue: "Восстановление кожи через 3 недели",
      maintenance: "Обслуживание",
      maintenanceValue: "По графику",
      protectionCard: "Защита",
      protectionCardValue: "12 мес. осталось",
      recent: "Недавние фото",
    },
  },
};

Object.keys(PUREGARAGE_DGS_I18N).forEach((code) => {
  if (translations[code] && translations[code].puregarage) {
    translations[code].puregarage.dgs = PUREGARAGE_DGS_I18N[code];
  }
});





/* ------------------------------------------------------------------------- */
/* PUREGARAGE Onboarding i18n — full 5-language coverage.                     */
/* Namespaces the onboarding gateway (3 roles) with role cards + form field   */
/* labels + common actions + GDPR + success/error copy.                       */
/* ------------------------------------------------------------------------- */
const PUREGARAGE_ONBOARDING_I18N = {
  ua: {
    eyebrow: "Приєднатися",
    title: "Оберіть свій шлях у PUREGARAGE.",
    desc: "Три ролі. Одна екосистема. Оберіть, як саме ви хочете долучитись.",
    roles: {
      driver: {
        title: "Водій",
        subtitle: "Для власників авто, які прагнуть найрозумнішого досвіду володіння.",
        cta: "Приєднатись як Водій",
      },
      detailer: {
        title: "Детейлер",
        subtitle: "Для професійних детейлінг-студій, які хочуть стати верифікованими партнерами.",
        cta: "Подати заявку як Детейлер",
      },
      partner: {
        title: "Партнер",
        subtitle: "Для авто-брендів, дилерів, страхових компаній, IT-провайдерів та стратегічних партнерів.",
        cta: "Стати Партнером",
      },
    },
    common: {
      back: "Повернутися до ролей",
      submit: "Надіслати заявку",
      sending: "Надсилаємо…",
      successTitle: "Дякуємо — ви в списку.",
      successBody: "Ми зв'яжемось з вами найближчим часом.",
      error: "Не вдалось надіслати. Спробуйте ще раз.",
      optional: "не обов'язково",
      required: "*",
      gdpr: "Я погоджуюсь з обробкою моїх даних відповідно до Політики конфіденційності.",
    },
    driver: {
      fields: {
        firstName: "Ім'я",
        lastName: "Прізвище",
        email: "Email",
        country: "Країна",
        city: "Місто",
        vehicleBrand: "Марка авто",
        vehicleModel: "Модель авто",
        vehicleYear: "Рік випуску",
        primaryInterest: "Основний інтерес",
        primaryInterestPlaceholder: "напр. Історія обслуговування, Прем'ї, AI-догляд",
        notes: "Коментар",
        notesPlaceholder: "Розкажіть щось про свій автомобіль…",
      },
    },
    detailer: {
      fields: {
        businessName: "Назва компанії",
        contactName: "Контактна особа",
        email: "Email",
        phone: "Телефон",
        country: "Країна",
        city: "Місто",
        website: "Вебсайт",
        instagram: "Instagram",
        businessType: "Тип бізнесу",
        businessTypePlaceholder: "Studio / Mobile / Hybrid",
        yearsExperience: "Років досвіду",
        studioOrMobile: "Стаціонарно чи виїзд",
        services: "Послуги",
        servicesPlaceholder: "напр. Керамічне покриття, Хімчистка, PPF",
        portfolio: "Портфоліо",
        portfolioPlaceholder: "Посилання на роботи",
        notes: "Коментар",
      },
    },
    partner: {
      fields: {
        company: "Компанія",
        contactPerson: "Контактна особа",
        email: "Робочий email",
        phone: "Телефон",
        country: "Країна",
        website: "Вебсайт",
        industry: "Індустрія",
        industryPlaceholder: "напр. Дилер, Страхування, ПЗ",
        companySize: "Розмір компанії",
        companySizePlaceholder: "1-10 / 11-50 / 51-200 / 200+",
        partnershipType: "Тип партнерства",
        partnershipTypePlaceholder: "Бренд / Дилер / Страхова / ПЗ / Стратегічний",
        proposal: "Ваша пропозиція",
        proposalPlaceholder: "Коротко опишіть ідею співпраці",
        notes: "Додатковий коментар",
      },
    },
  },
  de: {
    eyebrow: "Beitreten",
    title: "Wählen Sie Ihren Weg in PUREGARAGE.",
    desc: "Drei Rollen. Ein Ökosystem. Wählen Sie, wie Sie einsteigen möchten.",
    roles: {
      driver: {
        title: "Fahrer",
        subtitle: "Für Fahrzeugbesitzer, die das intelligenteste Ownership-Erlebnis wollen.",
        cta: "Als Fahrer beitreten",
      },
      detailer: {
        title: "Detailer",
        subtitle: "Für professionelle Detailing-Studios, die verifizierte Partner werden möchten.",
        cta: "Als Detailer bewerben",
      },
      partner: {
        title: "Partner",
        subtitle: "Für Automobilmarken, Händler, Versicherungen, Software-Anbieter und strategische Partner.",
        cta: "Partner werden",
      },
    },
    common: {
      back: "Zurück zur Auswahl",
      submit: "Bewerbung senden",
      sending: "Wird gesendet…",
      successTitle: "Sie sind dabei.",
      successBody: "Wir melden uns in Kürze bei Ihnen.",
      error: "Übermittlung fehlgeschlagen. Bitte erneut versuchen.",
      optional: "optional",
      required: "*",
      gdpr: "Ich willige in die Verarbeitung meiner Daten gemäß der Datenschutzerklärung ein.",
    },
    driver: {
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        country: "Land",
        city: "Stadt",
        vehicleBrand: "Fahrzeugmarke",
        vehicleModel: "Fahrzeugmodell",
        vehicleYear: "Baujahr",
        primaryInterest: "Hauptinteresse",
        primaryInterestPlaceholder: "z. B. Servicehistorie, Prämien, KI-Pflege",
        notes: "Anmerkung",
        notesPlaceholder: "Erzählen Sie uns etwas über Ihr Fahrzeug…",
      },
    },
    detailer: {
      fields: {
        businessName: "Firmenname",
        contactName: "Ansprechpartner",
        email: "E-Mail",
        phone: "Telefon",
        country: "Land",
        city: "Stadt",
        website: "Website",
        instagram: "Instagram",
        businessType: "Geschäftsart",
        businessTypePlaceholder: "Studio / Mobil / Hybrid",
        yearsExperience: "Jahre Erfahrung",
        studioOrMobile: "Studio oder mobil",
        services: "Leistungen",
        servicesPlaceholder: "z. B. Keramikversiegelung, Innenraum, PPF",
        portfolio: "Portfolio",
        portfolioPlaceholder: "Link zu Referenzen",
        notes: "Anmerkung",
      },
    },
    partner: {
      fields: {
        company: "Unternehmen",
        contactPerson: "Ansprechpartner",
        email: "Business-E-Mail",
        phone: "Telefon",
        country: "Land",
        website: "Website",
        industry: "Branche",
        industryPlaceholder: "z. B. Händler, Versicherung, Software",
        companySize: "Unternehmensgröße",
        companySizePlaceholder: "1-10 / 11-50 / 51-200 / 200+",
        partnershipType: "Partnerschaftstyp",
        partnershipTypePlaceholder: "Marke / Händler / Versicherung / Software / Strategisch",
        proposal: "Ihr Vorschlag",
        proposalPlaceholder: "Beschreiben Sie kurz die Idee der Zusammenarbeit",
        notes: "Zusätzliche Anmerkung",
      },
    },
  },
  en: {
    eyebrow: "Join",
    title: "Choose your path into PUREGARAGE.",
    desc: "Three roles. One ecosystem. Choose how you want to come on board.",
    roles: {
      driver: {
        title: "Driver",
        subtitle: "For vehicle owners who want the smartest ownership experience.",
        cta: "Join as Driver",
      },
      detailer: {
        title: "Detailer",
        subtitle: "For professional detailing studios who want to become verified partners.",
        cta: "Apply as Detailer",
      },
      partner: {
        title: "Partner",
        subtitle: "For automotive brands, dealerships, insurance companies, software providers and strategic partners.",
        cta: "Become a Partner",
      },
    },
    common: {
      back: "Back to roles",
      submit: "Submit application",
      sending: "Sending…",
      successTitle: "You're in.",
      successBody: "We'll be in touch shortly.",
      error: "Submission failed. Please try again.",
      optional: "optional",
      required: "*",
      gdpr: "I consent to processing of my data according to the Privacy Policy.",
    },
    driver: {
      fields: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        country: "Country",
        city: "City",
        vehicleBrand: "Vehicle brand",
        vehicleModel: "Vehicle model",
        vehicleYear: "Vehicle year",
        primaryInterest: "Primary interest",
        primaryInterestPlaceholder: "e.g. Service history, Rewards, AI care",
        notes: "Notes",
        notesPlaceholder: "Tell us something about your vehicle…",
      },
    },
    detailer: {
      fields: {
        businessName: "Business name",
        contactName: "Contact name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        city: "City",
        website: "Website",
        instagram: "Instagram",
        businessType: "Business type",
        businessTypePlaceholder: "Studio / Mobile / Hybrid",
        yearsExperience: "Years of experience",
        studioOrMobile: "Studio or mobile",
        services: "Services",
        servicesPlaceholder: "e.g. Ceramic coating, Interior, PPF",
        portfolio: "Portfolio",
        portfolioPlaceholder: "Link to your work",
        notes: "Notes",
      },
    },
    partner: {
      fields: {
        company: "Company",
        contactPerson: "Contact person",
        email: "Business email",
        phone: "Phone",
        country: "Country",
        website: "Website",
        industry: "Industry",
        industryPlaceholder: "e.g. Dealership, Insurance, Software",
        companySize: "Company size",
        companySizePlaceholder: "1-10 / 11-50 / 51-200 / 200+",
        partnershipType: "Partnership type",
        partnershipTypePlaceholder: "Brand / Dealer / Insurance / Software / Strategic",
        proposal: "Your proposal",
        proposalPlaceholder: "Briefly describe the collaboration idea",
        notes: "Additional notes",
      },
    },
  },
  pl: {
    eyebrow: "Dołącz",
    title: "Wybierz swoją drogę do PUREGARAGE.",
    desc: "Trzy role. Jeden ekosystem. Wybierz, jak chcesz dołączyć.",
    roles: {
      driver: {
        title: "Kierowca",
        subtitle: "Dla właścicieli pojazdów, którzy chcą najmądrzejszego doświadczenia własnościowego.",
        cta: "Dołącz jako Kierowca",
      },
      detailer: {
        title: "Detailer",
        subtitle: "Dla profesjonalnych studiów detailingu, które chcą zostać zweryfikowanymi partnerami.",
        cta: "Aplikuj jako Detailer",
      },
      partner: {
        title: "Partner",
        subtitle: "Dla marek motoryzacyjnych, dealerów, ubezpieczycieli, dostawców oprogramowania i partnerów strategicznych.",
        cta: "Zostań Partnerem",
      },
    },
    common: {
      back: "Powrót do ról",
      submit: "Wyślij zgłoszenie",
      sending: "Wysyłanie…",
      successTitle: "Jesteś w środku.",
      successBody: "Skontaktujemy się z Tobą wkrótce.",
      error: "Wysyłka nieudana. Spróbuj ponownie.",
      optional: "opcjonalnie",
      required: "*",
      gdpr: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z Polityką prywatności.",
    },
    driver: {
      fields: {
        firstName: "Imię",
        lastName: "Nazwisko",
        email: "E-mail",
        country: "Kraj",
        city: "Miasto",
        vehicleBrand: "Marka pojazdu",
        vehicleModel: "Model pojazdu",
        vehicleYear: "Rok produkcji",
        primaryInterest: "Główne zainteresowanie",
        primaryInterestPlaceholder: "np. Historia serwisowa, Nagrody, Opieka AI",
        notes: "Notatki",
        notesPlaceholder: "Opowiedz coś o swoim pojeździe…",
      },
    },
    detailer: {
      fields: {
        businessName: "Nazwa firmy",
        contactName: "Osoba kontaktowa",
        email: "E-mail",
        phone: "Telefon",
        country: "Kraj",
        city: "Miasto",
        website: "Strona www",
        instagram: "Instagram",
        businessType: "Rodzaj działalności",
        businessTypePlaceholder: "Studio / Mobilne / Hybrydowe",
        yearsExperience: "Lata doświadczenia",
        studioOrMobile: "Studio czy mobilne",
        services: "Usługi",
        servicesPlaceholder: "np. Powłoka ceramiczna, Wnętrze, PPF",
        portfolio: "Portfolio",
        portfolioPlaceholder: "Link do prac",
        notes: "Notatki",
      },
    },
    partner: {
      fields: {
        company: "Firma",
        contactPerson: "Osoba kontaktowa",
        email: "E-mail służbowy",
        phone: "Telefon",
        country: "Kraj",
        website: "Strona www",
        industry: "Branża",
        industryPlaceholder: "np. Dealer, Ubezpieczenia, Software",
        companySize: "Wielkość firmy",
        companySizePlaceholder: "1-10 / 11-50 / 51-200 / 200+",
        partnershipType: "Rodzaj partnerstwa",
        partnershipTypePlaceholder: "Marka / Dealer / Ubezpieczenia / Software / Strategiczne",
        proposal: "Twoja propozycja",
        proposalPlaceholder: "Krótko opisz pomysł współpracy",
        notes: "Dodatkowe notatki",
      },
    },
  },
  ru: {
    eyebrow: "Присоединиться",
    title: "Выберите свой путь в PUREGARAGE.",
    desc: "Три роли. Одна экосистема. Выберите, как вы хотите присоединиться.",
    roles: {
      driver: {
        title: "Водитель",
        subtitle: "Для владельцев авто, которые хотят самый умный опыт владения.",
        cta: "Присоединиться как Водитель",
      },
      detailer: {
        title: "Детейлер",
        subtitle: "Для профессиональных детейлинг-студий, которые хотят стать верифицированными партнёрами.",
        cta: "Подать заявку как Детейлер",
      },
      partner: {
        title: "Партнёр",
        subtitle: "Для автобрендов, дилеров, страховых компаний, разработчиков ПО и стратегических партнёров.",
        cta: "Стать Партнёром",
      },
    },
    common: {
      back: "Вернуться к ролям",
      submit: "Отправить заявку",
      sending: "Отправляем…",
      successTitle: "Вы в списке.",
      successBody: "Мы свяжемся с вами в ближайшее время.",
      error: "Не удалось отправить. Попробуйте ещё раз.",
      optional: "необязательно",
      required: "*",
      gdpr: "Я согласен на обработку моих данных согласно Политике конфиденциальности.",
    },
    driver: {
      fields: {
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Email",
        country: "Страна",
        city: "Город",
        vehicleBrand: "Марка авто",
        vehicleModel: "Модель авто",
        vehicleYear: "Год выпуска",
        primaryInterest: "Основной интерес",
        primaryInterestPlaceholder: "напр. История сервиса, Награды, AI-уход",
        notes: "Комментарий",
        notesPlaceholder: "Расскажите что-нибудь о вашем автомобиле…",
      },
    },
    detailer: {
      fields: {
        businessName: "Название компании",
        contactName: "Контактное лицо",
        email: "Email",
        phone: "Телефон",
        country: "Страна",
        city: "Город",
        website: "Веб-сайт",
        instagram: "Instagram",
        businessType: "Тип бизнеса",
        businessTypePlaceholder: "Студия / Мобильный / Гибрид",
        yearsExperience: "Лет опыта",
        studioOrMobile: "Стационарно или выезд",
        services: "Услуги",
        servicesPlaceholder: "напр. Керамика, Химчистка, PPF",
        portfolio: "Портфолио",
        portfolioPlaceholder: "Ссылка на работы",
        notes: "Комментарий",
      },
    },
    partner: {
      fields: {
        company: "Компания",
        contactPerson: "Контактное лицо",
        email: "Рабочий email",
        phone: "Телефон",
        country: "Страна",
        website: "Веб-сайт",
        industry: "Индустрия",
        industryPlaceholder: "напр. Дилер, Страхование, ПО",
        companySize: "Размер компании",
        companySizePlaceholder: "1-10 / 11-50 / 51-200 / 200+",
        partnershipType: "Тип партнёрства",
        partnershipTypePlaceholder: "Бренд / Дилер / Страховая / ПО / Стратегический",
        proposal: "Ваше предложение",
        proposalPlaceholder: "Кратко опишите идею сотрудничества",
        notes: "Дополнительный комментарий",
      },
    },
  },
};

Object.keys(PUREGARAGE_ONBOARDING_I18N).forEach((code) => {
  if (translations[code] && translations[code].puregarage) {
    translations[code].puregarage.onboarding = PUREGARAGE_ONBOARDING_I18N[code];
  }
});
